// @ts-ignore
import {
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  OnDestroy,
  AfterViewInit,
  ChangeDetectorRef,
  TemplateRef,
  Renderer2
} from '@angular/core';
import {DigitalCertificateService} from 'src/app/core/services/digital-certificate.service';
import {DomSanitizer} from '@angular/platform-browser';
// @ts-ignore
import {NzUploadFile} from 'ng-zorro-antd/upload';
import {ToastrService} from 'ngx-toastr';
import {Message} from 'src/app/core/class/message';
import {CommonService} from 'src/app/core/services/common.service';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {SignDocumentService} from 'src/app/core/services/sign-document.service';
import {MatDialog} from '@angular/material/dialog';
import {DocumentService} from 'src/app/core/services/document.service';
import {CanvasService} from 'src/app/core/services/canvas.service';
import {CanvasComponent} from 'src/app/shared/components/canvas/canvas.component';
import {AnonymousSignService} from '../../../core/services/anonymous-sign.service';
import {first, map, switchMap, tap} from 'rxjs/operators';
import {BehaviorSubject, forkJoin, Observable, of, Subscription} from 'rxjs';
import {ResponsiveService} from '../../../core/services/responsive.service';
import {SCREEN_SIZE} from '../../../core/constants/screen-size';
import {SignPositionTypes} from '../../../core/constants/signposition-types';
import {SignDocumentComponent} from '../../dashboard/home/home-enterprise/document/sign-document/sign-document.component';
import {Common} from '../../../core/constants/common';
import {ErrorCode} from '../../../core/constants/error-code';
import {ConfirmSignOtpWithImageComponent} from '../../dashboard/home/home-enterprise/document/confirm-sign-otp-with-image/confirm-sign-otp-with-image.component';
import {EnumContractEnterpriseStatus, EnumSignMethod} from "../../../core/constants/contract";
import {DeviceDetectorService} from 'ngx-device-detector';
import {SigningDialogComponent} from 'src/app/modules/dashboard/home/home-enterprise/document/signing-dialog/signing-dialog.component';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import {ApiService} from 'src/app/core/services/api.service';
import {AlertComponent} from 'src/app/shared/components/alert/alert.component';
import {CertificateTypeID} from 'src/app/core/constants/common';
import {EkycCameraComponent} from '../../dashboard/home/home-enterprise/document/ekyc/ekyc-camera/ekyc-camera.component';
import {ConfirmResignEkycSupportComponent} from '../../dashboard/home/home-enterprise/document/confirm-resign-ekyc-support/confirm-resign-ekyc-support.component';
import {NotifyWarningComponent} from 'src/app/shared/components/notify-warning/notify-warning.component';
import {EnterpriseTypes} from 'src/app/core/constants/enterprise-type';
import {CloudCaProvider} from "../../dashboard/home/home-enterprise/digital-certificate/add-digital-certificate/add-digital-certificate.component";
import * as _ from 'lodash';
import * as uuid from 'uuid';
import {EnvService} from 'src/app/core/services/env.service';
import {
  ContentPosition,
  SignatureConfig
} from "../../dashboard/home/home-enterprise/document/sign-flow-document/signature-config.model";
import {
  imageConfigRenderId,
  imageConfigViewScaleId, ImageSignConfigComponent, imageConfigFormPreviewId, transformContentPositionValue
} from "../../dashboard/home/home-enterprise/document/sign-flow-document/image-sign-config/image-sign-config.component";
import * as htmlToImage from "html-to-image";
import {FormControl} from '@angular/forms';
import {ImageGenerateService} from 'src/app/core/services/image-generate.service';
import {ConfirmFailComponent} from '../../kyc/confirm-fail/confirm-fail.component';
import {KycEnterpriceService} from '../../../core/services/kyc-enterprice.service';

declare var $: any;

declare function initPluginCertificate(comp: any): any;

declare function signHash(comp, hashBase64): any;

declare function initPlugin(comp): any;

declare function initPluginCertificateNormal(comp: any): any;

declare function anonymousSignHashAsyncNew(comp, hashBase64, sessionId, serialNumber): any;

@Component({
  selector: 'app-anonymous-sign-flow-v2',
  templateUrl: './anonymous-sign-flow-v2.component.html',
  styleUrls: ['./anonymous-sign-flow-v2.component.scss']
})
export class AnonymousSignFlowV2Component implements OnInit, OnDestroy, AfterViewInit {
  // START DECLARE VARIABLE
  @BlockUI() blockUI: NgBlockUI;
  language: string;
  blockUIStop: boolean = false;
  sessionId: string;

  // variable layout
  isFullviewPdf: boolean = false;
  subcribeViewLandscape: Subscription;
  isViewLandscape: boolean = false;
  BASE_URL: string = '';
  public tempEnterprise: any;

  // variable breakpoint
  mediaBreakpoint: any;
  subscribeMediaBreakPointService: Subscription;
  public signMethod = {
    SIGN_SERVER: 0,
    SIGN_USB_TOKEN: 1,
    SIGN_SIM_CA: 2,
    SIGN_OTP: 3,
    SIGN_CLOUD_CA: 10,
    // SIGN_HSM: 4,
    // SIGN_IMAGE: 5,
    SIGN_NO_CERT: 6,
    VNEID: 12,
  };
  // variable dialog
  dialogRef: any;
  isSetUpConfig: boolean = false;

  // variable contract
  document: any;
  contractId: string = '';
  enterpriseId: string = '';
  // Fix race condition: tách biệt fileUpload theo từng tab
  activeImageSource: 'default' | 'upload' | 'draw' = 'default';
  fileUploadDefault: File;   // Tab 0: Ảnh mặc định hệ thống
  fileUploadUpload: File;    // Tab 1: Ảnh tải lên
  fileUploadDraw: File;      // Tab 2: Vẽ chữ ký
  // fileUpload: dùng cho UI (preview, disable button) - giữ nguyên
  fileUpload: File;
  scopeType: number = 0;
  private hashKey: string;
  private tenantId: string;
  private contractIdAndContractEnterpriseIdEncode: string = null;
  serviceTypeData: any = null;
  isOutOfSmsMoney: boolean = false;
  isError: boolean = false;
  contractSignEntityList: any[] = [];


  // variable router
  routeLink: string = '';
  DEFAULT_ROUTER_ON_BACK_LINK = '/home-enterprise/search-document/';
  DEFAULT_RECEIVER_ROUTER_ON_BACK_LINK = '/home-enterprise/search-document-receive/';
  SIGN_WAIT_ROUTER_ON_BACK_LINK = '/home-enterprise/search-document-sign';
  APPOVAL_WAIT_ROUTER_ON_BACK_LINK = '/home-enterprise/search-approval-waiting-document';
  INITIAL_WAIT_ROUTER_ON_BACK_LINK = '/home-enterprise/search-initial-waiting-document';
  MY_DOCUMENT_ROUTER_ON_BACK_LINK = '/home-enterprise/search-my-created-document';

  // variable pre page
  goFrom: string = '';
  signPage: string = '';
  page: string = '';
  pageSize: string = '';
  enterprise: string = '';
  documentTypeSearch: string = '';
  nameOrCode: string = '';
  status: string = '';
  serviceType: string = '';
  taxCode: string = '';
  createdUser: string = '';
  createdTimeFrom: string = '';
  createdTimeTo: string = '';
  finishDateFrom: string = '';
  finishDateTo: string = '';
  sortColumn: string = '';
  sortDirection: string = '';
  customerName: string = '';
  maxLengthPhone = Common.MAX_LENGTH_PHONE;

  // variable permission
  permissions: any[];
  isHasPermissionAddCert: boolean = false;
  isHsmPermission: boolean = false;
  isNotAttestedUser: boolean = false;

  // variable EKYC
  @ViewChild(EkycCameraComponent, {static: false}) ekyc;
  supportEkyc: boolean = false;
  isShowEKYC: boolean = false;
  ekycSupportConfig: number = null;
  isStillQuantityEkyc: boolean = false;
  isQuantityEkyc: boolean = false;
  isQuantityAdvancedEkyc: boolean = false;
  enterpriseInfo: any;
  isPassport: boolean = false;
  templateRefEKYC: TemplateRef<any>;
  isShowWebcam: boolean = false;
  // variable sign method
  showCheckVerifySubject: boolean = false;
  checkPersonalCustomer: any;
  anonymousListEnterprise: any;
  checkPersonalVerify = false;
  identifyStatus: any;
  isVerifySubjectForLoad: any;
  identifyStatusForLoad: any;
  linkUrl: any;
  entTypeAnonymus: any = localStorage.getItem('entTypeAnonymus')
  isBuyService: boolean = false
  defaultImageConfigs: any;
  // KH đã có cấu hình chữ ký lưu từ lần ký trước -> ưu tiên hơn suggest TH2
  hasSavedUserConfig: boolean = false;
  private linkDownSignPlugin(os?: string) {
    let OSName = os;
    if (typeof (os) === 'undefined') {
      if (navigator.appVersion.indexOf("Win") != -1) OSName = "WINDOWS";
      if (navigator.appVersion.indexOf("Mac") != -1) OSName = "MACOS";
      if (navigator.appVersion.indexOf("X11") != -1) OSName = "UNIX";
      if (navigator.appVersion.indexOf("Linux") != -1) OSName = "LINUX";
    }
    return this.apiService.getBaseUrl() + `/file/download-last-version?os=${OSName}&typeFile=${OSName === "WINDOWS" ? 'exe' : OSName === "LINUX" ? 'deb' : 'pkg'}`;
  };

  errorFormatTypeFile: boolean = false;
  maxSizeInput: boolean = false;
  allowOtp: boolean = false;
  allowImage: boolean = false;
  checkCertNumber: boolean = false;
  checkName: boolean = false;
  checkOtp: boolean = false;
  imageCertificates: any[] = [];
  typeCertificate: number = 2;
  isCertificateDefault: boolean = false;
  typeCertificateCheck: boolean = false;
  isCertificateSupport: boolean = false;
  selectedCert: any = {
    serialNumber: '',
    phoneNumber: undefined,
    typeCertificate: undefined,
    id: undefined,
    idDetail: undefined,
    imageUrl: null,
    issuedTo: '',
    certificateName: '',
    cloudCaUserId: '',
    taxCode: '',
    email: '',
    issueDN: undefined
  };
  usbTokenCertificate = {
    certRawdata: '',
    taxCode: '',
    serialNumber: '',
    issuedTo: '',
    issuedBy: '',
    expireDate: new Date(),
    activeDate: new Date(),
    fileName: '',
    certificateName: '',
    distinguishedName: '',
    email: ''
  };
  selectedSimCaCert = {
    serialNumber: '',
    phoneNumber: undefined,
    typeCertificate: undefined,
    id: undefined,
    idDetail: undefined,
    imageUrl: null,
    issuedTo: '',
    certificateName: '',
    cloudCaUserId: '',
    taxCode: '',
    email: ''
  };
  selectedCloudCaCert = {
    serialNumber: '',
    phoneNumber: undefined,
    typeCertificate: undefined,
    id: undefined,
    idDetail: undefined,
    imageUrl: null,
    issuedTo: '',
    certificateName: '',
    cloudCaUserId: '',
    taxCode: '',
    email: ''
  };

  selectedVNeIDCert = {
    serialNumber: '',
    phoneNumber: undefined,
    typeCertificate: undefined,
    id: undefined,
    idDetail: undefined,
    imageUrl: null,
    issuedTo: '',
    certificateName: '',
    cloudCaUserId: '',
    taxCode: '',
    email: ''
  };
  enumSignMethod = EnumSignMethod;
  certificateTypeID = CertificateTypeID;
  signDataValidate: any;
  otpPhoneNumber: string = '';
  lstCloudCaProvider: CloudCaProvider[];
  providerName: string = '';
  providerId: number;
  otpPhoneNumberMaxLength = Common.MAX_LENGTH_PHONE;
  otpPhoneNumberPattern = Common.PHONE_PATTERN2;
  simCaPhoneNumber: string = '';
  listOfDataSimCa: any[] = [];
  cloudCaDataSource: any[] = [];
  cloudCaUsername: string;
  VNeIDDataSource: any[] = [];
  VNeIDDataUser: string = '';
  VNeIDTransactionCode: any;
  currentPhone: string;
  certData: string;
  checkAgree: boolean = false;
  isVerifySubject: any = null;
  checkVerify: boolean;
  isSignVNeID: boolean = false;

  // variable signImage and Canvas
  // @ts-ignore
  @ViewChild(ImageSignConfigComponent) imageSignConfig: ImageSignConfigComponent;
  // @ts-ignore
  @ViewChild('SignImageConfig', {static: true}) domRenderImage: ElementRef;
  // @ts-ignore
  @ViewChild(CanvasComponent) canvasComponent;
  @Input() public canvasWidth = 660;
  @Input() public canvasHeight = 300;
  enterpriseName: string = '';
  beforeUpload = this.commonService.beforeUploadImage;
  loading: boolean;
  avatarUrl: string = '';
  signConfig: SignatureConfig = SignatureConfig.build();
  systemImageSign: boolean = false; // Biến này check có dùng chân ký mặc định k
  isSelectDrawImage: boolean = false;
  isUploadImage: boolean = false;
  indexSelect: number = 0;
  imageUrlPreview: any;
  validateCertificateSign: any = {
    certificateNo: '',
    representDocumentNumber: '',
    taxCode: ''
  };

  signatureImageUpload: string = '';
  signatureImageDraw: string = '';
  signatureImageDefault: string = '';
  signatureFileDefault: any;
  customerImagesConfig: string[] = [];
  isCustomer: boolean = false;


  // variable userSign Or enterpriseSign
  isSignDigitalCertificate: boolean = false;
  roleApprover: string = '';
  listEnterprise: any;
  enterpriseSignIdInFlow;
  isPersonal: boolean = false;

  // variable PDF
  textLayerDiv: any;
  zoomLevel: number = 100;
  isShowSidebarButton = true;
  isAllowSelectSignPosition: boolean = true; // Biến này để check xem đang trong luồng đặt chân ký k
  isSelectedPosition = new BehaviorSubject<boolean>(true); // Biến này để check xem đã đặt chân ký hay chưa
  activeFile: number = 0;
  pdfSrc: any;
  pageCurrent: number = 1;
  authorization: any;
  fileError: string[] = [];
  listPdfSrc: any;
  pageIndex: number = 0;
  stampWrapper: HTMLDivElement;
  widthImageRender: number = 0;
  heightImageRender: number = 0;
  widthRectangle: number = 300; // width khung ký
  heightRectangle: number = 136; // height khung ký
  imagePreviewWidth: number = 0;
  imagePreviewHeight: number = 0;
  isGotoSignpage: boolean = true;
  isPersonalCustomer = false;

  // variable Sign
  canMoveAndResize: boolean = false;
  isShowImage: boolean = true;
  onlyDigital: boolean = false;
  signPosition: any[];
  signPositionTypes = SignPositionTypes;
  imageData: any = [];
  signImages: any = [];
  saveImageData: any = [];
  sign: any;
  signXMCT: any;
  signProcessing: any[] = [];
  signTransactionId: any;
  errorStatus: string;
  signError: string = null;
  isCancel: boolean = false;
  isCallDone: boolean = false;
  processingId: string = null;
  userCancel: boolean = false;
  success: boolean;
  signingInteval: any;
  openSigningDialog: boolean = false;
  noteControl = new FormControl('');
  isSetUpSignFlow: boolean = false;
  // variable button
  @ViewChild('navigation', {static: false}) navigation: ElementRef;
  isDisableSignBtn: boolean = true;
  signConfigPhoneNumber: boolean;

  // END DECLARE VARIABLE

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    public commonService: CommonService,
    public message: Message,
    private toastr: ToastrService,
    private digitalCertificateService: DigitalCertificateService,
    private sanitizer: DomSanitizer,
    private translateService: TranslateService,
    private signDocumentService: SignDocumentService,
    private documentService: DocumentService,
    private canvasService: CanvasService,
    private anonymousSignService: AnonymousSignService,
    private responsiveService: ResponsiveService,
    public deviceService: DeviceDetectorService,
    private apiService: ApiService,
    private env: EnvService,
    private cd: ChangeDetectorRef,
    private renderer: Renderer2,
    private kycService: KycEnterpriceService,
    private imageGenerateService: ImageGenerateService
  ) {
    this.isNotAttestedUser = this.commonService.checkEnterpriseAnonymusType();
    this.BASE_URL = env.is_private_app ? env.private_api_endpoint : env.public_api_endpoint;
    this.BASE_URL += '/anonymous/file-detail-no-file-path';
    const listEnterprise = JSON.parse(localStorage.getItem('AnonymousListEnterprise'));
    this.tempEnterprise = JSON.parse(localStorage.getItem('tempEnterprise'));
    const enterpriseChoose = listEnterprise.enterpriseSign.filter(enter => enter.status === EnumContractEnterpriseStatus.PROCESSING || enter.status === EnumContractEnterpriseStatus.WAIT_SETUP_FLOW);
    this.enterpriseId = localStorage.getItem('enterpriseId');
    if (enterpriseChoose && enterpriseChoose.length) {
      if (listEnterprise.enterpriseSignIdInFlow) {
        enterpriseChoose.map(enter => {
          if (enter.enterpriseId === listEnterprise.enterpriseSignIdInFlow || enter.customerId === listEnterprise.enterpriseSignIdInFlow) {
            this.enterpriseName = enter.enterpriseName;
            if (!enter.isCreatedSide) {
              this.isCustomer = true;
            }
          }
        });
      } else {
        this.enterpriseName = enterpriseChoose[0].enterpriseName || localStorage.getItem('fullName');
      }
    } else {
      this.enterpriseName = localStorage.getItem('fullName');
    }

    const enterpriseProcessing = listEnterprise.enterpriseSign.find(enter => enter.isCurrent);
    this.canMoveAndResize = enterpriseProcessing && enterpriseProcessing.signConfig ? JSON.parse(enterpriseProcessing.signConfig).resize : false;
    this.language = localStorage.getItem('__language') || 'vi';
    this.isSetUpSignFlow = JSON.parse(localStorage.getItem('isSetUpSignFlow'))
  }


  ngOnInit() {
    this.initData();
    this.anonymousListEnterprise = JSON.parse(localStorage.getItem('AnonymousListEnterprise'));
    this.checkPersonalCustomer = this.anonymousListEnterprise.enterpriseSign.filter(x => (x.customerId == this.anonymousListEnterprise.enterpriseSignIdInFlow));
    if (this.checkPersonalCustomer[0] && this.checkPersonalCustomer[0].enterpriseType == 10000) {
      this.checkPersonalVerify = true;
      console.log("eeeeeee", this.checkPersonalVerify)
    }
  }

  onchangeCert() {
    if (this.isPersonal) {
      if (this.allowOtp) {
        this.typeCertificate = this.enumSignMethod.SIGN_OTP;
        this.onChangeSelectCertificateType(this.enumSignMethod.SIGN_OTP);
      } else {
        this.typeCertificate = this.enumSignMethod.CLOUD_CA;
        this.onChangeSelectCertificateType(this.enumSignMethod.CLOUD_CA);
      }
    } else {
      if(this.allowOtp && this.entTypeAnonymus == '2' && !this.isBuyService && !(this.isSignDigitalCertificate && !this.isShowImage)){
        this.typeCertificate = this.enumSignMethod.SIGN_OTP;
        this.onChangeSelectCertificateType(this.enumSignMethod.SIGN_OTP);
      } else {
        this.typeCertificate = this.enumSignMethod.CLOUD_CA;
        this.onChangeSelectCertificateType(this.enumSignMethod.CLOUD_CA);
      }
    }
  }

  ngAfterViewInit() {

    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          switch (this.mediaBreakpoint) {
            case SCREEN_SIZE.XS:
              this.canvasWidth = 320;
              this.canvasHeight = Math.round(320 * (136 / 300));
              break;
            case SCREEN_SIZE.SM:
              this.canvasWidth = 345;
              this.canvasHeight = Math.round(345 * (136 / 300));
              break;
            case SCREEN_SIZE.MD:
              this.canvasWidth = 450;
              break;
            case SCREEN_SIZE.XL:
              this.canvasWidth = 470;
              break;
            default:
              this.canvasWidth = 660;
              break;
          }
        }
      }
    );

    this.subcribeViewLandscape = this.responsiveService.getView().subscribe(isLandscape => {
      this.isViewLandscape = isLandscape;
    });


    setTimeout(() => {
      document.body.scrollTop = 0;
    }, 600);
  }

  // --------------------- START FUNCTION --------------------------

  // fn InitData
  initData() {
    this.route.paramMap.subscribe(params => {
      this.hashKey = params.get('hashKey');
      this.tenantId = params.get('tenantId');
      this.contractIdAndContractEnterpriseIdEncode = params.get('contractIdAndContractEnterpriseIdEncode') ? params.get('contractIdAndContractEnterpriseIdEncode') : null;
    });
    this.setLanguage();
    this.loadData();
    this.documentService.getApparamInfo({code: 'enable_sign_vneid'}).subscribe(res => {
      if(res.data){
        this.isSignVNeID = JSON.parse(res.data.value) && res.data.status;
      }
    })
  }

  loadData() {
    this.signDataValidate = JSON.parse(localStorage.getItem('SignDataValidate') || '{}');
    this.otpPhoneNumber = this.signDataValidate.phoneNumber;
    this.signConfig.phoneNumber.value = this.otpPhoneNumber;

    if (+this.signDataValidate.certificateId === CertificateTypeID.HO_CHIEU) {
      this.isPassport = true;
    } else if (+this.signDataValidate.certificateId === CertificateTypeID.CCCD || +this.signDataValidate.certificateId === CertificateTypeID.CMTND) {
      this.isPassport = false;
    }

    if (+this.signDataValidate.certificateId === CertificateTypeID.CCCD
      || +this.signDataValidate.certificateId === CertificateTypeID.CMTND
      || +this.signDataValidate.certificateId === CertificateTypeID.HO_CHIEU) {
      this.isCertificateSupport = true;
    }
    this.listEnterprise = JSON.parse(localStorage.getItem('AnonymousListEnterprise')).enterpriseSign;
    this.enterpriseSignIdInFlow = JSON.parse(localStorage.getItem('AnonymousListEnterprise')).enterpriseSignIdInFlow;
    this.listEnterprise.map(enter => {
      // trạng thái đang xử lý
      if ((enter.status === EnumContractEnterpriseStatus.PROCESSING || enter.status === EnumContractEnterpriseStatus.WAIT_SETUP_FLOW) && enter.isCurrent) {
        // Luồng KCT không có enterpriseId thay bằng customerId
        if (
          enter.enterpriseId === JSON.parse(localStorage.getItem('AnonymousListEnterprise')).enterpriseSignIdInFlow ||
          enter.customerId === JSON.parse(localStorage.getItem('AnonymousListEnterprise')).enterpriseSignIdInFlow
        ) {
          // type = 2 là khách hàng cá nhân, type !=2 thì không hiển thị OTP và ký ảnh
          if (enter.enterpriseType === EnterpriseTypes.PERSONAL) {
            this.isPersonal = true;
          }
        }
      }
    });

    this.signDocumentService.openSigningDialog.subscribe(rs => {
      this.openSigningDialog = rs;
    });

    this.documentService.contractInfo.subscribe(contract => {
      if (!contract) {
        this.getDocumentById();
      } else {
        this.document = contract;
        this.serviceTypeData = this.documentService.serviceTypeSource.getValue();
        this.loadServiceType();
      }
      // sau khi cos document thì lấy contractEnterpriseName
      this.signConfig.enterpriseName.value = this.document && this.document.contractEnterpriseName;
    });

    this.documentService.contractFilesInfo.subscribe(info => {
      this.listPdfSrc = info;
    });

    this.isSelectedPosition.subscribe((value) => {
      if ((this.isSignDigitalCertificate && this.isShowImage) || !this.isSignDigitalCertificate) {
        this.isDisableSignBtn = value;
      } else {
        this.isDisableSignBtn = false;
      }
    });

    this.canvasService.canvasSignatureImage.subscribe((imgUpload) => {
      if (imgUpload) {
        this.fileUpload = imgUpload;
        this.fileUploadDraw = imgUpload;
      }
    });

    this.canvasService.canvasSignatureImageUrl.subscribe((imgUrl) => {
      this.imageUrlPreview = imgUrl;
      this.signatureImageDraw = imgUrl;
      const img = new Image();
      img.src = this.imageUrlPreview;
      img.onload = () => {
        this.widthImageRender = img.width;
        this.heightImageRender = img.height;
      }
      setTimeout(() => {
        this.reRenderSignature();
      }, 100);
    });

    this.documentService.getImageSignature().subscribe((imageSignature: any) => {
      this.blockUI.start('');
      if (imageSignature && imageSignature.url) {
        this.imageUrlPreview = imageSignature.url;
        const img = new Image();
        img.src = this.imageUrlPreview;
        img.onload = () => {
          this.widthImageRender = img.width;
          this.heightImageRender = img.height;
        }
        setTimeout(() => {
          this.reRenderSignature();
        }, 100);
      }

      if (imageSignature && imageSignature.fileUpload) {
        this.fileUpload = imageSignature.fileUpload;
      }
      setTimeout(() => {
        this.blockUI.stop();
      }, 500);
    });

    const position = JSON.parse(localStorage.getItem('SignPosition'));
    this.signPosition = position;
    if (position && position.length > 0) {
      if (this.signPosition.length === 1 && this.signPosition[0].signType === this.signPositionTypes.DIGITAL) {
        this.onlyDigital = true;
      } else {
        this.onlyDigital = false;
      }
      this.isAllowSelectSignPosition = false;
      this.imageData = position.map((item) => {
        const image = {
          positionX: item.x,
          positionY: item.y,
          pageNumber: item.pageNumber,
          signType: item.signType,
          widthRectangle: item.width,
          heightRectangle: item.height,
          id: item.id,
          zoom: 1,
          fileId: item.fileId,
          signPositionId: item.id,
          contractSignId: undefined
        };
        // Trường hợp tài khoản không chứng thực, kí gửi lên contractSignId
        if (localStorage.getItem('entTypeAnonymus') == '2') image.contractSignId = item.id;

        return image;
      });
    } else {
      this.isAllowSelectSignPosition = true;
      this.signPosition = [];
    }

    this.route.paramMap.subscribe(params => {
      this.hashKey = params.get('hashKey');
      this.tenantId = params.get('tenantId');
      this.contractIdAndContractEnterpriseIdEncode = params.get('contractIdAndContractEnterpriseIdEncode') ? params.get('contractIdAndContractEnterpriseIdEncode') : null;
    });
    this.getDocumentById();

    this.commonService.getAllCloudCaProvider().subscribe(rs => {
      if (rs && rs.data) {
        this.lstCloudCaProvider = rs.data;
        this.providerName = this.lstCloudCaProvider[0].name;
        this.providerId = this.lstCloudCaProvider[0].id;

      }
    });

    this.getUserConfig();
  }

  loadPageAndChangerIsVerifySubject(isVerifySubject: any, identifyStatus?: number) {
    if (isVerifySubject && identifyStatus != 1) {
      const url = window.location.href
      console.log('urrltoload', url)
      for (let i = url.length - 1; i >= 0; i--) {
        if (url[i] === '/') {
          this.linkUrl = url.slice(0, i)
          break
        }
      }
      window.location.href = this.linkUrl;
    }
  }

  // start fn group contract
  getDocumentById() {
    this.anonymousSignService.anonymousGetDetail(this.hashKey, this.tenantId, this.contractIdAndContractEnterpriseIdEncode).subscribe(rs => {
      this.checkDisplayMessageError(rs.code);
      console.log("cmu2", rs)
      this.isVerifySubjectForLoad = rs.data.serviceType.isVerifySubject
      this.identifyStatusForLoad = rs.data.identifyStatus
      this.showCheckVerifySubject = rs.data.serviceType.isVerifySubject;
      this.identifyStatus = rs.data.identifyStatus;
      if (rs.data.serviceType.isVerifySubject == undefined || rs.data.serviceType.isVerifySubject == null) {
        this.showCheckVerifySubject = true;
        this.isVerifySubject = null;
        this.checkVerify = true;
      }

      this.document = rs.data.contractDTO;
      this.isBuyService = rs.data.isBuyService || false;
      if(!this.isBuyService && this.entTypeAnonymus == '2' && rs.data.serviceType.defaultImageConfigs && !this.defaultImageConfigs){
        this.defaultImageConfigs = rs.data.serviceType.defaultImageConfigs;
        this.defaultImageConfigs = this.defaultImageConfigs.reduce((acc,item) => {
          if(item.signatureComponent == 'issuedTo') item.signatureComponent = 'enterpriseName';
          if(item.signatureComponent == 'phone') item.signatureComponent = 'phoneNumber';
          if(item.signatureComponent == 'tick') item.signatureComponent = 'greenTick';
          if(item.signatureComponent == 'dateTime') item.signatureComponent = 'signingTime';
          acc[item.signatureComponent] = {
            isDefault: item.isDefault,
            isRequire: item.isRequire
          };
          return acc;
        },{});
        this.hasDefaultImageConfigs = true;
        this.applyDefaultTypeConfig()
      }
      this.onchangeCert();
      this.signConfig.phoneNumber.enabled = this.signConfigPhoneNumber

      this.customerImagesConfig = (rs.data.serviceType && rs.data.serviceType.customerImagesConfig && rs.data.serviceType.customerImagesConfig.length) ? [...rs.data.serviceType.customerImagesConfig] : ['default_image', 'download_sign_image', 'draw_sign_image'];
      if (!this.isDisplaySignatureTab(1) && !this.isDisplaySignatureTab(2) && this.isDisplaySignatureTab(3)) {
        this.canvasService.setIsSelectSignDraw(true);
      }
      this.isShowImage = this.document.signConfig ? JSON.parse(this.document.signConfig).showImage : true;
      if (rs.data.contractDTO.isSignDigitalCertificate) {
        this.isSignDigitalCertificate = true;
        this.canMoveAndResize = rs.data.contractDTO.signConfig ? JSON.parse(rs.data.contractDTO.signConfig).resize : false;
      } else {
        this.isSignDigitalCertificate = false;
      }
      this.scopeType = this.document.scopeType || 0;
      this.documentService.setContractInfo(rs.data.contractDTO);
      this.documentService.setServiceType(rs.data.serviceType);
      this.serviceTypeData = rs.data.serviceType;
      this.isOutOfSmsMoney = rs.data.isOutOfSmsMoney;
      this.loadServiceType();
      if (rs.data.contractSignEntityList) {
        this.documentService.setSignPosition(rs.data.contractSignEntityList);
      } else {
        this.documentService.setSignPosition(null);
      }
      if (!this.listPdfSrc) {
        for (const item of this.document.mainContractAttachments) {
          this.handleRenderFilePDF(item.path, item.fileSize);
        }
      } else {
        this.renderFilePDF();
      }

      if (this.isDisplaySignatureTab(1) || (this.isSignDigitalCertificate && !this.isShowImage)) {
        this.systemImageSign = true;
        this.isSelectDrawImage = false;
        this.isUploadImage = false;
        this.canvasService.setCanvasSignatureImageUrl('');
        if (this.canvasComponent) {
          this.canvasComponent.clearCanvas();
        }
        this.convertHtmlToImage();
        this.cd.detectChanges();
        setTimeout(() => {
          this.setFontSize(imageConfigViewScaleId);
          this.setFontSize(imageConfigRenderId);
        }, 100);
      } else if (this.isDisplaySignatureTab(2)) {
        this.systemImageSign = false;
        this.isSelectDrawImage = false;
        this.isUploadImage = true;
        this.imagePreviewWidth = 0;
        this.imagePreviewHeight = 0;
        if (this.selectedCert.imageUrl) {
          fetch(this.selectedCert.imageUrl)
            .then(r => r.blob())
            .then(blobFile => {
              this.fileUpload = new File([blobFile], 'fileNameGoesHere', {type: 'image/png'});
              this.fileUploadUpload = this.fileUpload;
              if (this.fileUpload) {
                this.handlePreviewFromFileUpload(this.fileUpload, true);
              }
            });
        } else {
          this.avatarUrl = null;
          this.imageUrlPreview = null;
          setTimeout(() => {
            this.reRenderSignature();
          }, 100);
        }
      } else {
        this.isSelectDrawImage = true;
        this.systemImageSign = false;
        this.isUploadImage = false;
        this.imagePreviewWidth = 0;
        this.imagePreviewHeight = 0;
        this.canvasService.setIsSelectSignDraw(true);
      }
      this.syncActiveTab();
    });
  }

  // end fn group contract

  // start fn Sign method

  changePhone(value) {
    let regexpNumber = new RegExp(this.otpPhoneNumberPattern);
    if (value.trim() == '' || value === null || !regexpNumber.test(value.trim())) {
      this.isDisableSignBtn = true;
    } else {
      this.isDisableSignBtn = false;
    }

    this.signConfig.phoneNumber.value = this.otpPhoneNumber;
  }

  clear() {
    this.otpPhoneNumber = null;
    this.isDisableSignBtn = true
  }

  getCertificateOfSimCA() {
    this.anonymousSignService.anonymousGetlistCertSimCa(this.hashKey, this.simCaPhoneNumber, this.tenantId, this.contractIdAndContractEnterpriseIdEncode).pipe(first()).subscribe(rs => {
      this.checkDisplayMessageError(rs.code);
      if (rs.data.length > 0) {
        this.listOfDataSimCa = rs.data.map((item, index) => {
          return {
            ...item,
            STT: index + 1
          };
        });
      } else {
        this.toastr.error(this.message.getMessage('validation.no_valid_certificate_simCA'));
      }
    }, error => {
    });
  }

  onSelectedSimCaCert(event: any, cert) {
    if (event === true) {
      this.selectedCert = cert;
      this.selectedSimCaCert = cert;
      this.signConfig.enterpriseName.value = this.selectedCert.certificateName;
      // this.signConfig.email.value = this.selectedCert.email;
      this.isDisableSignBtn = false;
      this.listOfDataSimCa = this.listOfDataSimCa.map(item => {
        return {...item, checked: cert.STT === item.STT};
      });
      this.canvasService.setCanvasSignatureImageUrl('');
      if (this.canvasComponent) {
        this.canvasComponent.clearCanvas();
      }
      this.convertHtmlToImage();
      this.cd.detectChanges();
      setTimeout(() => {
        this.setFontSize(imageConfigViewScaleId);
        this.setFontSize(imageConfigRenderId);
      }, 100);
      this.activeImageSource = 'default';
    } else {
      this.isDisableSignBtn = true;
      this.resetSelectCert();
      this.selectedSimCaCert = this.selectedCert;
      this.signConfig.enterpriseName.value = '';
      // this.signConfig.email.value = '';
      this.indexSelect = 0;
      if (this.isDisplaySignatureTab(1) || (this.isSignDigitalCertificate && !this.isShowImage)) {
        this.systemImageSign = true;
        this.isSelectDrawImage = false;
        this.isUploadImage = false;
        this.canvasService.setCanvasSignatureImageUrl('');
        if (this.canvasComponent) {
          this.canvasComponent.clearCanvas();
        }
        this.convertHtmlToImage();
        this.cd.detectChanges();
        setTimeout(() => {
          this.setFontSize(imageConfigViewScaleId);
          this.setFontSize(imageConfigRenderId);
        }, 100);
      } else if (this.isDisplaySignatureTab(2)) {
        this.systemImageSign = false;
        this.isSelectDrawImage = false;
        this.isUploadImage = true;
        this.imagePreviewWidth = 0;
        this.imagePreviewHeight = 0;
        if (this.selectedCert.imageUrl) {
          fetch(this.selectedCert.imageUrl)
            .then(r => r.blob())
            .then(blobFile => {
              this.fileUpload = new File([blobFile], 'fileNameGoesHere', {type: 'image/png'});
              this.fileUploadUpload = this.fileUpload;
              if (this.fileUpload) {
                this.handlePreviewFromFileUpload(this.fileUpload, true);
              }
            });
        } else {
          this.avatarUrl = null;
          this.imageUrlPreview = null;
          setTimeout(() => {
            this.reRenderSignature();
          }, 100);
        }
      } else {
        this.isSelectDrawImage = true;
        this.systemImageSign = false;
        this.isUploadImage = false;
        this.imagePreviewWidth = 0;
        this.imagePreviewHeight = 0;
        this.canvasService.setIsSelectSignDraw(true);
      }
      this.syncActiveTab();
    }
  }

  onSelectedCloudCaCert(event: any, cert) {
    this.indexSelect = 0;
    if (event === true) {
      this.selectedCert = cert;
      this.selectedCloudCaCert = cert;
      this.signConfig.enterpriseName.value = this.selectedCert.certificateName;
      // this.signConfig.email.value = this.selectedCert.email;
      this.isDisableSignBtn = false;
      this.cloudCaDataSource = this.cloudCaDataSource.map(item => {
        return {...item, checked: cert.STT === item.STT};
      });
      if (this.isDisplaySignatureTab(1) || (this.isSignDigitalCertificate && !this.isShowImage)) {
        this.systemImageSign = true;
        this.isSelectDrawImage = false;
        this.isUploadImage = false;
        this.canvasService.setCanvasSignatureImageUrl('');
        if (this.canvasComponent) {
          this.canvasComponent.clearCanvas();
        }
        this.convertHtmlToImage();
        this.cd.detectChanges();
        setTimeout(() => {
          this.setFontSize(imageConfigViewScaleId);
          this.setFontSize(imageConfigRenderId);
        }, 100);
      } else if (this.isDisplaySignatureTab(2)) {
        this.systemImageSign = false;
        this.isSelectDrawImage = false;
        this.isUploadImage = true;
        this.imagePreviewWidth = 0;
        this.imagePreviewHeight = 0;
        if (this.selectedCert.imageUrl) {
          fetch(this.selectedCert.imageUrl)
            .then(r => r.blob())
            .then(blobFile => {
              this.fileUpload = new File([blobFile], 'fileNameGoesHere', {type: 'image/png'});
              this.fileUploadUpload = this.fileUpload;
              if (this.fileUpload) {
                this.handlePreviewFromFileUpload(this.fileUpload, true);
              }
            });
        } else {
          this.avatarUrl = null;
          this.imageUrlPreview = null;
          setTimeout(() => {
            this.reRenderSignature();
          }, 100);
        }
      } else {
        this.isSelectDrawImage = true;
        this.systemImageSign = false;
        this.isUploadImage = false;
        this.imagePreviewWidth = 0;
        this.imagePreviewHeight = 0;
        this.canvasService.setIsSelectSignDraw(true);
      }
      this.syncActiveTab();
    } else {
      this.isDisableSignBtn = true;
      this.resetSelectCert();
      this.selectedCloudCaCert = this.selectedCert;
      this.signConfig.enterpriseName.value = '';
      // this.signConfig.email.value = '';
      if (this.isDisplaySignatureTab(1) || (this.isSignDigitalCertificate && !this.isShowImage)) {
        this.systemImageSign = true;
        this.isSelectDrawImage = false;
        this.isUploadImage = false;
        this.canvasService.setCanvasSignatureImageUrl('');
        if (this.canvasComponent) {
          this.canvasComponent.clearCanvas();
        }
        this.convertHtmlToImage();
        this.cd.detectChanges();
        setTimeout(() => {
          this.setFontSize(imageConfigViewScaleId);
          this.setFontSize(imageConfigRenderId);
        }, 100);
      } else if (this.isDisplaySignatureTab(2)) {
        this.systemImageSign = false;
        this.isSelectDrawImage = false;
        this.isUploadImage = true;
        this.imagePreviewWidth = 0;
        this.imagePreviewHeight = 0;
        if (this.selectedCert.imageUrl) {
          fetch(this.selectedCert.imageUrl)
            .then(r => r.blob())
            .then(blobFile => {
              this.fileUpload = new File([blobFile], 'fileNameGoesHere', {type: 'image/png'});
              this.fileUploadUpload = this.fileUpload;
              if (this.fileUpload) {
                this.handlePreviewFromFileUpload(this.fileUpload, true);
              }
            });
        } else {
          this.avatarUrl = null;
          this.imageUrlPreview = null;
          setTimeout(() => {
            this.reRenderSignature();
          }, 100);
        }
      } else {
        this.isSelectDrawImage = true;
        this.systemImageSign = false;
        this.isUploadImage = false;
        this.imagePreviewWidth = 0;
        this.imagePreviewHeight = 0;
        this.canvasService.setIsSelectSignDraw(true);
      }
      this.syncActiveTab();
    }
  }

  onChangeSelectCertificateType(value: any) {
    this.typeCertificateCheck = !this.typeCertificateCheck;
    this.typeCertificate = value;
    this.resetSelectCert();
    this.signConfig.enterpriseName.value = this.document && this.document.contractEnterpriseName;


    if (value === this.enumSignMethod.SIGN_SIM_CA) {
      this.selectedCert = Object.assign(this.selectedSimCaCert, {typeCertificate: this.typeCertificate}) as any;
      if (this.selectedSimCaCert.certificateName) {
        this.signConfig.enterpriseName.value = this.selectedSimCaCert.certificateName;
      }
      // else {
      //   this.signConfig.enterpriseName.value = '';
      // }
      this.isShowWebcam = false;
    }

    if (value === this.enumSignMethod.SIGN_USB_TOKEN) {
      this.selectedCert = Object.assign(this.usbTokenCertificate, {typeCertificate: this.typeCertificate}) as any;
      if (this.usbTokenCertificate.issuedTo) {
        this.signConfig.enterpriseName.value = this.usbTokenCertificate.issuedTo;
      }
      // else {
      //   this.signConfig.enterpriseName.value = '';
      // }
      this.isShowWebcam = false;
    }

    if (value === this.enumSignMethod.CLOUD_CA) {
      this.selectedCert = Object.assign(this.selectedCloudCaCert, {typeCertificate: this.typeCertificate}) as any;
      if (this.selectedCloudCaCert.certificateName) {
        this.signConfig.enterpriseName.value = this.selectedCloudCaCert.certificateName;
      }
      // else {
      //   this.signConfig.enterpriseName.value = '';
      // }
      this.isShowWebcam = false;
    }

    if (value === this.enumSignMethod.SIGN_OTP) {
      this.selectedCert = Object.assign(this.selectedCert, {typeCertificate: this.typeCertificate});
      if(this.otpPhoneNumber){
        this.changePhone(this.otpPhoneNumber);
      }
      this.signConfig.enterpriseName.value = this.document && this.document.contractEnterpriseName;
      // this.signConfig.email.value = this.document.email;
      if (this.supportEkyc) {
        this.isShowWebcam = true;
      } else {
        this.isShowWebcam = false;
      }
    }
    if (value === this.enumSignMethod.VNEID) {
      this.selectedCert = Object.assign(this.selectedVNeIDCert, {typeCertificate: this.typeCertificate}) as any;
      if (this.selectedVNeIDCert.certificateName) {
        this.signConfig.enterpriseName.value = this.selectedVNeIDCert.certificateName;
      }
      this.isShowWebcam = false;
    }
    this.indexSelect = 0;

    if (this.isDisplaySignatureTab(1) || (this.isSignDigitalCertificate && !this.isShowImage)) {
      this.systemImageSign = true;
      this.isSelectDrawImage = false;
      this.isUploadImage = false;
      this.canvasService.setCanvasSignatureImageUrl('');
      if (this.canvasComponent) {
        this.canvasComponent.clearCanvas();
      }
      this.convertHtmlToImage();
      this.cd.detectChanges();
      setTimeout(() => {
        this.setFontSize(imageConfigViewScaleId);
        this.setFontSize(imageConfigRenderId);
      }, 100);
    } else if (this.isDisplaySignatureTab(2)) {
      this.systemImageSign = false;
      this.isSelectDrawImage = false;
      this.isUploadImage = true;
      this.imagePreviewWidth = 0;
      this.imagePreviewHeight = 0;
      if (this.selectedCert.imageUrl) {
        fetch(this.selectedCert.imageUrl)
          .then(r => r.blob())
          .then(blobFile => {
            this.fileUpload = new File([blobFile], 'fileNameGoesHere', {type: 'image/png'});
            this.fileUploadUpload = this.fileUpload;
            if (this.fileUpload) {
              this.handlePreviewFromFileUpload(this.fileUpload, true);
            }
          });
      } else {
        this.avatarUrl = null;
        this.imageUrlPreview = null;
        setTimeout(() => {
          this.reRenderSignature();
        }, 100);
      }
    } else {
      this.isSelectDrawImage = true;
      this.systemImageSign = false;
      this.isUploadImage = false;
      this.imagePreviewWidth = 0;
      this.imagePreviewHeight = 0;
      this.canvasService.setIsSelectSignDraw(true);
    }
    this.syncActiveTab();

    if (this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_OTP && localStorage.getItem('entTypeAnonymus') != '2') {
      this.signConfig.confirmBy.enabled = true;
      this.signConfig.confirmBy.value = this.confirmBy;
    }
  }

  onSelectedVNeIDCert(event: any, cert) {
    this.indexSelect = 0;
    if (event === true) {
      this.selectedCert = cert;
      this.selectedVNeIDCert = cert;
      this.signConfig.enterpriseName.value = this.selectedCert.certificateName;
      // this.signConfig.email.value = this.selectedCert.email;
      this.isDisableSignBtn = false;
      this.VNeIDDataSource = this.VNeIDDataSource.map(item => {
        return {...item, checked: cert.STT === item.STT};
      });
      if (this.isDisplaySignatureTab(1) || (this.isSignDigitalCertificate && !this.isShowImage)) {
        this.systemImageSign = true;
        this.isSelectDrawImage = false;
        this.isUploadImage = false;
        this.canvasService.setCanvasSignatureImageUrl('');
        if (this.canvasComponent) {
          this.canvasComponent.clearCanvas();
        }
        this.convertHtmlToImage();
        this.cd.detectChanges();
        setTimeout(() => {
          this.setFontSize(imageConfigViewScaleId);
          this.setFontSize(imageConfigRenderId);
        }, 100);
      } else if (this.isDisplaySignatureTab(2)) {
        this.systemImageSign = false;
        this.isSelectDrawImage = false;
        this.isUploadImage = true;
        this.imagePreviewWidth = 0;
        this.imagePreviewHeight = 0;
        if (this.selectedCert.imageUrl) {
          fetch(this.selectedCert.imageUrl)
            .then(r => r.blob())
            .then(blobFile => {
              this.fileUpload = new File([blobFile], 'fileNameGoesHere', {type: 'image/png'});
              this.fileUploadUpload = this.fileUpload;
              if (this.fileUpload) {
                this.handlePreviewFromFileUpload(this.fileUpload, true);
              }
            });
        } else {
          this.avatarUrl = null;
          this.imageUrlPreview = null;
          setTimeout(() => {
            this.reRenderSignature();
          }, 100);
        }
      } else {
        this.isSelectDrawImage = true;
        this.systemImageSign = false;
        this.isUploadImage = false;
        this.imagePreviewWidth = 0;
        this.imagePreviewHeight = 0;
        this.canvasService.setIsSelectSignDraw(true);
      }
      this.syncActiveTab();
    } else {
      this.isDisableSignBtn = true;
      this.resetSelectCert();
      this.selectedCloudCaCert = this.selectedCert;
      this.signConfig.enterpriseName.value = '';
      // this.signConfig.email.value = '';
      if (this.isDisplaySignatureTab(1) || (this.isSignDigitalCertificate && !this.isShowImage)) {
        this.systemImageSign = true;
        this.isSelectDrawImage = false;
        this.isUploadImage = false;
        this.canvasService.setCanvasSignatureImageUrl('');
        if (this.canvasComponent) {
          this.canvasComponent.clearCanvas();
        }
        this.convertHtmlToImage();
        this.cd.detectChanges();
        setTimeout(() => {
          this.setFontSize(imageConfigViewScaleId);
          this.setFontSize(imageConfigRenderId);
        }, 100);
      } else if (this.isDisplaySignatureTab(2)) {
        this.systemImageSign = false;
        this.isSelectDrawImage = false;
        this.isUploadImage = true;
        this.imagePreviewWidth = 0;
        this.imagePreviewHeight = 0;
        if (this.selectedCert.imageUrl) {
          fetch(this.selectedCert.imageUrl)
            .then(r => r.blob())
            .then(blobFile => {
              this.fileUpload = new File([blobFile], 'fileNameGoesHere', {type: 'image/png'});
              this.fileUploadUpload = this.fileUpload;
              if (this.fileUpload) {
                this.handlePreviewFromFileUpload(this.fileUpload, true);
              }
            });
        } else {
          this.avatarUrl = null;
          this.imageUrlPreview = null;
          setTimeout(() => {
            this.reRenderSignature();
          }, 100);
        }
      } else {
        this.isSelectDrawImage = true;
        this.systemImageSign = false;
        this.isUploadImage = false;
        this.imagePreviewWidth = 0;
        this.imagePreviewHeight = 0;
        this.canvasService.setIsSelectSignDraw(true);
      }
      this.syncActiveTab();
    }
  }

  resetSelectCert() {
    this.selectedCert = {
      serialNumber: '',
      phoneNumber: undefined,
      typeCertificate: undefined,
      id: undefined,
      idDetail: undefined,
      imageUrl: null,
      issuedTo: '',
      certificateName: '',
      cloudCaUserId: '',
      taxCode: '',
      email: '',
      issueDN: undefined
    };
  }

  getInformCertificateFromFile(baseString: string, file) {
    this.digitalCertificateService.getInformCertificateFromFile({
      certRawdata: baseString
    }).subscribe(rs => {
      this.errorStatus = null;
      this.fileUpload = file;
      this.fileUploadDefault = file;
      this.usbTokenCertificate = {
        ...this.usbTokenCertificate,
        activeDate: rs.data.activeDate,
        expireDate: rs.data.expireDate,
        certificateName: rs.data.certificateName,
        serialNumber: rs.data.serialNumber,
        distinguishedName: rs.data.distinguishedName,
        issuedBy: rs.data.issuedBy,
        certRawdata: baseString,
        taxCode: rs.data.taxCode,
        email: rs.data.email
      };
    });
  }

  onGetCertificate() {
    this.blockUI.start('');
    initPluginCertificate(this);
    this.isDisableSignBtn = false;
  }

  downloadSignPlugin(os?: string) {
    this.anonymousSignService.getSignPluginName(this.hashKey).subscribe(filename => {
      this.digitalCertificateService.downloadSignPlugin(os).subscribe(rs => {
        this.downLoadFile(rs, 'application/octet-stream', filename);
      });
    });
  }

  resetValue() {
    this.errorStatus = null;
    this.signError = null;
    this.isCancel = false;
    this.isCallDone = false;
  }

  getLinkDownload(os?: string) {
    return this.digitalCertificateService.linkDownloadPluginSign(os);
  }

  createATag(link: string, title: string) {
    return '<a target="_blank" href="' + link + '">' + title + '</a>';
  }

  showErrMsgTransle(msg: string, showToast?: boolean) {
    if (msg === 'messages.not_initPlugin') {
      const link = this.linkDownSignPlugin();
      // console.log(this.createATag(this.linkDownSignPlugin('WINDOWS'), 'Windows, '));
      msg = "messages.initPlugin_faile"
      if (showToast) {
        this.blockUI.stop();

        this.dialog.open(AlertComponent, {
          width: '370px',
          data: this.message.getMessage(msg)
            // + '<a target="_blank" href="' + link + '"><b> ' + this.message.getMessage('messages.here') + '</b></a>'
            + this.createATag(this.linkDownSignPlugin('WINDOWS'), 'Windows, ') + this.createATag(this.linkDownSignPlugin('MACOS'), 'MacOS, ') + this.createATag(this.linkDownSignPlugin('LINUX'), 'ViettelOS')
        });
        return;
      }
      this.signError = this.message.getMessage(msg)
        // + '<a target="_blank" href="' + link + '"><b> ' + this.message.getMessage('messages.here') + '</b></a>';
        + this.createATag(this.linkDownSignPlugin('WINDOWS'), 'Windows, ') + this.createATag(this.linkDownSignPlugin('MACOS'), 'MacOS, ') + this.createATag(this.linkDownSignPlugin('LINUX'), 'ViettelOS')

    } else {
      if (showToast) {
        this.blockUI.stop();
        this.toastr.error(this.message.getMessage(msg));
        return;
      }
      // this.blockUI.stop();
      this.errorStatus = msg;
    }
  }

  getCertificateCloudCa() {
    this.anonymousSignService.getCertsCloudCa(this.hashKey, this.cloudCaUsername, this.providerName, this.contractIdAndContractEnterpriseIdEncode, this.tenantId).pipe(first()).subscribe(rs => {
      this.checkDisplayMessageError(rs.code);
      if (rs && rs.data && rs.data.length > 0) {
        this.cloudCaDataSource = rs.data.map((item, index) => {
          return {
            ...item,
            STT: index + 1
          };
        });
      } else {
        this.toastr.error(this.message.getMessage('validation.no_valid_certificate_cloudCA'));
      }
    }, error => {
    });
  }

  getCertificateVNeID() {
    this.anonymousSignService.getCertsVNeID(this.hashKey, this.VNeIDDataUser, this.contractIdAndContractEnterpriseIdEncode, this.tenantId).pipe(first()).subscribe(rs => {
      this.checkDisplayMessageError(rs.code);
      if (rs && rs.data && rs.data.credentialInfos && rs.data.credentialInfos.length > 0) {
        this.VNeIDDataSource = rs.data.credentialInfos.map((item, index) => {
          return {
            ...item.cert,
            STT: index + 1,
            checked: false,
            credentialId: item.credentialID,
            certificateName: item.cert.subjectDN,
          };
        });
      } else {
        this.toastr.error(this.message.getMessage('validation.no_valid_certificate_cloudCA'));
      }
    }, error => {
    });
  }

  getFile(evt) {
    if (typeof (FileReader) !== 'undefined') {
      const file = evt.target.files[0];
      // Check format of file
      if (!this.checkFormatTypeFile(file)) {
        // Check size of file
        if (!this.checkSize(file.size)) {
          this.usbTokenCertificate.fileName = file.name;
          const reader = new FileReader();
          reader.onload = (e: any) => {
            // Base64 string of file
            const binaryData = e.target.result;
            this.usbTokenCertificate.certRawdata = window.btoa(binaryData);
            this.getInformCertificateFromFile(window.btoa(binaryData), file);
          };
          // Read in the image file as a data URL.
          reader.readAsBinaryString(file);
        }
      } else {
        if (!this.toastr.findDuplicate(this.message.getMessage('validation.file_format_error'), true, true)) {
          this.toastr.error(this.message.getMessage('validation.file_format_error'));
        }
      }
    }
  }

  checkFormatTypeFile(file): boolean {
    if (file.type !== 'application/x-x509-ca-cert') {
      this.errorFormatTypeFile = true;
      return true;
    } else {
      return false;
    }
  }

  private checkSize(fileSize): boolean {
    if (fileSize > 5242880) {
      this.maxSizeInput = true;
      if (!this.toastr.findDuplicate(this.message.getMessage('messages.error_file_5mb'), true, true)) {
        this.toastr.error(this.message.getMessage('messages.error_file_5mb'));
      }
      return true;
    } else {
      this.maxSizeInput = false;
      return false;
    }
  }

  setSerialNumber(value) {
    this.usbTokenCertificate.serialNumber = value;
  }

  setIssuedTo(value) {
    this.usbTokenCertificate.issuedTo = value;
    this.signConfig.enterpriseName.value = value;
    this.isDisableSignBtn = false;

    this.indexSelect = 0;

    if (this.isDisplaySignatureTab(1) || (this.isSignDigitalCertificate && !this.isShowImage)) {
      this.systemImageSign = true;
      this.isSelectDrawImage = false;
      this.isUploadImage = false;
      this.canvasService.setCanvasSignatureImageUrl('');
      if (this.canvasComponent) {
        this.canvasComponent.clearCanvas();
      }
      this.convertHtmlToImage();
      this.cd.detectChanges();
      setTimeout(() => {
        this.setFontSize(imageConfigViewScaleId);
        this.setFontSize(imageConfigRenderId);
      }, 100);
    } else if (this.isDisplaySignatureTab(2)) {
      this.systemImageSign = false;
      this.isSelectDrawImage = false;
      this.isUploadImage = true;
      this.imagePreviewWidth = 0;
      this.imagePreviewHeight = 0;
      if (this.selectedCert.imageUrl) {
        fetch(this.selectedCert.imageUrl)
          .then(r => r.blob())
          .then(blobFile => {
            this.fileUpload = new File([blobFile], 'fileNameGoesHere', {type: 'image/png'});
            this.fileUploadUpload = this.fileUpload;
            if (this.fileUpload) {
              this.handlePreviewFromFileUpload(this.fileUpload, true);
            }
          });
      } else {
        this.avatarUrl = null;
        this.imageUrlPreview = null;
        setTimeout(() => {
          this.reRenderSignature();
        }, 100);
      }
    } else {
      this.isSelectDrawImage = true;
      this.systemImageSign = false;
      this.isUploadImage = false;
      this.imagePreviewWidth = 0;
      this.imagePreviewHeight = 0;
      this.canvasService.setIsSelectSignDraw(true);
    }
    this.syncActiveTab();
  }

  setDistinguishedName(value) {
    this.usbTokenCertificate.distinguishedName = value;
  }

  setTaxCode(value) {
    this.usbTokenCertificate.taxCode = value;
  }

  setIssuedBy(value) {
    this.usbTokenCertificate.issuedBy = value;
  }

  setCertRawdata(value) {
    this.usbTokenCertificate.certRawdata = value;
  }

  setActiveDate(value) {
    this.usbTokenCertificate.activeDate = new Date(value);
  }

  setExpireDate(value) {
    this.usbTokenCertificate.expireDate = new Date(value);
  }

  setSessionId(value) {
    this.sessionId = value;
  }

  setCertData(data) {
    let dataValid = true;
    for (const [key, value] of Object.entries(data)) {
      if (!value) {
        dataValid = false;
        break;
      }
    }
    if (dataValid) {
      this.certData = data;
    } else {
      this.toastr.error(this.message.getMessage('messages.certificate_info_not_valid'));
      this.usbTokenCertificate = {
        certRawdata: '',
        taxCode: '',
        serialNumber: '',
        issuedTo: '',
        issuedBy: '',
        expireDate: new Date(),
        activeDate: new Date(),
        fileName: '',
        certificateName: '',
        distinguishedName: '',
        email: ''
      };
      this.sessionId = null;
    }
  }

  // end fn Sign method

  // start fn group with PDF

  reRenderSignature() {
    if (this.document) {
      const id = this.document.mainContractAttachments[this.activeFile].id;
      const fileId = this.decodeId(id);
      const signs = this.signPosition.filter(sign => {
        return sign.fileId === fileId && (sign.signType === this.signPositionTypes.IMAGE || sign.signType === this.signPositionTypes.COMBINE);
      });
      for (let sign of signs) {
        let signatureId = document.getElementById(`sign-${sign.id}`) || document.getElementById('show-frames-notification');
        const signPositionData = this.signPosition.find(e => e.id === sign.id);
        const width = signPositionData.width;
        const height = signPositionData.height;
        if (signatureId) {
          signatureId.innerHTML = this.generateStampContentWidthHeight(Number(width), Number(height), null, true);
          if (this.canMoveAndResize) {
            const resizer = this.renderer.createElement('div');
            this.renderer.setAttribute(resizer, 'class', 'resize-div-bot-right')
            resizer.style.setProperty('--zoom', (this.zoomLevel / 100).toString());
            const rerenderSign = () => {
              signatureId.appendChild(resizer);
              resizer.style.removeProperty('--zoom');
              resizer.style.setProperty('--zoom', (this.zoomLevel / 100).toString());
              return;
            };
            this.renderer.appendChild(signatureId, resizer);
            rerenderSign();

            let startX, startY;
            let baseWidth;
            let baseHeight;
            const signatureWidth = this.widthRectangle * this.zoomLevel / 100;
            const heightRectangle = this.heightRectangle * this.zoomLevel / 100;
            const widthHeightRatio = signatureWidth / heightRectangle;

            this.renderer.listen(resizer, 'mousedown', (e) => {
              e.stopPropagation();
              startX = e.clientX;
              startY = e.clientY;
              baseWidth = signatureId.offsetWidth;
              baseHeight = signatureId.offsetHeight;

              document.documentElement.addEventListener('mousemove', doDragSignPosition);
              document.documentElement.addEventListener('mouseup', stopDragSignPosition);
            });

            const doDragSignPosition = (e) => {
              e.stopPropagation();
              const signatureH = this.signPosition.find(e => e.id === sign.id).width * this.zoomLevel / 100;
              const signatureW = this.signPosition.find(e => e.id === sign.id).width * this.zoomLevel / 100;
              signatureId.style.width = (signatureW + e.clientX - startX) + 'px';
              signatureId.style.height = (signatureH + e.clientY - startY) + 'px';
              const widthHeightRatioDrag = signatureId.offsetWidth / signatureId.offsetHeight;
              if (widthHeightRatio !== widthHeightRatioDrag) {
                signatureId.style.height = (signatureId.offsetWidth / widthHeightRatio) + 'px';
                signatureId.style.width = (signatureId.offsetHeight * widthHeightRatio) + 'px';
              }
              signatureId.style.maxWidth = (this.textLayerDiv.offsetWidth - signatureId.offsetLeft) + 'px';
              signatureId.style.maxHeight = (this.textLayerDiv.offsetHeight - signatureId.offsetTop) + 'px';
              signatureId.innerHTML =
                this.generateStampContentWidthHeight(Number(signatureId.offsetWidth), Number(signatureId.offsetHeight), null, true);

              rerenderSign();
            };

            const stopDragSignPosition = (e) => {
              const wrapperLeft = (sign.x * this.zoomLevel) / 100;
              const wrapperTop = (sign.y * this.zoomLevel) / 100;
              e.stopPropagation();
              if (signatureId.offsetWidth / 2 + wrapperLeft < 0 || signatureId.offsetHeight / 2 + wrapperTop < 0) {
                signatureId.style.width = baseWidth + 'px';
                signatureId.style.height = baseHeight + 'px';
              } else {
                baseWidth = signatureId.offsetWidth;
                baseHeight = signatureId.offsetHeight;
              }
              signatureId.innerHTML =
                this.generateStampContentWidthHeight(Number(signatureId.offsetWidth), Number(signatureId.offsetHeight), null, true);

              this.signPosition = this.signPosition.map(position => {
                if ((position.id === sign.id) && position.fileId === fileId) {
                  position.width = signatureId.offsetWidth;
                  position.height = signatureId.offsetHeight;
                }
                return position;
              });
              this.imageData = this.imageData.map(position => {
                if ((position.id === sign.id) && position.fileId === fileId) {
                  position.widthRectangle = signatureId.offsetWidth;
                  position.heightRectangle = signatureId.offsetHeight;
                }
                return position;
              });
              rerenderSign();
              document.documentElement.removeEventListener('mousemove', doDragSignPosition);
              document.documentElement.removeEventListener('mouseup', stopDragSignPosition);
            };
          }
        }
      }
    }
  }

  renderFilePDF() {
    if (this.document) {
      const firstFile = this.document.mainContractAttachments[0];
      this.pdfSrc = this.listPdfSrc[firstFile.path];
      this.setTitleFilePDF();
    }
  }

  toggleFullviewPdf() {
    this.isFullviewPdf = !this.isFullviewPdf;
    this.setZoomLevel();
  }

  setZoomLevel() {
    // TODO
    if ((this.mediaBreakpoint === SCREEN_SIZE.MD || this.mediaBreakpoint === SCREEN_SIZE.LG
      || this.mediaBreakpoint === SCREEN_SIZE.XL || this.mediaBreakpoint === SCREEN_SIZE.XXL) && this.isFullviewPdf) {
      this.zoomLevel = 100;
    } else {
      if (this.mediaBreakpoint === SCREEN_SIZE.XXL) {
        this.zoomLevel = 100;
      } else if (this.mediaBreakpoint === SCREEN_SIZE.XL || this.mediaBreakpoint === SCREEN_SIZE.LG) {
        this.zoomLevel = 75;
      } else {
        this.zoomLevel = 50;
      }
    }
  }

  setTitleFilePDF() {
    if (this.document && this.document.mainContractAttachments) {
      setTimeout(() => {
        const tabs = document.getElementsByClassName('tab');
        if (tabs) {
          Array.from({length: tabs.length}, (v, i) => i).forEach(index => {
            const tab = tabs.item(index) as HTMLElement;
            tab.style.width = 100 / this.document.mainContractAttachments.length + '%';
          })
        }
      }, 100);
    }
  }

  handleRenderFilePDF(pdfFilePath, size?) {
    const data = {
      hashKey: this.hashKey,
      tenantId: this.tenantId,
      pdfFilePath: pdfFilePath
    };
    if (!this.env.pdfViewFullDownload && size && size > 10485760) {
      const queryString = Object.entries(data)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
      // const res = await this.commonService.getViewPdfForDocumentByFilePath(data).toPromise();
      const pdfSrc = `${this.BASE_URL}?${queryString}`;
      this.listPdfSrc[pdfFilePath] = pdfSrc;
      this.document.mainContractAttachments.forEach(item => {
        if (item.path == pdfFilePath) {
          item.loading = false;
        }
      });
    } else {
      try {
        this.anonymousSignService.anonymousGetContractFileByHashKey(this.hashKey, this.tenantId, pdfFilePath, (err) => {
        }).subscribe(
          res => {
            this.showPdf(res, pdfFilePath);
          }
        );
      } catch (e) {
      }
    }
    this.setTitleFilePDF();
  }

  showPdf(blob: any, pdfFilePath: string) {
    const file = this.blobToFile(blob, 'application/pdf');
    this.commonService.readFile(file, (pdfSrc) => {
      this.pdfSrc = pdfSrc;
      if (!this.listPdfSrc) {
        this.listPdfSrc = {}
      }
      this.listPdfSrc[pdfFilePath] = pdfSrc;
      this.document.mainContractAttachments.forEach(item => {
        if (item.path == pdfFilePath) {
          item.loading = false;
        }
      });
    });
  }

  changeFile(filePath: string, index: number) {
    this.isSelectedPosition.next(false);
    const nodeOther = document.getElementById('show-frames-notification');
    if (nodeOther) {
      nodeOther.remove();
    }
    this.pageCurrent = 1;
    this.activeFile = index;
    this.checkSignManual();

    if (this.listPdfSrc) {
      this.pdfSrc = this.listPdfSrc[filePath];
    }
  }

  checkFileNotHaveSign(id: string) {
    return this.fileError.includes(id);
  }

  // ----------- render Chân ký ---------------

  // check
  checkSignManual() {
    const id = this.document.mainContractAttachments[this.activeFile].id;
    const fileId = this.decodeId(id);
    const signs = this.signPosition.filter(sign => {
      return sign.fileId === fileId;
    });
    if (signs.length > 0) {
      this.isAllowSelectSignPosition = false;
      this.isSelectedPosition.next(false);
      if (signs.length === 1 && signs[0].signType === this.signPositionTypes.DIGITAL) {
        this.onlyDigital = true;
      } else {
        this.onlyDigital = false;
      }
    } else {
      this.isAllowSelectSignPosition = true;
      this.onStamped();
    }
  }

  checkSignManualNoStamp() {
    const id = this.document.mainContractAttachments[this.activeFile].id;
    const fileId = this.decodeId(id);
    const signs = this.signPosition.filter(sign => {
      return sign.fileId === fileId;
    });
    if (signs.length > 0) {
      this.isAllowSelectSignPosition = false;
      this.isSelectedPosition.next(false);
      if (signs.length === 1 && signs[0].signType === this.signPositionTypes.DIGITAL) {
        this.onlyDigital = true;
      } else {
        this.onlyDigital = false;
      }
    } else {
      this.isAllowSelectSignPosition = true;
    }
  }

  // Đặt lại chân ký
  onStamped() {
    this.isSelectedPosition.next(true);
    const id = this.document.mainContractAttachments[this.activeFile].id;
    const fileId = this.decodeId(id);
    if (fileId && this.signPosition && this.signPosition.length > 0) {
      this.signPosition = this.signPosition.filter(sign => {
        return sign.fileId !== fileId;
      });
    }
    if (fileId && this.imageData && this.imageData.length > 0) {
      this.imageData = this.imageData.filter(image => {
        return image.fileId !== fileId;
      });
    }
    const listElement = document.getElementsByClassName('box-sign');
    if (listElement && listElement.length) {
      listElement.item(0).remove();
    }
    const nodeOther = document.getElementById('show-frames-notification');
    if (nodeOther) {
      nodeOther.remove();
    }
    this.showFramesNotification();
  }

  // Khung hiển thị chân ký
  showFramesNotification() {
    const nodeOther = document.getElementById('show-frames-notification');
    if (nodeOther) {
      nodeOther.remove();
    }
    const navBoundingClient = this.navigation.nativeElement.getBoundingClientRect();
    const {top, left, bottom, width, height} = navBoundingClient;
    const signatureWidth = this.widthRectangle * this.zoomLevel / 100;
    const heightRectangle = this.heightRectangle * this.zoomLevel / 100;
    const navigation = document.getElementById('navigation');
    const newTop = top - 2 * heightRectangle;
    const newLeft = width / 2 - signatureWidth / 2;
    const stampNode = document.createElement('div');
    this.renderer.setAttribute(stampNode, 'id', 'show-frames-notification');
    const contentNode = `<span style="color: red;">${this.translateService.instant('messages.click_to_select_sign_position')}</span>`;
    stampNode.innerHTML = contentNode;
    this.renderer.setStyle(stampNode, 'position', 'absolute');
    this.renderer.setStyle(stampNode, 'background', 'rgb(0,0,0,0.2)');
    this.renderer.setStyle(stampNode, 'left', `${newLeft}px`);
    this.renderer.setStyle(stampNode, 'top', `${newTop}px`);
    this.renderer.setStyle(stampNode, 'width', `${signatureWidth}px`);
    this.renderer.setStyle(stampNode, 'height', `${heightRectangle}px`);
    this.renderer.setStyle(stampNode, 'zIndex', 1);
    this.renderer.setStyle(stampNode, 'border', '1px solid #999999');
    this.renderer.setStyle(stampNode, 'display', 'flex');
    this.renderer.setStyle(stampNode, 'alignItems', 'center');
    this.renderer.setStyle(stampNode, 'justifyContent', 'center');
    this.renderer.setStyle(stampNode, 'overflow', '-webkit-paged-x');

    this.stampWrapper = stampNode;
    navigation.appendChild(stampNode);
  }

  textLayerRendered(ele) {
    this.checkSignManualNoStamp()
    if (this.isSignDigitalCertificate && !this.isShowImage) {
      return '';
    }
    const element = ele.source.textLayerDiv;
    this.textLayerDiv = element;
    const pageIndex = ele.source.pageNumber;
    this.renderer.listen(element, 'mouseenter', () => {
      this.pageIndex = pageIndex;
    });

    let signPosition;
    const fileId = this.document.mainContractAttachments[this.activeFile].id;
    const id = this.decodeId(fileId);
    const imageId = this.commonService.generateUUID();

    // lấy các chữ ký từng pageNumber nếu đã cấu hình sẵn chân ký
    if (this.signPosition && this.signPosition.length > 0) {
      signPosition = this.signPosition.filter((item) => {
        return item.pageNumber === pageIndex && id === item.fileId;
      });
    }

    if (signPosition && signPosition.length > 0) {
      for (const position of signPosition) {
        const x = position.x;
        const y = position.y;
        const _width = position.width;
        const _height = position.height;
        const signType = position.signType;
        const id = position.id;
        const htmlNode = this.getStampWrapper(x, y, signType, id, element, parseInt(position.page));
        const hasImage = this.signPosition.some(e => e.signType === SignPositionTypes.IMAGE);
        if (signType === SignPositionTypes.DIGITAL && hasImage) { // Lọc lấy những SignPosition có signType là 'image'
          console.log('not show digital');
        } else {
          this.renderer.appendChild(element, htmlNode);
        }
      }

      // move đến trang chân ký lần vào đầu tiên
      if (this.isGotoSignpage) {
        const firstPosition = signPosition[0];
        const firstPage = firstPosition.pageNumber;
        this.signPage = firstPosition.pageNumber;
        this.gotoSignPageNumber(firstPage);
        this.isGotoSignpage = false;
      }
      const fileCustomerSign = this.signPosition.find(sign => sign.fileId === id && sign.isNew);
      this.isAllowSelectSignPosition = !!fileCustomerSign;
      this.isSelectedPosition.next(false);
    }

    // Luồng đặt chân ký
    if (this.isAllowSelectSignPosition) {
      // kéo chân ký ra khỏi file PDF
      this.renderer.listen(element, 'mouseleave', () => {
        if (this.isSelectedPosition.getValue()) {
          const nodeOther = document.getElementById('show-frames-notification');
          if (nodeOther) {
            nodeOther.remove();
          }
        }
      });

      // event lăn chân ký sang file khác
      this.renderer.listen(element, 'wheel', (wheelEvent) => {
        if (this.isSelectedPosition.getValue()) {
          const node = element.querySelector('#show-frames-notification');
          const nodeOther = document.getElementById('show-frames-notification');
          if (!node && nodeOther) {
            nodeOther.remove();
          }
          const boundingClient = element.getBoundingClientRect();
          const {top, left} = boundingClient;
          const signatureWidth = this.widthRectangle * this.zoomLevel / 100;
          const heightRectangle = this.heightRectangle * this.zoomLevel / 100;

          if (!node) {
            const stampNode = this.renderer.createElement('div');
            stampNode.innerHTML = this.generateStampContent();
            this.stampWrapper = stampNode;
            this.renderer.setAttribute(stampNode, 'id', 'show-frames-notification');
            const width = signatureWidth;
            const height = heightRectangle;
            const wrapperLeft = wheelEvent.clientX - signatureWidth / 2 - left;
            const wrapperTop = wheelEvent.clientY - heightRectangle / 2 - top;
            this.setStyleFrameSignature(stampNode, width, height, wrapperLeft, wrapperTop);
            this.renderer.appendChild(element, stampNode);
          } else {
            this.renderer.setStyle(node, 'left', `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`);
            this.renderer.setStyle(node, 'top', `${(wheelEvent.clientY - heightRectangle / 2 - top)}px`);
          }
        }
      })

      // đặt chân ký
      this.renderer.listen(element, 'mousedown', (mousedownEvent) => {
        if (this.isSelectedPosition.getValue()) {
          this.isSelectedPosition.next(false);
          const framesNotification = document.getElementById('show-frames-notification');
          if (framesNotification) {
            framesNotification.remove();
          }
          const offsetParent = element.offsetParent.dataset;
          const {pageNumber} = offsetParent;
          const boundingClient = element.getBoundingClientRect();
          const {top, left} = boundingClient;
          const signatureWidth = this.widthRectangle * this.zoomLevel / 100;
          const heightRectangle = this.heightRectangle * this.zoomLevel / 100;
          const signZoom = this.zoomLevel / 100;
          const widthHeightRatio = signatureWidth / heightRectangle;
          const wrapperLeft = mousedownEvent.clientX - signatureWidth / 2 - left;
          const wrapperTop = mousedownEvent.clientY - heightRectangle / 2 - top;

          this.setStyleFrameSignature(this.stampWrapper, signatureWidth, heightRectangle, wrapperLeft, wrapperTop);
          this.stampWrapper.innerHTML = this.generateStampContent();

          if (this.canMoveAndResize) {
            let startX, startY;
            let baseWidth;
            let baseHeight;
            const resizer = this.renderer.createElement('div');
            this.renderer.setAttribute(resizer, 'class', 'resize-div-bot-right')
            resizer.style.setProperty('--zoom', signZoom.toString());
            const rerenderSign = () => {
              this.stampWrapper.appendChild(resizer);
              resizer.style.removeProperty('--zoom');
              resizer.style.setProperty('--zoom', (signZoom).toString());
              return;
            };
            this.renderer.appendChild(this.stampWrapper, resizer);

            this.renderer.listen(resizer, 'mousedown', (e) => {
              e.stopPropagation();
              startX = e.clientX;
              startY = e.clientY;
              baseWidth = this.stampWrapper.offsetWidth;
              baseHeight = this.stampWrapper.offsetHeight;
              document.documentElement.addEventListener('mousemove', doDragSignPosition);
              document.documentElement.addEventListener('mouseup', stopDragSignPosition);
            });

            const doDragSignPosition = (e) => {
              e.stopPropagation();
              const positionData = this.signPosition.find(sign => sign.id === imageId);
              const signatureH = positionData.width * this.zoomLevel / 100;
              const signatureW = positionData.width * this.zoomLevel / 100;
              this.stampWrapper.style.width = (signatureW + e.clientX - startX) + 'px';
              this.stampWrapper.style.height = (signatureH + e.clientY - startY) + 'px';
              const widthHeightRatioDrag = this.stampWrapper.offsetWidth / this.stampWrapper.offsetHeight;
              if (widthHeightRatio !== widthHeightRatioDrag) {
                this.stampWrapper.style.height = (this.stampWrapper.offsetWidth / widthHeightRatio) + 'px';
                this.stampWrapper.style.width = (this.stampWrapper.offsetHeight * widthHeightRatio) + 'px';
              }
              this.stampWrapper.style.maxWidth = (element.offsetWidth - this.stampWrapper.offsetLeft) + 'px';
              this.stampWrapper.style.maxHeight = (element.offsetHeight - this.stampWrapper.offsetTop) + 'px';
              this.stampWrapper.innerHTML =
                this.generateStampContentWidthHeight(Number(this.stampWrapper.offsetWidth), Number(this.stampWrapper.offsetHeight), null, true);

              rerenderSign();
            };
            const stopDragSignPosition = (e) => {
              e.stopPropagation();
              if (this.stampWrapper.offsetWidth / 2 + wrapperLeft < 0 || this.stampWrapper.offsetHeight / 2 + wrapperTop < 0) {
                this.stampWrapper.style.width = baseWidth + 'px';
                this.stampWrapper.style.height = baseHeight + 'px';
              } else {
                baseWidth = this.stampWrapper.offsetWidth;
                baseHeight = this.stampWrapper.offsetHeight;
              }
              this.stampWrapper.innerHTML =
                this.generateStampContentWidthHeight(Number(this.stampWrapper.offsetWidth), Number(this.stampWrapper.offsetHeight), null, true);
              this.signPosition = this.signPosition.map(position => {
                if ((position.id === imageId) && position.fileId === id) {
                  position.width = this.stampWrapper.offsetWidth;
                  position.height = this.stampWrapper.offsetHeight;
                }
                return position;
              });
              this.imageData = this.imageData.map(position => {
                if ((position.id === imageId) && position.fileId === id) {
                  position.widthRectangle = this.stampWrapper.offsetWidth;
                  position.heightRectangle = this.stampWrapper.offsetHeight;
                }
                return position;
              });
              rerenderSign();
              document.documentElement.removeEventListener('mousemove', doDragSignPosition);
              document.documentElement.removeEventListener('mouseup', stopDragSignPosition);
            };
          }
          this.renderer.appendChild(element, this.stampWrapper);

          // xoá dòng thông báo click để chọn vị trí
          document.querySelectorAll('#notify_outside').forEach(item => {
            if (item) {
              item.remove();
            }
          });

          const zoomLevel = this.zoomLevel;
          this.imageData = this.imageData.filter(img => {
            return img.fileId !== fileId;
          });
          this.imageData.push({
            stampPositionLeft: mousedownEvent.clientX - signatureWidth / 2 - left,
            stampPositionTop: mousedownEvent.clientY - heightRectangle / 2 - top,
            positionX: 100 * wrapperLeft / zoomLevel,
            positionY: 100 * wrapperTop / zoomLevel,
            pageIndex,
            zoom: this.zoomLevel / 100,
            pdfSrc: this.pdfSrc,
            pageNumber,
            id: imageId,
            isNew: true,
            signType: SignPositionTypes.COMBINE,
            type: SignDocumentComponent.SIGN_SINGLE,
            widthRectangle: this.widthRectangle,
            heightRectangle: this.heightRectangle,
            fileId: id
          });
          this.signPosition = this.signPosition.filter(sp => {
            return sp.fileId !== id;
          });
          this.signPosition.push({
            fileId: id,
            signType: SignPositionTypes.COMBINE,
            pageNumber: Number(pageIndex),
            x: 100 * wrapperLeft / zoomLevel,
            y: 100 * wrapperTop / zoomLevel,
            width: this.widthRectangle,
            height: this.heightRectangle,
            id: imageId,
            isNew: true
          });
          if (this.fileError.includes(fileId)) {
            this.fileError = this.fileError.filter(idFile => {
              return idFile !== fileId;
            });
          }
        }
      });

      // Di chuyển chân ký
      this.renderer.listen(element, 'mousemove', (mousemoveEvent) => {
        if (this.isSelectedPosition.getValue()) {
          const node = element.querySelector('#show-frames-notification');
          const nodeOther = document.getElementById('show-frames-notification');
          if (!node && nodeOther) {
            nodeOther.remove();
          }
          const boundingClient = element.getBoundingClientRect();
          const {top, left} = boundingClient;
          const signatureWidth = this.widthRectangle * this.zoomLevel / 100;
          const heightRectangle = this.heightRectangle * this.zoomLevel / 100;
          if (!node) {
            const stampNode = this.renderer.createElement('div');
            stampNode.innerHTML = this.generateStampContent();
            this.renderer.setAttribute(stampNode, 'id', 'show-frames-notification');
            const width = signatureWidth;
            const height = heightRectangle;
            const wrapperLeft = mousemoveEvent.clientX - signatureWidth / 2 - left;
            const wrapperTop = mousemoveEvent.clientY - heightRectangle / 2 - top;
            this.setStyleFrameSignature(stampNode, width, height, wrapperLeft, wrapperTop);

            this.renderer.appendChild(element, stampNode);

          } else {
            this.renderer.setStyle(node, 'left', `${(mousemoveEvent.clientX - signatureWidth / 2 - left)}px`);
            this.renderer.setStyle(node, 'top', `${(mousemoveEvent.clientY - heightRectangle / 2 - top)}px`);
          }
        }
      })
    }

    this.renderer.setStyle(element, 'opacity', '1');
    this.renderer.setAttribute(element, 'id', `text-pdf-layer-${pageIndex}`);
    this.pageIndex++;
    if (this.isAllowSelectSignPosition && this.isSelectedPosition.getValue()) {
      this.onStamped();
    }
  }

  // Add style khung chân ký
  setStyleFrameSignature(stampNode: any, widthRectangle: number, heightRectangle: number, wrapperLeft: number, wrapperTop: number) {
    this.renderer.setStyle(stampNode, 'position', 'absolute');
    this.renderer.setStyle(stampNode, 'background', 'rgb(0,0,0,0.2)');
    this.renderer.setStyle(stampNode, 'zIndex', 1);
    this.renderer.setStyle(stampNode, 'border', '1px solid #999999');
    this.renderer.setStyle(stampNode, 'lineHeight', '1.9');
    this.renderer.setStyle(stampNode, 'color', '#00f');
    this.renderer.setStyle(stampNode, 'fontFamily', 'Roboto, sans-serif');
    this.renderer.setStyle(stampNode, 'left', `${wrapperLeft}px`);
    this.renderer.setStyle(stampNode, 'top', `${wrapperTop}px`);
    this.renderer.setStyle(stampNode, 'width', `${widthRectangle}px`);
    this.renderer.setStyle(stampNode, 'height', `${heightRectangle}px`);
    this.renderer.setStyle(stampNode, 'padding', `${10 * this.zoomLevel / 100}px`);
    this.renderer.setStyle(stampNode, 'fontSize', `${16 * this.zoomLevel / 100}px`);
    this.renderer.setStyle(stampNode, 'display', 'flex');
    this.renderer.setStyle(stampNode, 'alignItems', 'center');
    this.renderer.setStyle(stampNode, 'justifyContent', 'center');
    this.renderer.setStyle(stampNode, 'overflow', '-webkit-paged-x');
  }

  // lấy khung chân ký
  getStampWrapper(positionX: number, positionY: number, signType: string, id: string, elementTextLayerDiv: any, basePageIndex: number) {
    const signPositionData = this.signPosition.find(e => e.id === id);
    const width = signPositionData.width;
    const height = signPositionData.height;
    const stampNode = this.renderer.createElement('div');
    this.renderer.setAttribute(stampNode, 'id', `sign-${id}`);

    // with, height khung ký
    let widthRectangle = width * this.zoomLevel / 100;
    const heightRectangle = height * this.zoomLevel / 100;

    // khoảng cách từ lề trái, lề bên trên đến chân ký
    const wrapperLeft = (positionX * this.zoomLevel) / 100;
    const wrapperTop = (positionY * this.zoomLevel) / 100;

    const widthHeightRatio = width / height;

    // lấy vị trí tương đối của elementTextLayerDiv
    let {top, left} = elementTextLayerDiv.getBoundingClientRect();

    const elementId = elementTextLayerDiv.id.replace('text-pdf-layer-', '');

    // Add style cho khung chân ký
    this.setStyleFrameSignature(stampNode, widthRectangle, heightRectangle, wrapperLeft, wrapperTop);

    stampNode.innerHTML = this.generateStampContentWidthHeight(width, height, signType, !!signPositionData.isNew);
    stampNode.className = 'box-sign';

    // move chân ký
    if (this.canMoveAndResize) {
      // move element
      let baseWrapperLeft;
      let baseWrapperTop;
      let signId;
      if (!signPositionData.isNew) {
        stampNode.style.cursor = 'move';
        stampNode.addEventListener('mousedown', (e) => {
          const targetSignId = e.target as Element;
          signId = targetSignId.id.replace('sign-', '');
          baseWrapperLeft = stampNode.offsetLeft;
          baseWrapperTop = stampNode.offsetTop;
          stampNode.innerHTML = `<div style="font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: red; cursor: move;">
              <div id="notify_outside" style="position: absolute;top: -${35 * signZoom}px;left: ${(stampNode.offsetWidth / 2 - 150) * signZoom}px;color: red; width: ${300 * signZoom}px">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
                ${this.generateStampContentWidthHeight(stampNode.offsetWidth, stampNode.offsetHeight, signType, !!signPositionData.isNew)}
              </div>`;

          document.documentElement.addEventListener('mousemove', doMove);
          document.documentElement.addEventListener('wheel', (wheelEvent) => {
            const elBounding = elementTextLayerDiv.getBoundingClientRect();
            left = elBounding.left;
            top = elBounding.top;

          });
          document.documentElement.addEventListener('mouseup', stopMove);
        });
      }
      const signZoom = this.zoomLevel / 100;
      let goPage;
      // Move element sign
      const doMove = (e) => {
        goPage = document.getElementById(`text-pdf-layer-${this.pageIndex}`);
        if (this.pageIndex + '' !== elementId && goPage) {
          const elBounding = goPage.getBoundingClientRect();
          left = elBounding.left;
          top = elBounding.top;
          stampNode.remove();
          goPage.appendChild(stampNode);
        } else {
          const elBounding = elementTextLayerDiv.getBoundingClientRect();
          left = elBounding.left;
          top = elBounding.top;
          stampNode.remove();
          goPage.appendChild(stampNode);
        }
        stampNode.style.left = (e.clientX - stampNode.offsetWidth / 2 - left) + 'px';
        stampNode.style.top = (e.clientY - stampNode.offsetHeight / 2 - top) + 'px';
      };

      // stop move and save position
      const stopMove = (e) => {
        e.stopPropagation();
        if (stampNode.offsetWidth / 2 + stampNode.offsetLeft < 0
          || stampNode.offsetHeight / 2 + stampNode.offsetTop < 0
        ) {
          stampNode.style.left = baseWrapperLeft + 'px';
          stampNode.style.top = baseWrapperTop + 'px';
          this.pageIndex = basePageIndex;
        } else {
          baseWrapperLeft = stampNode.offsetLeft;
          baseWrapperTop = stampNode.offsetTop;
        }
        stampNode.innerHTML = this.generateStampContentWidthHeight(stampNode.offsetWidth, stampNode.offsetHeight, signType, !!signPositionData.isNew);
        this.signPosition = this.signPosition.map(position => {
          if ((position.id === id) && position.fileId === fileId) {
            position.x = stampNode.offsetLeft / signZoom;
            position.y = stampNode.offsetTop / signZoom;
            position.pageNumber = this.pageIndex;
          }
          return position;
        });
        this.imageData = this.imageData.map(position => {
          if ((position.id === id) && position.fileId === fileId) {
            position.positionX = stampNode.offsetLeft / signZoom;
            position.positionY = stampNode.offsetTop / signZoom;
            position.pageIndex = this.pageIndex;
            position.pageNumber = this.pageIndex;
          }
          return position;
        });
        rerenderSign();
        document.documentElement.removeEventListener('mousemove', doMove);
        document.documentElement.removeEventListener('mouseup', stopMove);
      };
      const fileId = this.decodeId(this.document.mainContractAttachments[this.activeFile].id);
      const resizer = document.createElement('div');
      resizer.setAttribute('class', 'resize-div-bot-right');
      resizer.style.setProperty('--zoom', signZoom.toString());
      const rerenderSign = () => {
        stampNode.appendChild(resizer);
        resizer.style.removeProperty('--zoom');
        resizer.style.setProperty('--zoom', (signZoom).toString());
        return;
      };
      if (signType !== SignPositionTypes.DIGITAL) {

        stampNode.appendChild(resizer);

        let startX, startY;
        let baseWidth;
        let baseHeight;
        resizer.addEventListener('mousedown', (e) => {
          e.stopPropagation();
          startX = e.clientX;
          startY = e.clientY;
          const targetSignId = e.target as Element;
          signId = targetSignId.parentElement.id.replace('sign-', '');
          baseWidth = stampNode.offsetWidth;
          baseHeight = stampNode.offsetHeight;
          document.documentElement.addEventListener('mousemove', doDrag);
          document.documentElement.addEventListener('mouseup', stopDrag);

        });


        const doDrag = (e) => {
          e.stopPropagation();
          const signatureHeight = signPositionData.height * this.zoomLevel / 100;
          stampNode.style.width = ((signPositionData.width * this.zoomLevel / 100) + e.clientX - startX) + 'px';
          stampNode.style.height = (signatureHeight + e.clientY - startY) + 'px';
          const widthHeightRatioDrag = stampNode.offsetWidth / stampNode.offsetHeight;
          if (widthHeightRatio !== widthHeightRatioDrag) {
            stampNode.style.height = (stampNode.offsetWidth / widthHeightRatio) + 'px';
            stampNode.style.width = (stampNode.offsetHeight * widthHeightRatio) + 'px';
          }
          stampNode.style.maxWidth = (elementTextLayerDiv.offsetWidth - stampNode.offsetLeft) + 'px';
          stampNode.style.maxHeight = (elementTextLayerDiv.offsetHeight - stampNode.offsetTop) + 'px';
          stampNode.innerHTML = this.generateStampContentWidthHeight(Number(stampNode.offsetWidth), Number(stampNode.offsetHeight), signType, !!signPositionData.isNew);

          rerenderSign();
        };

        const stopDrag = (e) => {
          e.stopPropagation();
          if (stampNode.offsetWidth / 2 + wrapperLeft < 0 || stampNode.offsetHeight / 2 + wrapperTop < 0) {
            console.log('');
          } else {
            baseWidth = stampNode.offsetWidth;
            baseHeight = stampNode.offsetHeight;
          }
          stampNode.innerHTML = this.generateStampContentWidthHeight(Number(stampNode.offsetWidth), Number(stampNode.offsetHeight), signType, !!signPositionData.isNew);
          this.signPosition = this.signPosition.map(position => {
            if ((position.id === id) && position.fileId === fileId) {
              position.width = stampNode.offsetWidth;
              position.height = stampNode.offsetHeight;
            }
            return position;
          });
          this.imageData = this.imageData.map(position => {
            if ((position.id === id) && position.fileId === fileId) {
              position.widthRectangle = stampNode.offsetWidth;
              position.heightRectangle = stampNode.offsetHeight;
            }
            return position;
          });
          rerenderSign();
          document.documentElement.removeEventListener('mousemove', doDrag);
          document.documentElement.removeEventListener('mouseup', stopDrag);
        };
      }
      //    resize element
    }
    return stampNode;
  }

  // generate chữ ký Resize
  generateStampContentWidthHeight(widthRect: number, heightRect: number, signType: string, canNotMove: boolean): string {
    let contentNode: string;
    const padding = 10;
    const zoom = this.zoomLevel / 100;
    let widthRectangle = widthRect * zoom;
    let heightRectangle = heightRect * zoom;
    widthRectangle -= padding * zoom * 2;
    heightRectangle -= padding * zoom * 2;
    let height = widthRectangle;
    let width = heightRectangle;
    const ratio = this.imagePreviewWidth / this.imagePreviewHeight;
    if (this.imagePreviewWidth > this.imagePreviewHeight) {
      width = widthRectangle;
      height = width / ratio;
      if (height > heightRectangle) {
        height = heightRectangle;
        width = height * ratio;
      }
    } else {
      height = heightRectangle;
      width = height * ratio;
    }
    const heightPx = `${height}px`;
    const widthPx = `${width}px`;

    this.cd.detectChanges();
    if (signType === SignPositionTypes.DIGITAL) {
      contentNode = `<div></div>`;
    } else {
      if (this.systemImageSign) {
        contentNode = `
                    <i class="fa fa-undo" aria-hidden="true"
                        style="
                            display: ${this.canMoveAndResize && !canNotMove ? '' : 'none'};
                            font-size: ${15 * zoom}px;
                            position: absolute; top: 5px; right: 5px;
                            cursor: move;
                            height: unset;
                            width: unset;
                            color: red;
                            z-index: 100;">
                        </i>
                    <img draggable="false"
                        src="${this.imageUrlPreview}"
                        style="
                            transform: scale(${this.signConfig.signaturePosition.value === 'top' || this.signConfig.signaturePosition.value === 'bottom' ? (heightRectangle + 20) / this.heightImageRender : (widthRectangle + 20) / this.widthImageRender});
                            display: flex;
                            justify-content: flex-end;
                            align-items:
                            flex-start;
                            object-fit: cover;"/>
                 `;
      } else {
        if (this.imageUrlPreview) {
          contentNode = `
                    <i class="fa fa-undo" aria-hidden="true"
                        style="
                            display: ${this.canMoveAndResize && !canNotMove ? '' : 'none'};font-size: ${15 * zoom}px;
                            position: absolute; top: 5px; right: 5px;
                            cursor: move;
                            height: unset;
                            width: unset;
                            color: red;
                            z-index: 100;">
                        </i>
                        <img draggable="false"
                            src="${this.imageUrlPreview}"
                            style="
                                height: ${heightPx};
                                width: ${widthPx};
                                max-width: ${this.signConfig.signaturePosition.value === 'left' || this.signConfig.signaturePosition.value === 'right' ? '1386px' : 'none'}; max-height: ${this.signConfig.signaturePosition.value === 'top' || this.signConfig.signaturePosition.value === 'bottom' ? '538px' : 'none'};
                                margin: auto;
                                display: flex;
                                justify-content:
                                flex-end;
                                align-items: flex-start;"/>
                          `;
        } else {
          contentNode = `
                    <i class="fa fa-undo" aria-hidden="true"
                        style="
                            display: ${this.canMoveAndResize && !canNotMove ? '' : 'none'};font-size: ${15 * zoom}px;
                            position: absolute; top: 5px; right: 5px;
                            cursor: move;
                            height: unset;
                            width: unset;
                            color: red;
                            z-index: 100;">
                        </i>
                        <div style="color: #EE0033; text-align: center;">
                            ${this.translateService.instant('enterprise_contract.image_signing.no_image.no_select_image_signature')}
                        </div>
                          `;
        }

      }
    }

    return contentNode;
  }

  // generate chữ ký origin
  generateStampContent() {
    let contentNode: string;
    const padding = 10;
    const zoom = this.zoomLevel / 100;
    let widthRectangle = this.widthRectangle * zoom;
    let heightRectangle = this.heightRectangle * zoom;

    widthRectangle -= padding * zoom * 2;
    heightRectangle -= padding * zoom * 2;

    let height = widthRectangle;
    let width = heightRectangle;
    const ratio = this.imagePreviewWidth / this.imagePreviewHeight;
    if (this.imagePreviewWidth > this.imagePreviewHeight) {
      width = widthRectangle;
      height = width / ratio;
      if (height > heightRectangle) {
        height = heightRectangle;
        width = height * ratio;
      }
    } else {
      height = heightRectangle;
      width = height * ratio;
    }

    const heightPx = `${height}px`;
    const widthPx = `${width}px`;
    let contentInsideNode = '';
    if (this.systemImageSign) {
      contentInsideNode = `
                <img draggable="false" src="${this.imageUrlPreview}" style="transform: scale(${this.signConfig.signaturePosition.value === 'top' || this.signConfig.signaturePosition.value === 'bottom' ? (heightRectangle + 20) / this.heightImageRender : (widthRectangle + 20) / this.widthImageRender}); display: flex; justify-content: flex-end; align-items: flex-start; object-fit: cover;"/>
         `;
    } else {
      if (this.imageUrlPreview) {
        contentInsideNode = `
                    <img draggable="false" src="${this.imageUrlPreview}" style="height: ${heightPx};width: ${widthPx}; max-width: ${this.signConfig.signaturePosition.value === 'left' || this.signConfig.signaturePosition.value === 'right' ? '1386px' : 'none'}; max-height: ${this.signConfig.signaturePosition.value === 'top' || this.signConfig.signaturePosition.value === 'bottom' ? '538px' : 'none'}; margin: auto; display: flex; justify-content: flex-end; align-items: flex-start;"/>
                  `;
      } else {
        contentInsideNode = `
                <div style="color: #EE0033; text-align: center;">
                    ${this.translateService.instant('enterprise_contract.image_signing.no_image.no_select_image_signature')}
                </div>
                `
      }

    }

    // tslint:disable-next-line:max-line-length
    contentNode = `
            <div id="notify_outside" style="position: absolute;top: -40px;left: 33px;color: red;">${this.translateService.instant('messages.click_to_select_sign_position')}</div>
            ${contentInsideNode}`;

    return contentNode;
  }

  gotoSignPageNumber(signPage: number) {
    this.pageCurrent = signPage;
  }

  async convertHtmlToImage() {
    let imgUrl = "";
    let file = null;

    this.cd.detectChanges();

    try {
      const imageSize = this.setSizeFrameImage();
      if (this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_OTP && localStorage.getItem('entTypeAnonymus') != '2') {
        this.signConfig.confirmBy.enabled = true;
      } else {
        this.signConfig.confirmBy.enabled = false;
      }
      const rs = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
      file = new File([rs], 'signatureImage.png', {type: 'image/png'});
      imgUrl = await this.commonService.getBase64(file) as string;
    } catch (e) {
      console.log("call api error, use html to image", e);
      const imageFile = await htmlToImage.toBlob(this.domRenderImage.nativeElement);
      file = new File([imageFile], 'signatureImage.png', {type: 'image/png'});
      imgUrl = await htmlToImage.toPng(this.domRenderImage.nativeElement);

    }

    this.fileUpload = file;
    this.fileUploadDefault = file;
    this.signatureImageDefault = imgUrl;
    this.signatureFileDefault = file;

    this.setFontSize(imageConfigViewScaleId);
    this.setFontSize(imageConfigRenderId);
    setTimeout(() => {
      this.documentService.setImageSignature({
        url: imgUrl,
        fileUpload: file
      });
    }, 100);
    if (this.fileUpload) {
      this.handlePreviewFromFileUpload(this.fileUpload);
    }
  }


  // -----------------------------------------------------------

  // end fn group PDF

  // start fn group signature image
  nzSelectChange(index = 0) {
    const indexSystemTab = 0;
    const indexUploadTab = this.isDisplaySignatureTab(1) ? 1 : 0;
    const indexDrawTab = this.isDisplaySignatureTab(1) ? 2 : (this.isDisplaySignatureTab(2) ? 1 : 0);
    this.indexSelect = index;
    if (this.selectedCert.typeCertificate !== this.enumSignMethod.SIGN_NO_CERT) {
      if (index === indexDrawTab) {
        this.activeImageSource = 'draw';
        this.isSelectDrawImage = true;
        this.systemImageSign = false;
        this.isUploadImage = false;
        this.imagePreviewWidth = 0;
        this.imagePreviewHeight = 0;
        this.canvasService.canvasImage.subscribe((imgUpload) => {
          if (imgUpload) {
            this.fileUpload = imgUpload;
            this.fileUploadDraw = imgUpload;
          }
        });
        this.canvasService.setCanvasSignatureImageUrl(this.signatureImageDraw);
        this.canvasService.setIsApplyDrawSignature(!!this.signatureImageDraw);
      } else if (index === indexUploadTab) {
        this.activeImageSource = 'upload';
        this.systemImageSign = false;
        this.isSelectDrawImage = false;
        this.isUploadImage = true;
        this.imagePreviewWidth = 0;
        this.imagePreviewHeight = 0;
        this.canvasService.setIsApplyDrawSignature(false);
        if (this.selectedCert.imageUrl && this.isDisplaySignatureTab(2)) {
          fetch(this.selectedCert.imageUrl)
            .then(r => r.blob())
            .then(blobFile => {
              this.fileUpload = new File([blobFile], 'fileNameGoesHere', {type: 'image/png'});
              this.fileUploadUpload = this.fileUpload;
              if (this.fileUpload) {
                this.handlePreviewFromFileUpload(this.fileUpload, true);
              }
            });
        } else {
          this.avatarUrl = null;
          this.imageUrlPreview = null;
          setTimeout(() => {
            this.reRenderSignature()
          }, 100);
        }
      } else {
        this.activeImageSource = 'default';
        this.systemImageSign = true;
        this.isSelectDrawImage = false;
        this.isUploadImage = false;
        this.canvasService.setIsApplyDrawSignature(false);
        if (!this.selectedCert.imageUrl) {
          this.avatarUrl = null;
        }
        this.setFontSize(imageConfigViewScaleId);
        this.setFontSize(imageConfigRenderId);
        setTimeout(() => {
          this.documentService.setImageSignature({
            url: this.signatureImageDefault,
            fileUpload: this.signatureFileDefault
          });
        }, 100);
        if (this.signatureFileDefault) {
          this.handlePreviewFromFileUpload(this.fileUpload);
          this.fileUploadDefault = this.fileUpload;
        } else {
          this.convertHtmlToImage();
        }
      }
    } else {
      if (index === indexUploadTab) {
        this.activeImageSource = 'upload';
        this.systemImageSign = false;
      }

      if (index === indexSystemTab) {
        this.activeImageSource = 'default';
        this.systemImageSign = true;
        this.fileUpload = null;
        this.avatarUrl = null;
        this.imageUrlPreview = '';
        setTimeout(() => {
          this.setFontSize(imageConfigViewScaleId);
          this.setFontSize(imageConfigRenderId);
        }, 100);
      }
    }
  }

  isDisplaySignatureTab(value): boolean {
    const userType = localStorage.getItem('userType');
    let currentValue = '';
    switch (value) {
      case 1:
        currentValue = 'default_image';
        break;
      case 2:
        currentValue = 'download_sign_image';
        break;
      case 3:
        currentValue = 'draw_sign_image';
        break;
    }
    if (userType == '3' || userType == '4' || userType == '5' || this.isCustomer) {
      if (this.customerImagesConfig.includes(currentValue)) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  handlePreview = async (file: NzUploadFile) => {
    if (!file.url && !file.preview) {
      // tslint:disable-next-line:no-non-null-assertion
      file.preview = await this.commonService.getBase64(file.originFileObj!);
    }
  }

  dummyRequest = ({file, onSuccess, onError}) => {
    this.fileUpload = file;
    this.fileUploadUpload = file;
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  }

  handleChange(info: { file: NzUploadFile }): void {
    // this.isFormChanging = true;
    switch (info.file.status) {
      case 'uploading':
        this.loading = true;
        break;
      case 'done':
        // Get this url from response in real world.
        // tslint:disable-next-line:no-non-null-assertion
        this.commonService.getBase64Avatar(info.file!.originFileObj!, (imgUrl: string) => {
          this.loading = false;
          // tslint:disable-next-line:radix
          const img = new Image();
          // Set the src attribute to your URL
          img.src = imgUrl;
          this.imagePreviewWidth = img.width;
          this.imagePreviewHeight = img.height;
          // When the image is loaded, read the available properties
          this.avatarUrl = imgUrl;
          this.imageUrlPreview = imgUrl;
          this.signatureImageUpload = imgUrl;
          this.fileUploadUpload = this.fileUpload;
          this.documentService.setImageSignature({
            url: imgUrl,
            fileUpload: this.fileUpload
          });
        });
        break;
      case 'error':
        this.toastr.error('Network error');
        this.loading = false;
        break;
    }
  }

  onSelectDrawSign() {
    this.canvasService.setIsSelectSignDraw(true);
    this.canvasService.setIsApplyDrawSignature(!!this.signatureImageDraw);
  }

  getConfigKeyList(): string[] {
    return Object.keys(this.signConfig);
  }

  confirmBy: string;

  getUserConfig() {
    this.signDocumentService.getUserConfigAsync(true)
      .pipe(tap(res => {
          if (res.success && res.data) {
            // for (const key in this.signConfig) {
            //   this.signConfig[key].enabled = false;
            // }

            // this.signConfig.enterpriseName.enabled = true;
            // this.signConfig.greenTick.enabled = true;

            // this.signConfig.address.enabled = true;
            // this.signConfig.address.value = res.data['addressDetail'] || '';

            // this.confirmBy = res.data['signature'] || '';

            // if (this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_OTP && localStorage.getItem('entTypeAnonymus') != '2') {
            //   this.signConfig.confirmBy.enabled = true;
            //   this.signConfig.confirmBy.value = this.confirmBy;
            // }
            console.log(res.data);
            this.hasSavedUserConfig = true;
            for (const key in this.signConfig) {
              this.signConfig[key].enabled = res.data[key] || false;
            }

            this.signConfig.enterpriseName.value = this.enterpriseName;

            this.signConfig.address.value = res.data["addressDetail"] || "";
            this.signConfig.position.value = res.data["positionDetail"] || "";
            this.signConfig.confirmBy.value = res.data["signature"] || "";
            this.signConfig.fontFamily.value = res.data["fontFamily"] || "";
            this.signConfig.fontWeight.value = res.data["fontWeight"] || "";
            this.signConfig.fontStyle.value = res.data["fontStyle"] || "";
            this.signConfig.signatureImageBase64.value =
              res.data["signatureImageBase64"] || "";
            this.signConfig.signatureImageName.value =
              res.data["signatureImageName"] || "";
            this.signConfig.signaturePosition.value =
              res.data["signaturePosition"] || "";
            this.signConfig.signatureRatio.value =
              res.data["signatureRatio"] || "";

            this.signConfig.fontFamily.enabled = false;
            this.signConfig.fontWeight.enabled = false;
            this.signConfig.fontStyle.enabled = false;
            this.signConfig.signatureImageBase64.enabled = false;
            this.signConfig.signatureImageName.enabled = false;
            this.signConfig.signaturePosition.enabled = false;
            this.signConfig.signatureRatio.enabled = false;
            this.signConfig.contentPosition.value =
              res.data["contentPosition"] === "false"
                ? ContentPosition.left
                : res.data["contentPosition"];
            this.signConfig.contentPosition.enabled = false;
            this.signConfigPhoneNumber = this.signConfig.phoneNumber.enabled
            this.confirmBy = res.data['signature'] || '';

            if (this.selectedCert.typeCertificate === this.enumSignMethod.SIGN_OTP && localStorage.getItem('entTypeAnonymus') != '2') {
              this.signConfig.confirmBy.enabled = true;
              this.signConfig.confirmBy.value = this.confirmBy;
            }
            console.log(this.signConfig);
          }
        }),
        switchMap(() => {
          return forkJoin({
            email: this.signDocumentService.getEmailAnonymousAsync(this.hashKey),
            date: this.signDocumentService.getDateAsync()
          });
        })
      ).subscribe(res => {
      if (res) {
        this.signConfig.signingTime.value = res.date.success ? res.date.data.date : ''
        this.signConfig.email.value = res.email.success ? res.email.data : ''
        this.hasSignConfigs = true;
        this.applyDefaultTypeConfig();
        this.convertHtmlToImage();
        this.cd.detectChanges();
        setTimeout(() => {
          this.setFontSize(imageConfigViewScaleId);
          this.setFontSize(imageConfigRenderId);
        }, 100);
      }
    })
  }

  showConfig(key: string): boolean {
    if (key === 'greenTick') {
      return false
    }

    if (this.selectedCert.typeCertificate !== this.enumSignMethod.SIGN_OTP) {
      if (key === 'phoneNumber') {
        this.signConfig.phoneNumber.enabled = false;
        return false;
      }
      if (key === 'confirmBy') {
        this.signConfig.confirmBy.enabled = false;
        return false;
      }
      if (key === 'signatureImage') {
        return false;
      }

      if (key === 'isDraw') {
        return false;
      }
    } else {
      if (key === 'confirmBy' && localStorage.getItem('entTypeAnonymus') != '2') {
        this.signConfig.confirmBy.enabled = true;
        return true;
      } else if (key === 'confirmBy' && localStorage.getItem('entTypeAnonymus') == '2') {
        this.signConfig.confirmBy.enabled = false;
        return false;
      }

      if (key === 'signatureImage') {
        return false;
      }

      if (key === 'isDraw') {
        return false;
      }
    }

    return this.signConfig[key].enabled;
  }

  getNumber(value: any) {
    return value.split(':') || [];
  }

  setSizeFrameImage() {
    switch (this.signConfig.signaturePosition.value) {
      case 'left':
      case 'right':
        return {
          width: '370px',
          height: '136px'
        };
      case 'top':
      case 'bottom':
        return {
          width: '300px',
          height: '237px'
        };

      default:
        return {
          width: '300px',
          height: '136px'
        };
    }
  }

  setFontSize(id: string) {
    const listElement: any = document.getElementsByClassName(id);
    for (let el of listElement) {
      if (!el) {
        return;
      }
      el.style.wordBreak = 'break-word';
      if (id === imageConfigViewScaleId) {
        if (el && el.lastElementChild && el.lastElementChild.lastElementChild)
          el = el.lastElementChild.lastElementChild as HTMLElement;
      }

      if (el) {
        let fontSize = 56;
        let minSize = 32;
        let padding = 40;
        if (id === imageConfigFormPreviewId) {
          fontSize /= 4;
          minSize /= 4;
          padding /= 4;
        }

        el.style.fontSize = fontSize + 'px';

        let parent;
        if (this.signConfig.signaturePosition.value === 'top' || this.signConfig.signaturePosition.value === 'bottom') {
          parent = el.parentElement;
        } else {
          parent = el.parentElement.parentElement;
        }
        const parentHeight = parent.offsetHeight;
        let height = el.offsetHeight;

        while (height > parentHeight - padding && fontSize > minSize) {
          if (id === imageConfigFormPreviewId) {
            fontSize -= 1 / 4;
          } else {
            fontSize--;
          }
          el.style.fontSize = fontSize + 'px';
          height = el.offsetHeight;
        }
      }
    }
  }

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  // end fn group signature image

  // start fn group sign

  setTimetamMoney() {
    if (this.isSelectedPosition.getValue() && (this.isShowImage || !this.isSignDigitalCertificate)) {
      this.toastr.error(this.message.getMessage('messages.need_choose_position'));
      this.blockUI.stop();
      this.blockUIStop = true;
      return;
    } else {
      this.blockUIStop = false;
    }
    if (this.document.mainContractAttachments && this.document.mainContractAttachments.length && (this.isShowImage || !this.isSignDigitalCertificate)) {
      const fileName = [];
      let indexError = null;
      let filePathError = null;
      const fileError = [];
      this.document.mainContractAttachments.forEach((ca, index) => {
        const fileId = this.decodeId(ca.id);
        const hasImage = this.signPosition.some(e => e.signType === SignPositionTypes.IMAGE);
        const sign = this.signPosition.filter(signData => {
          if (signData.fileId === fileId) {
            if (hasImage) {
              if (signData.signType !== SignPositionTypes.DIGITAL) {
                return signData;
              }
            } else {
              return signData;
            }
          }

        });
        if (!sign.length) {
          if (!indexError) {
            indexError = index;
            filePathError = ca.path;
          }
          fileError.push(ca.id);
          fileName.push(`'${ca.fileName}'`);
        }
      });
      if (fileName.length) {
        this.changeFile(filePathError, indexError);
        this.fileError = fileError;
        this.toastr.error(this.commonService.format(this.message.getMessage('messages.need_create_sign_file'), fileName.join(', ')).replace(/&quot;/g, "'"));
        this.blockUI.stop();
        this.blockUIStop = true;
        return;
      } else {
        this.blockUIStop = false;
      }
    }

    if (this.saveImageData.length == 0) {
      this.saveImageData = _.cloneDeep(this.imageData);
    } else
      this.imageData = this.saveImageData;

    const positionConvert = [];
    if (this.imageData && this.imageData.length > 0) {
      this.imageData.forEach(pos => {
        positionConvert.push({
          positionY: pos.positionY,
          pageNumber: pos.pageNumber,
          positionX: pos.positionX,
          widthRectangle: pos.widthRectangle,
          heightRectangle: pos.heightRectangle,
          signType: "combine"
        });
      });
    }
    if (this.checkPersonalVerify && !this.showCheckVerifySubject) {
      this.sign = {
        ...this.selectedCert,
        hashKey: this.hashKey,
        tenantId: this.tenantId,
        phoneNumber: this.simCaPhoneNumber,
        contractId: this.document.id,
        isVerifySubject: true
      };
    } else {
      this.sign = {
        ...this.selectedCert,
        hashKey: this.hashKey,
        tenantId: this.tenantId,
        phoneNumber: this.simCaPhoneNumber,
        contractId: this.document.id,
      };
    }


    if (this.typeCertificate === this.enumSignMethod.SIGN_OTP) {
      this.sign.phoneNumber = this.otpPhoneNumber;
    }
    let preImageSort = [];
    for (const contractAttachment of this.document.mainContractAttachments) {
      const fileId = this.decodeId(contractAttachment.id);
      if (!this.isShowImage && this.isSignDigitalCertificate) {
        let imageData = [
          {
            positionX: 1,
            positionY: 1,
            pageNumber: 1,
            signType: "image",
            widthRectangle: 0,
            heightRectangle: 0,
            zoom: 1,
            fileId: fileId,
          }
        ]
        preImageSort = preImageSort.concat(imageData);
      } else {
        const hasImage = this.imageData.some(e => e.signType === SignPositionTypes.IMAGE);
        const imageData = this.imageData.filter((signDataImage: any) => {
          if (signDataImage.fileId === fileId) {
            if (hasImage) {
              if (signDataImage.signType !== SignPositionTypes.DIGITAL) {
                return signDataImage;
              }
            } else {
              return signDataImage;
            }
          }
        });
        preImageSort = preImageSort.concat(imageData);
      }
    }
    const imageSort = _.cloneDeep(preImageSort);
    let imageData = []
    const arr1 = [];
    for (let i = 0; i < imageSort.length; i++) {
      for (let j = 0; j < imageSort.length; j++) {
        if (i !== j && imageSort[j].positionX == imageSort[i].positionX
          && imageSort[j].positionY == imageSort[i].positionY
          && imageSort[j].pageNumber == imageSort[i].pageNumber
          && imageSort[j].widthRectangle == imageSort[i].widthRectangle
          && imageSort[j].heightRectangle == imageSort[i].heightRectangle
          && imageSort[j].zoom == imageSort[i].zoom
          && imageSort[j].fileId == imageSort[i].fileId
          && imageSort[j].signType !== imageSort[i].signType) {
          if (imageSort[j].signType == 'image') {
            arr1.push(imageSort[j])
          } else {
            arr1.push(imageSort[i])
          }
          imageSort.splice(j, 1);
          imageSort.splice(i, 1);
          i--;
          break;
        }
      }
    }
    imageData = ([...imageSort, ...arr1]);
    let imagePreSort = [];
    for (const contractAttachment of this.document.mainContractAttachments) {
      const fileId = this.decodeId(contractAttachment.id);
      let imageList = imageData.filter(item => {
        return item.fileId === fileId
      });
      imageList = imageList.sort((a, b) => a.pageNumber === b.pageNumber ?
        Number(b.positionY) - Number(a.positionY) :
        Number(a.pageNumber) - Number(b.pageNumber));
      imagePreSort = imagePreSort.concat(imageList);
    }
    this.signImages = imagePreSort.map((item) => {
      item['code'] = uuid.v4();
      return item;
    })
    this.signProcessing = JSON.parse(JSON.stringify(this.signImages));
  }

  getBodyTimeStampMoney() {
    const body = {
      signMethod: this.typeCertificate,
      hashKey: this.hashKey,
      tenantId: this.tenantId,
      contractId: this.document.id,
      signPositions: this.signImages
    }
    if (this.contractIdAndContractEnterpriseIdEncode) {
      body['hashLink'] = this.contractIdAndContractEnterpriseIdEncode;
    }
    return body;
  }

  callSignButton(tmpl?: TemplateRef<any>) {
    if(this.checkErrorConfigDefault()){
      return;
    }
    if (this.showCheckVerifySubject == false && !this.isSignDigitalCertificate && this.checkPersonalVerify) {
      if (this.typeCertificate != this.enumSignMethod.SIGN_OTP && !this.validateIsVerifySubject()) {
        return;
      }
      this.onClickNavigateSignFlow(tmpl); // moi
    } else {
      this.checkTimestampMoney(tmpl); //luong cu
    }
  }

  async checkTimestampMoney(tmpl?: TemplateRef<any>) {

    if (this.contractIdAndContractEnterpriseIdEncode) {
      this.checkExpireTime();
    }
    if (this.typeCertificate === this.enumSignMethod.SIGN_OTP
      || this.typeCertificate === this.enumSignMethod.SIGN_EKYC
      || this.typeCertificate === this.enumSignMethod.SIGN_EKYC_ADVANCED) {
      if (this.digitalCertificateService.formatPhoneNumber(this.otpPhoneNumber).trim().length < 11
        || this.digitalCertificateService.formatPhoneNumber(this.otpPhoneNumber).trim().length >= 15) {
        this.toastr.error(this.message.getMessage('lading_page.main.contact.validate_form.otp_phone_min_length'));
        return;
      }
    }
    // check simCA hoặc Usb token

    if (this.typeCertificate === this.enumSignMethod.SIGN_SIM_CA
      || this.typeCertificate === this.enumSignMethod.SIGN_USB_TOKEN
      || this.typeCertificate === this.enumSignMethod.VNEID
      || this.typeCertificate === this.enumSignMethod.CLOUD_CA) {
      if (this.typeCertificate === this.enumSignMethod.SIGN_SIM_CA
        || this.typeCertificate === this.enumSignMethod.CLOUD_CA) {
        if (this.signDataValidate != null) {
          // check mã số thuế
          if (this.signDataValidate.checkCertNumber) {
            if (this.selectedCert.taxCode.length > 0 &&
              (this.selectedCert.taxCode.toUpperCase() === this.signDataValidate.certificateNo.toUpperCase() ||
                (this.signDataValidate.representDocumentNumber && this.selectedCert.taxCode.toUpperCase() === this.signDataValidate.representDocumentNumber.toUpperCase()) ||
                (this.signDataValidate.taxCode && this.selectedCert.taxCode.toUpperCase() === this.signDataValidate.taxCode.toUpperCase()))) {
              // next step
            } else {
              this.toastr.error(this.message.getMessage('messages.digital_certificate_validate_taxCode'));
              return false;
            }
          }
          // check name
          if (this.signDataValidate.checkName) {
            // status = 2 là đang xử lý
            const enterpriseProcessing = this.listEnterprise.filter(enter => enter.isCurrent);
            const enterpriseName = enterpriseProcessing[0].enterpriseName;
            if (enterpriseName && (this.selectedCert.certificateName.toUpperCase() !== enterpriseName.toUpperCase())) {
              this.toastr.error(this.message.getMessage('messages.digital_certificate_validate_name'));
              return false;
            }
          }
        }
      } else if(this.typeCertificate === this.enumSignMethod.VNEID) {
        if (this.signDataValidate) {
          if (this.signDataValidate.checkCertNumber) {
            if (this.selectedCert.identifier.length > 0 &&
              (this.selectedCert.identifier.toUpperCase() === this.signDataValidate.certificateNo.toUpperCase() ||
                (this.signDataValidate.representDocumentNumber && this.selectedCert.identifier.toUpperCase() === this.signDataValidate.representDocumentNumber.toUpperCase()) ||
                (this.signDataValidate.taxCode && this.selectedCert.identifier.toUpperCase() === this.signDataValidate.taxCode.toUpperCase()))) {
              // next step
            } else {
              this.toastr.error(this.message.getMessage('messages.digital_certificate_validate_taxCode'));
              return false;
            }
          }
          // check name
          if (this.signDataValidate.checkName) {
            // status = 2 là đang xử lý
            const enterpriseProcessing = this.listEnterprise.filter(enter => enter.isCurrent);
            const enterpriseName = enterpriseProcessing[0].enterpriseName;
            if (enterpriseName && (this.selectedCert.subjectDN.toUpperCase() !== enterpriseName.toUpperCase())) {
              this.toastr.error(this.message.getMessage('messages.digital_certificate_validate_name'));
              return false;
            }
          }
        }
      } else {
        if (this.signDataValidate) {
          if (this.signDataValidate.checkCertNumber) {
            const taxCode = this.usbTokenCertificate.taxCode;
            const validateInfo = this.decodeTaxCode(taxCode);
            if (validateInfo.length > 0 && (validateInfo.toUpperCase() === this.signDataValidate.certificateNo.toUpperCase() ||
              (this.signDataValidate.representDocumentNumber && validateInfo.toUpperCase() === this.signDataValidate.representDocumentNumber.toUpperCase()) ||
              (this.signDataValidate.taxCode && validateInfo.toUpperCase() === this.signDataValidate.taxCode.toUpperCase()))) {
            } else {
              this.toastr.error(this.message.getMessage('messages.digital_certificate_validate_taxCode'));
              return false;
            }
          }
          // check name
          if (this.signDataValidate.checkName) {
            // status = 2 là đang xử lý
            const enterpriseProcessing = this.listEnterprise.filter(enter => enter.isCurrent);
            const enterpriseName = enterpriseProcessing[0].enterpriseName;
            if (enterpriseName && (this.usbTokenCertificate.issuedTo.toUpperCase() !== enterpriseName.toUpperCase())) {
              this.toastr.error(this.message.getMessage('messages.digital_certificate_validate_name'));
              return false;
            }
          }
        }
      }
    }

    // check OTP
    if (this.typeCertificate === this.enumSignMethod.SIGN_OTP) {
      if (this.signDataValidate) {
        if (this.signDataValidate.checkOtp) {
          // status = 2 là đang xử lý
          const enterpriseProcessing = this.listEnterprise.filter(enter => (enter.status === 2 || enter.status === 6) && (enter.enterpriseId === this.enterpriseSignIdInFlow || enter.customerId === this.enterpriseSignIdInFlow));
          const enterprisePhone = enterpriseProcessing[0].enterprisePhone;
          if (enterprisePhone && (this.digitalCertificateService.formatPhoneNumber(this.otpPhoneNumber) !== this.digitalCertificateService.formatPhoneNumber(enterprisePhone))) {
            const message = this.commonService.format(this.message.getMessage('messages.digital_certificate_validate_phone'), enterprisePhone);
            this.toastr.error(message);
            return false;
          }
        }
      }
    }

    let isPassEKYC = false;
    let isValidatedSupportCertificate = false;
    let typeSupportEKYC = this.typeCertificate === this.enumSignMethod.SIGN_OTP
      || this.typeCertificate === this.enumSignMethod.SIGN_NO_CERT;
    let isSignEkyc = this.typeCertificate === this.enumSignMethod.SIGN_EKYC
      || this.typeCertificate === this.enumSignMethod.SIGN_EKYC_ADVANCED
    if (typeSupportEKYC) {
      if (this.supportEkyc && this.isPersonal) {
        isValidatedSupportCertificate = true;
        if (+this.signDataValidate.certificateId === CertificateTypeID.CCCD
          || +this.signDataValidate.certificateId === CertificateTypeID.CMTND
          || +this.signDataValidate.certificateId === CertificateTypeID.HO_CHIEU) {
          this.isShowEKYC = true;
          isPassEKYC = await this.getQuantityEkycBeforeNext().toPromise().then()
        } else this.isShowEKYC = false;
      } else this.isShowEKYC = false;
    } else {
      if (isSignEkyc) {
        if (this.isPersonal) {
          isValidatedSupportCertificate = true;
          if (+this.signDataValidate.certificateId === CertificateTypeID.CCCD
            || +this.signDataValidate.certificateId === CertificateTypeID.CMTND
            || +this.signDataValidate.certificateId === CertificateTypeID.HO_CHIEU) {
            this.isShowEKYC = true;
            isPassEKYC = await this.getQuantityEkycBeforeNext().toPromise().then()
          } else this.isShowEKYC = false;
        } else this.isShowEKYC = false;
      } else this.isShowEKYC = false;
    }
    if (isValidatedSupportCertificate) {
      if (!this.isShowEKYC) {
        this.toastr.error(this.message.getMessage('digital_certificate_management.certificate_not_support'))
        return
      }
    }

    if (this.isSelectedPosition.getValue() && (this.isShowImage || !this.isSignDigitalCertificate)) {
      this.toastr.error(this.message.getMessage('messages.need_choose_position'));
      this.blockUI.stop();
      return;
    }

    // tab vẽ chữ ký: chặn ký khi nét vẽ mới chưa được Áp dụng
    if (this.isSelectDrawImage && !this.canvasService.isApplyDrawSignatureValue) {
      this.toastr.error(this.message.getMessage('validation.draw_sign_valid_empty'));
      this.blockUI.stop();
      return;
    }

    if (this.isShowEKYC) {
      if (this.isOutOfSmsMoney) {
        this.openDialogOutOfMoneyOtp(this.message.getMessage('messages.otp_out_of_money'));
        return;
      }
    }

    if (this.isShowEKYC && !isPassEKYC) {
      this.toastr.error(this.message.getMessage('digital_certificate_management.quantity_ekyc_not_enough'));
      return
    }

    if (this.isShowEKYC && isPassEKYC) {
      if (this.ekyc.errors.length > 0) {
        this.toastr.error(this.message.getMessage('kyc.camera_errors'));
        return
      }
    }

    if (this.isShowEKYC && isPassEKYC && !this.ekyc.errors.length) {
      this.openDialogSignEKYC(tmpl);
      return;
    } else {
      await this.signFlowDocument();
    }
  }

  async signFlowDocument() {
    if (this.contractIdAndContractEnterpriseIdEncode) {
      this.anonymousSignService.checkExpireTime(this.hashKey, this.tenantId, this.contractIdAndContractEnterpriseIdEncode).subscribe(async res => {
        this.checkDisplayMessageError(res.code);
        this.setTimetamMoney();
        if (this.blockUIStop) {
          this.blockUI.stop();
          return;
        }
        if (this.isShowEKYC) {
          this.onIdentityEKYC();
        } else if (this.typeCertificate === this.enumSignMethod.SIGN_OTP) {
          if (!this.isShowEKYC) {
            this.processSignOTP();
          }
        } else {
          this.blockUI.reset();
          this.blockUI.start('');
          if (this.document.isConfirmBCT && this.typeCertificate !== this.enumSignMethod.SIGN_USB_TOKEN) {
            this.anonymousSignService.createTimestampMoney(this.getBodyTimeStampMoney()).subscribe(
              res => {
                this.checkDisplayMessageError(res.code);
                this.blockUI.stop();
                if (res && !res.success) {
                  if (res.code === ErrorCode.NotEnoughMoneyTimestamp)
                    this.openDialogOutOfMoneyOtp(this.message.getMessage('digital_certificate_management.out_of_money_timestamp'));
                  else
                    this.toastr.error(res.message)
                } else {
                  this.signTransactionId = res.data;
                  this.onClickSignButton()
                }
              }
            )
          } else {
            this.blockUI.reset();
            this.blockUI.start('');

            // gọi api
            if (this.systemImageSign) {
              const date = await this.signDocumentService.getDateAsync().toPromise();
              const email = await this.signDocumentService.getEmailAnonymousAsync(this.hashKey).toPromise();

              this.signConfig.signingTime.value = date.data.date;
              this.signConfig.email.value = email.data;
              let blob = null;
              try {
                let imageSize = this.setSizeFrameImage();
                blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
              } catch (e) {
                console.log("call api error, use html to image", e);
                try {
                  let imageSize = this.setSizeFrameImage();
                  blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
                } catch (e) {
                  console.log("call api error, use html to image", e);
                }
              }

              if (!blob) {
                this.toastr.error(this.message.getMessage('messages.error_proccessing'));
                return;
              }

              const file = new File([blob], 'lastImage.png', {type: 'image/png'});
              this.fileUpload = file;
              this.fileUploadDefault = file;
            }

            if (this.document.isConfirmBCT) {
              this.anonymousSignService.createTimestampMoney(this.getBodyTimeStampMoney()).subscribe(
                res => {
                  this.checkDisplayMessageError(res.code);
                  this.blockUI.stop();
                  if (res && !res.success) {
                    if (res.code === ErrorCode.NotEnoughMoneyTimestamp)
                      this.openDialogOutOfMoneyOtp(this.message.getMessage('digital_certificate_management.out_of_money_timestamp'));
                    else
                      this.toastr.error(res.message)
                  } else {
                    this.signTransactionId = res.data;
                    this.onClickSignButton()
                  }
                }
              )
            } else {
              this.blockUI.stop();
              this.onClickSignButton()
            }
          }
        }
      });
    } else {
      this.setTimetamMoney();
      if (this.blockUIStop) {
        this.blockUI.stop();
        return;
      }
      if (this.isShowEKYC) {
        this.onIdentityEKYC();
      } else if (this.typeCertificate === this.enumSignMethod.SIGN_OTP) {
        if (this.isShowEKYC) {

        } else {
          this.processSignOTP()
        }
      } else {
        this.blockUI.reset();
        this.blockUI.start('');


        // gọi api
        if (this.systemImageSign) {
          const date = await this.signDocumentService.getDateAsync().toPromise();
          const email = await this.signDocumentService.getEmailAnonymousAsync(this.hashKey).toPromise();

          this.signConfig.signingTime.value = date.data.date;
          this.signConfig.email.value = email.data;
          let blob = null;
          try {
            let imageSize = this.setSizeFrameImage();
            blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
          } catch (e) {
            console.log("call api error, use html to image", e);
            try {
              let imageSize = this.setSizeFrameImage();
              blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
            } catch (e) {
              console.log("call api error, use html to image", e);
            }
          }

          if (!blob) {
            this.toastr.error(this.message.getMessage('messages.error_proccessing'));
            return;
          }

          const file = new File([blob], 'lastImage.png', {type: 'image/png'});
          this.fileUpload = file;
          this.fileUploadDefault = file;
        }

        if (this.document.isConfirmBCT && this.typeCertificate !== this.enumSignMethod.SIGN_USB_TOKEN) {
          this.anonymousSignService.createTimestampMoney(this.getBodyTimeStampMoney()).subscribe(
            res => {
              this.checkDisplayMessageError(res.code);
              this.blockUI.stop();
              if (res && !res.success) {
                if (res.code === ErrorCode.NotEnoughMoneyTimestamp)
                  this.openDialogOutOfMoneyOtp(this.message.getMessage('digital_certificate_management.out_of_money_timestamp'));
                else
                  this.toastr.error(res.message)
              } else {
                this.signTransactionId = res.data;
                this.onClickSignButton()
              }
            }
          )
        } else {
          this.blockUI.reset();
          this.blockUI.start('');
          if (this.document.isConfirmBCT) {
            this.anonymousSignService.createTimestampMoney(this.getBodyTimeStampMoney()).subscribe(
              res => {
                this.checkDisplayMessageError(res.code);
                this.blockUI.stop();
                if (res && !res.success) {
                  if (res.code === ErrorCode.NotEnoughMoneyTimestamp)
                    this.openDialogOutOfMoneyOtp(this.message.getMessage('digital_certificate_management.out_of_money_timestamp'));
                  else
                    this.toastr.error(res.message)
                } else {
                  this.signTransactionId = res.data;
                  this.onClickSignButton()
                }
              }
            )
          } else {
            this.blockUI.stop();
            this.onClickSignButton()
          }
        }
      }
    }
  }

  async processSignNoCertificate() {
    let isSuccess = true;
    const filePath = {};
    const mainContractAttachmentsNew = [];
    for await (const img of this.signProcessing) {
      if (this.isCancel) {
        isSuccess = false;
        break;
      }
      const sign = JSON.parse(JSON.stringify(this.sign));
      sign.position = JSON.stringify(img);
      const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === img.fileId);
      sign.path = file && file.path ? file.path : null;
      sign.oldPath = filePath[img.fileId] ? filePath[img.fileId] : '';
      sign.image = this.fileUpload;

      let res;

      if (this.indexSelect === 0 && (this.isDisplaySignatureTab(1) || (this.isSignDigitalCertificate && !this.isShowImage)) && this.fileUpload) {
        const newDate = await this.signDocumentService.getDateAsync().toPromise();
        const email = await this.signDocumentService.getEmailAnonymousAsync(this.hashKey).toPromise();
        if (!newDate || !newDate.data || !newDate.data.date) {
          return;
        }

        this.signConfig.signingTime.value = newDate.data.date;
        this.signConfig.email.value = email.data;

        this.cd.detectChanges();

        sign.image = this.fileUpload;

        res = await this.anonymousSignService.signWithImageNoCertificateBase64(sign);

        if (res && !res.success) {
          isSuccess = false;
          this.signError = res && res.message ? res.message : null;
          break;
        } else if (!res || !res.data) {
          isSuccess = false;
          break;
        } else {
          filePath[img.fileId] = res.data.path;
          const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
          if (!contractAttachment) {
            const contractAttachmentNew = JSON.parse(JSON.stringify(file));
            contractAttachmentNew.path = res.data.path;
            mainContractAttachmentsNew.push(contractAttachmentNew);
          } else {
            contractAttachment.path = res.data.path;
          }
          if (!this.isCancel) {
            img.done = true;
          }
        }
      } else {
        res = await this.anonymousSignService.signWithImageNoCertificateBase64(sign);
        if (res && !res.success) {
          isSuccess = false;
          this.signError = res && res.message ? res.message : null;
          break;
        }
        if (!res || !res.data) {
          isSuccess = false;
          break;
        } else {
          filePath[img.fileId] = res.data.path;
          const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
          if (!contractAttachment) {
            const contractAttachmentNew = JSON.parse(JSON.stringify(file));
            contractAttachmentNew.path = res.data.path;
            mainContractAttachmentsNew.push(contractAttachmentNew);
          } else {
            contractAttachment.path = res.data.path;
          }
          if (!this.isCancel) {
            img.done = true;
          }
        }
      }
    }
    if (this.isCancel) {
      isSuccess = false;
    }
    let data = {};
    if (!this.showCheckVerifySubject && this.checkPersonalVerify) {
      data = {
        signMethod: this.typeCertificate,
        contractId: this.document.id,
        mainContractAttachments: mainContractAttachmentsNew,
        certificate: this.sign.certificate,
        hashKey: this.hashKey,
        tenantId: this.tenantId,
        signTransactionId: this.signTransactionId,
        userCancel: this.userCancel,
        message: this.noteControl.value,
        isVerifySubject: true
      };
    } else {
      data = {
        signMethod: this.typeCertificate,
        contractId: this.document.id,
        mainContractAttachments: mainContractAttachmentsNew,
        certificate: this.sign.certificate,
        hashKey: this.hashKey,
        tenantId: this.tenantId,
        signTransactionId: this.signTransactionId,
        userCancel: this.userCancel,
        message: this.noteControl.value,
      };
    }
    if (isSuccess) {
      this.isCallDone = true;
      const res = await this.anonymousSignService.signDone(data).toPromise();
      if (res && res.data) {
        this.onSignSuccess();
      } else {
        this.isCallDone = false;
      }
    } else {
      this.anonymousSignService.signCancel(data, this.contractIdAndContractEnterpriseIdEncode).subscribe(rs => {
        this.checkDisplayMessageError(rs.code);
        this.errorStatus = "messages.stop_sign_document";
      });
    }
  }

  async processSignSimCAImage() {
    const id = this.commonService.generateUUID();
    this.processingId = id;
    const sign = JSON.parse(JSON.stringify(this.sign));
    sign.signTransactionCode = this.commonService.generateUUID();
    sign.signPositions = JSON.stringify(this.signProcessing);
    sign.image = this.fileUpload;
    sign.message = this.noteControl.value;

    this.getApiSignImageSystem(this.anonymousSignService.anonymousSignSimCaImageBase64, sign, this.contractIdAndContractEnterpriseIdEncode)
    this.signingProcess(sign.signTransactionCode)
  }

  async processSignCloudCA() {
    let isSuccess = true;
    const filePath = {};
    const mainContractAttachmentsNew = [];
    const _data = [];
    const hashMap = {};
    let id = 0;
    const processingId = this.commonService.generateUUID();
    this.processingId = processingId;
    let signPositions: any[] = []
    for (const item of this.signProcessing) {
      const fileId = item.fileId;
      if (fileId in hashMap) {
        hashMap[fileId].push({
          ...item
        })
      } else {
        hashMap[fileId] = [{
          ...item
        }]
      }
    }

    for (const key in hashMap) {
      _data.push({
        fileId: Number(key),
        listSignPosition: hashMap[key],
        ...this.sign
      })
    }
    // tìm số chữ ký nhiều nhất
    let maxSignPosition = 0;
    for (const item of _data) {
      if (item.listSignPosition.length > maxSignPosition) {
        maxSignPosition = item.listSignPosition.length
      }
    }
    // số vòng lặp bằng số position lớn nhất
    for (let i = 0; i < maxSignPosition; i++) {
      // lặp số lần bằng số file
      let request = [];
      for (const dataItem of _data) {
        if (dataItem.listSignPosition[i]) {
          const position = dataItem.listSignPosition[i];

          let requestItem = {
            ...this.sign,
            fileId: dataItem.fileId,
            position: position,
            image: null,
          };
          const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === dataItem.fileId);
          requestItem.path = file && file.path ? file.path : null;
          requestItem.oldPath = filePath[requestItem.fileId] ? filePath[requestItem.fileId] : '';
          signPositions.push(requestItem);
        }
      }
    }
    let newRequest: any;
    if (!this.showCheckVerifySubject && this.checkPersonalVerify) {
      newRequest = {
        ...this.sign,
        providerName: this.providerName,
        credentialId: this.sign.credentialId,
        cloudCaUserId: this.cloudCaUsername,
        listSignPosition: signPositions,
        signTransactionCode: this.commonService.generateUUID(),
        message: this.noteControl.value,
        isVerifySubject: true
      };
    } else {
      newRequest = {
        ...this.sign,
        providerName: this.providerName,
        credentialId: this.sign.credentialId,
        cloudCaUserId: this.cloudCaUsername,
        listSignPosition: signPositions,
        signTransactionCode: this.commonService.generateUUID(),
        message: this.noteControl.value
      };
    }
    if (this.fileUpload) {
      let imageRequest: any
      if (!this.showCheckVerifySubject && this.checkPersonalVerify) {
        imageRequest = {
          ...this.sign,
          providerName: this.providerName,
          credentialId: this.sign.credentialId,
          cloudCaUserId: this.cloudCaUsername,
          image: this.fileUpload,
          signTransactionCode: this.commonService.generateUUID(),
          listSignPosition: JSON.stringify(signPositions),
          message: this.noteControl.value,
          isVerifySubject: true
        }
      } else {
        imageRequest = {
          ...this.sign,
          providerName: this.providerName,
          credentialId: this.sign.credentialId,
          cloudCaUserId: this.cloudCaUsername,
          image: this.fileUpload,
          signTransactionCode: this.commonService.generateUUID(),
          listSignPosition: JSON.stringify(signPositions),
          message: this.noteControl.value,
        }
      }
      this.getApiSignImageSystem(this.anonymousSignService.signCloudCaImageBase64, imageRequest, this.contractIdAndContractEnterpriseIdEncode);
      this.signingProcess(imageRequest.signTransactionCode)
    } else {
      this.anonymousSignService.signCloudCaNoImage(newRequest, this.contractIdAndContractEnterpriseIdEncode).subscribe(res => {

        if (res && res.code === ErrorCode.NoAuthenToAccess) {
          // 0x102009
          this.isError = true;
          this.dialog.closeAll();
          this.toastr.error(this.message.getMessage(res.message), "", {
            timeOut: 10000
          });
          this.blockUI.stop()
        } else {
          this.checkDisplayMessageError(res.code, res.message);
        }

      })
      this.signingProcess(newRequest.signTransactionCode)
    }
  }

  async processSignSimCANoImage() {
    const id = this.commonService.generateUUID();
    this.processingId = id;
    const sign = JSON.parse(JSON.stringify(this.sign));
    sign.signTransactionCode = this.commonService.generateUUID();
    sign.signPositions = JSON.stringify(this.signProcessing);
    sign.message = this.noteControl.value;
    if (!this.showCheckVerifySubject && this.checkPersonalVerify) {
      sign.isVerifySubject = true
    }

    this.anonymousSignService.anonymousSignSimCaNoImage(sign, this.contractIdAndContractEnterpriseIdEncode).subscribe(res => {
      this.checkDisplayMessageError(res.code);
    })
    this.signingProcess(sign.signTransactionCode)
  }

  async processSignVNeID() {
    let isSuccess = true;
    const filePath = {};
    const mainContractAttachmentsNew = [];
    const _data = [];
    const hashMap = {};
    let id = 0;
    const processingId = this.commonService.generateUUID();
    this.processingId = processingId;
    let signPositions: any[] = []
    for (const item of this.signProcessing) {
      const fileId = item.fileId;
      if (fileId in hashMap) {
        hashMap[fileId].push({
          ...item
        })
      } else {
        hashMap[fileId] = [{
          ...item
        }]
      }
    }

    for (const key in hashMap) {
      _data.push({
        fileId: Number(key),
        listSignPosition: hashMap[key],
        ...this.sign
      })
    }
    // tìm số chữ ký nhiều nhất
    let maxSignPosition = 0;
    for (const item of _data) {
      if (item.listSignPosition.length > maxSignPosition) {
        maxSignPosition = item.listSignPosition.length
      }
    }
    // số vòng lặp bằng số position lớn nhất
    for (let i = 0; i < maxSignPosition; i++) {
      // lặp số lần bằng số file
      let request = [];
      for (const dataItem of _data) {
        if (dataItem.listSignPosition[i]) {
          const position = dataItem.listSignPosition[i];

          let requestItem = {
            ...this.sign,
            fileId: dataItem.fileId,
            position: position,
            image: null,
          };
          const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === dataItem.fileId);
          requestItem.path = file && file.path ? file.path : null;
          requestItem.oldPath = filePath[requestItem.fileId] ? filePath[requestItem.fileId] : '';
          signPositions.push(requestItem);
        }
      }
    }
    let newRequest: any;
    if (!this.showCheckVerifySubject && this.checkPersonalVerify) {
      newRequest = {
        ...this.sign,
        providerName: this.providerName,
        credentialId: this.sign.credentialId,
        citizenPid: this.VNeIDDataUser,
        listSignPosition: signPositions,
        signTransactionCode: this.commonService.generateUUID(),
        message: this.noteControl.value,
        isVerifySubject: true
      };
    } else {
      newRequest = {
        ...this.sign,
        providerName: this.providerName,
        credentialId: this.sign.credentialId,
        citizenPid: this.VNeIDDataUser,
        listSignPosition: signPositions,
        signTransactionCode: this.commonService.generateUUID(),
        message: this.noteControl.value
      };
    }
    if (this.fileUpload) {
      let imageRequest: any
      if (!this.showCheckVerifySubject && this.checkPersonalVerify) {
        imageRequest = {
          ...this.sign,
          providerName: this.providerName,
          credentialId: this.sign.credentialId,
          citizenPid: this.VNeIDDataUser,
          image: this.fileUpload,
          signTransactionCode: this.commonService.generateUUID(),
          listSignPosition: JSON.stringify(signPositions),
          message: this.noteControl.value,
          isVerifySubject: true
        }
      } else {
        imageRequest = {
          ...this.sign,
          providerName: this.providerName,
          credentialId: this.sign.credentialId,
          citizenPid: this.VNeIDDataUser,
          image: this.fileUpload,
          signTransactionCode: this.commonService.generateUUID(),
          listSignPosition: JSON.stringify(signPositions),
          message: this.noteControl.value,
        }
      }
      this.getApiSignImageSystem(this.anonymousSignService.signVNeIDBase64, imageRequest, this.contractIdAndContractEnterpriseIdEncode);
      this.signingProcess(this.VNeIDTransactionCode)
    }
  }


  /**
   * Fix race condition: khi hiển thị tab mặc định (reset/show tab) mà nzSelectChange
   * không được gọi (vd chỉ có 1 tab, hoặc chọn chứng thư), activeImageSource vẫn giữ
   * giá trị cũ ('default') dẫn đến gửi nhầm ảnh. Helper này suy ra tab đang hiển thị
   * từ các cờ UI đã được set bởi khối if/else tương ứng rồi đồng bộ activeImageSource.
   */
  syncActiveTab() {
    if (this.isUploadImage) {
      this.activeImageSource = 'upload';
    } else if (this.isSelectDrawImage) {
      this.activeImageSource = 'draw';
    } else {
      this.activeImageSource = 'default';
    }
  }

  /**
   * Fix race condition: đồng bộ ảnh từ tab đang hoạt động vào fileUpload trước khi gửi ký.
   * Tránh việc ảnh từ tab khác ghi đè fileUpload khi user chuyển tab.
   */
  syncActiveTabImage() {
    if (this.activeImageSource === 'default' && this.fileUploadDefault) {
      this.fileUpload = this.fileUploadDefault;
    } else if (this.activeImageSource === 'upload' && this.fileUploadUpload) {
      this.fileUpload = this.fileUploadUpload;
    } else if (this.activeImageSource === 'draw' && this.fileUploadDraw) {
      this.fileUpload = this.fileUploadDraw;
    }
  }

  onClickConfirmButtonNoImage() {
    this.syncActiveTabImage();
    switch (this.typeCertificate) {
      case this.enumSignMethod.SIGN_USB_TOKEN:
        this.createHash(this.usbTokenCertificate.certRawdata);
        break;
      case this.enumSignMethod.SIGN_SIM_CA:
        this.isCallDone = false;
        this.processSignSimCANoImage();
        break;
      case this.enumSignMethod.SIGN_NO_CERT:
        this.processSignNoCertificate();
        break;
      case this.enumSignMethod.CLOUD_CA:
        this.processSignCloudCA();
        break;
      case this.enumSignMethod.VNEID:
        this.processSignVNeID();
        break;
      default:
        break;
    }
  }

  onClickConfirmButtonImage() {
    this.syncActiveTabImage();
    switch (this.typeCertificate) {
      case this.enumSignMethod.SIGN_USB_TOKEN:
        this.createHash(this.usbTokenCertificate.certRawdata);
        break;
      case this.enumSignMethod.SIGN_SIM_CA:
        this.isCallDone = false;
        this.processSignSimCAImage();
        break;
      case this.enumSignMethod.SIGN_NO_CERT:
        this.processSignNoCertificate();
        break;
      case this.enumSignMethod.CLOUD_CA:
        this.processSignCloudCA();
        break;
      case this.enumSignMethod.VNEID:
        this.processSignVNeID();
        break;
      default:
        break;
    }
  }

  async createHashSvc(certUserBase64: string) {
    this.sign.certificate = certUserBase64;
    if (this.fileUpload) {
      const filePath = {};
      let isSuccess = true;
      const mainContractAttachmentsNew = [];
      for await (const [index, img] of this.signProcessing.entries()) {
        if (this.isCancel) {
          isSuccess = false;
          break;
        }
        const sign = JSON.parse(JSON.stringify(this.sign));
        sign.image = this.fileUpload;
        sign.position = JSON.stringify(img);
        const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === img.fileId);
        sign.path = file && file.path ? file.path : null;
        sign.oldPath = filePath[img.fileId] ? filePath[img.fileId] : '';
        if (!this.showCheckVerifySubject && this.checkPersonalVerify) {
          sign.isVerifySubject = true
        }
        let rs;
        if (this.indexSelect === 0 && (this.isDisplaySignatureTab(1) || (this.isSignDigitalCertificate && !this.isShowImage)) && this.fileUpload) {
          const newDate = await this.signDocumentService.getDateAsync().toPromise();
          const email = await this.signDocumentService.getEmailAnonymousAsync(this.hashKey).toPromise();
          if (!newDate || !newDate.data || !newDate.data.date) {
            return;
          }

          this.signConfig.signingTime.value = newDate.data.date;
          this.signConfig.email.value = email.data;

          this.cd.detectChanges();

          sign.image = this.fileUpload;

          rs = await this.anonymousSignService.createHashWithImageBase64(sign, this.contractIdAndContractEnterpriseIdEncode);

          if (this.contractIdAndContractEnterpriseIdEncode) {
            this.checkExpireTime();
          }

          if (rs && !rs.success) {
            isSuccess = false;
            this.signError = rs && rs.message ? rs.message : null;
          } else if (rs && rs.data) {
            sign.path = rs.data.path;
            sign.signPdf = rs.data.signPdf;
            filePath[img.fileId] = rs.data.path;
            const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
            if (!contractAttachment) {
              const contractAttachmentNew = JSON.parse(JSON.stringify(file));
              contractAttachmentNew.path = rs.data.path;
              mainContractAttachmentsNew.push(contractAttachmentNew);
            } else {
              contractAttachment.path = rs.data.path;
            }
            const signature = await anonymousSignHashAsyncNew(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber);
            if (!signature) {
              this.errorStatus = 'messages.error_not_find_certificate';
              isSuccess = false;
              break;
            }
            if (index === 0) {
              this.isCallDone = false;
            }
            sign.signature = signature;
            sign.position = JSON.parse(sign.position);
            sign.signPositions = this.signImages;
            // usb-token không cần ảnh chân ký → bỏ hẳn ra khỏi payload JSON
            // (tránh Jackson không deserialize được MultipartFile từ @RequestBody)
            delete sign.image;
            const resSign = await this.signUsb(sign, this.contractIdAndContractEnterpriseIdEncode);
            if (this.contractIdAndContractEnterpriseIdEncode) {
              this.checkExpireTime();
            }
            if (resSign && !resSign.success) {
              this.signError = resSign && resSign.message ? resSign.message : null;
              isSuccess = false;
              break;
            }
            if (!resSign || !resSign.data) {
              isSuccess = false;
              break;
            }
            if (!this.isCancel) {
              img.done = true;
            }
          } else {
            isSuccess = false;
            break;
          }
        } else {
          rs = await this.anonymousSignService.createHashWithImageBase64(sign, this.contractIdAndContractEnterpriseIdEncode);
          if (this.contractIdAndContractEnterpriseIdEncode) {
            this.checkExpireTime();
          }

          if (rs && !rs.success) {
            isSuccess = false;
            this.signError = rs && rs.message ? rs.message : null;
            break;
          }
          if (rs && rs.data) {
            sign.path = rs.data.path;
            sign.signPdf = rs.data.signPdf;
            filePath[img.fileId] = rs.data.path;
            const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
            if (!contractAttachment) {
              const contractAttachmentNew = JSON.parse(JSON.stringify(file));
              contractAttachmentNew.path = rs.data.path;
              mainContractAttachmentsNew.push(contractAttachmentNew);
            } else {
              contractAttachment.path = rs.data.path;
            }
            const signature = await anonymousSignHashAsyncNew(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber);
            if (!signature) {
              this.errorStatus = 'messages.error_not_find_certificate';
              isSuccess = false;
              break;
            }
            if (index === 0) {
              this.isCallDone = false;
            }
            sign.signature = signature;
            sign.position = JSON.parse(sign.position);
            sign.signPositions = this.signImages;
            // usb-token không cần ảnh chân ký → bỏ hẳn ra khỏi payload JSON
            // (tránh Jackson không deserialize được MultipartFile từ @RequestBody)
            delete sign.image;
            const resSign = await this.signUsb(sign, this.contractIdAndContractEnterpriseIdEncode);
            if (this.contractIdAndContractEnterpriseIdEncode) {
              this.checkExpireTime();
            }
            if (resSign && !resSign.success) {
              this.signError = resSign && resSign.message ? resSign.message : null;
              isSuccess = false;
              break;
            }
            if (!resSign || !resSign.data) {
              isSuccess = false;
              break;
            }
            if (!this.isCancel) {
              img.done = true;
            }
          } else {
            isSuccess = false;
            break;
          }
        }
      }
      if (this.isCancel) {
        isSuccess = false;
      }

      let data = {};
      if (!this.showCheckVerifySubject && this.checkPersonalVerify) {
        data = {
          signMethod: this.typeCertificate,
          contractId: this.document.id,
          mainContractAttachments: mainContractAttachmentsNew,
          certificate: this.sign.certificate,
          hashKey: this.hashKey,
          tenantId: this.tenantId,
          signTransactionId: this.signTransactionId,
          userCancel: this.userCancel,
          message: this.noteControl.value,
          isVerifySubject: true
        };
      } else {
        data = {
          signMethod: this.typeCertificate,
          contractId: this.document.id,
          mainContractAttachments: mainContractAttachmentsNew,
          certificate: this.sign.certificate,
          hashKey: this.hashKey,
          tenantId: this.tenantId,
          signTransactionId: this.signTransactionId,
          userCancel: this.userCancel,
          message: this.noteControl.value,

        };
      }
      if (isSuccess) {
        this.isCallDone = true;
        const res = await this.anonymousSignService.signDone(data).toPromise();
        if (res && res.data) {
          this.onSignSuccess();
        } else {
          this.isCallDone = false;
        }
      } else {
        this.anonymousSignService.signCancel(data, this.contractIdAndContractEnterpriseIdEncode).subscribe(rs => {
          this.errorStatus = "messages.stop_sign_document";
        });
      }
    } else {
      const filePath = {};
      let isSuccess = true;
      const mainContractAttachmentsNew = [];
      for await (const [index, img] of this.signProcessing.entries()) {
        if (this.isCancel) {
          isSuccess = false;
          break;
        }
        const sign = JSON.parse(JSON.stringify(this.sign));
        sign.position = JSON.stringify(img);
        const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === img.fileId);
        sign.path = file && file.path ? file.path : null;
        sign.oldPath = filePath[img.fileId] ? filePath[img.fileId] : '';
        const rs = await this.anonymousSignService.createHashNoImage(sign, this.contractIdAndContractEnterpriseIdEncode).toPromise();
        if (this.contractIdAndContractEnterpriseIdEncode) {
          this.checkExpireTime();
        }
        if (rs && !rs.success) {
          isSuccess = false;
          this.signError = rs && rs.message ? rs.message : null;
          break;
        }
        if (rs && rs.data) {
          sign.path = rs.data.path;
          sign.signPdf = rs.data.signPdf;
          filePath[img.fileId] = rs.data.path;
          const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
          if (!contractAttachment) {
            const contractAttachmentNew = JSON.parse(JSON.stringify(file));
            contractAttachmentNew.path = rs.data.path;
            mainContractAttachmentsNew.push(contractAttachmentNew);
          } else {
            contractAttachment.path = rs.data.path;
          }
          const signature = await anonymousSignHashAsyncNew(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber);
          if (!signature) {
            this.errorStatus = 'messages.error_not_find_certificate';
            isSuccess = false;
            break;
          }
          if (index === 0) {
            this.isCallDone = false;
          }
          sign.signature = signature;
          sign.position = JSON.parse(sign.position);
          sign.signPositions = this.signImages;
          // usb-token không cần ảnh chân ký → bỏ hẳn ra khỏi payload JSON
          delete sign.image;
          if (!this.showCheckVerifySubject && this.checkPersonalVerify) {
            sign.isVerifySubject = true;
          }
          const resSign = await this.signUsb(sign, this.contractIdAndContractEnterpriseIdEncode);
          if (this.contractIdAndContractEnterpriseIdEncode) {
            this.checkExpireTime();
          }
          if (resSign && !resSign.success) {
            isSuccess = false;
            this.signError = resSign && resSign.message ? resSign.message : null;
            break;
          }
          if (!resSign || !resSign.data) {
            isSuccess = false;
            break;
          }
          if (!this.isCancel) {
            img.done = true;
          }
        } else {
          isSuccess = false;
          break;
        }
      }
      if (this.isCancel) {
        isSuccess = false;
      }
      let data = {};
      if (!this.showCheckVerifySubject && this.checkPersonalVerify) {
        data = {
          signMethod: this.typeCertificate,
          contractId: this.document.id,
          mainContractAttachments: mainContractAttachmentsNew,
          certificate: this.sign.certificate,
          hashKey: this.hashKey,
          tenantId: this.tenantId,
          signTransactionId: this.signTransactionId,
          userCancel: this.userCancel,
          message: this.noteControl.value,
          isVerifySubject: true
        }
      } else {
        data = {
          signMethod: this.typeCertificate,
          contractId: this.document.id,
          mainContractAttachments: mainContractAttachmentsNew,
          certificate: this.sign.certificate,
          hashKey: this.hashKey,
          tenantId: this.tenantId,
          signTransactionId: this.signTransactionId,
          userCancel: this.userCancel,
          message: this.noteControl.value,
        }
      }

      if (isSuccess) {
        this.isCallDone = true;
        const res = await this.anonymousSignService.signDone(data).toPromise();
        if (res && res.data) {
          this.onSignSuccess();
        } else {
          this.isCallDone = false;
        }
      } else {
        this.anonymousSignService.signCancel(data, this.contractIdAndContractEnterpriseIdEncode).subscribe(rs => {
          this.errorStatus = "messages.stop_sign_document";
        });
      }
    }
  }


  private onSignFail(message) {
    this.blockUI.stop();
    if (this.hashKey && this.tenantId) {
      const dialogRe = this.dialog.open(ConfirmFailComponent, {
        width: '350px',
        data: {
          message: message ? message : (this.message.getMessage('kyc.fail_title') + ', ' + this.message.getMessage('kyc.fail_title_2')),
          hashKey: this.hashKey,
          tenantId: this.tenantId,
          hashLink: this.contractIdAndContractEnterpriseIdEncode
        }
      });
      dialogRe.afterClosed().subscribe(rs => {
        dialogRe.close();
      });
    } else {
      const dialogRe = this.dialog.open(ConfirmFailComponent, {
        width: '350px',
        data: {
          message: message ? message : (this.message.getMessage('kyc.fail_title') + ', ' + this.message.getMessage('kyc.fail_title_2')),
        }
      });
      dialogRe.afterClosed().subscribe(rs => {
        dialogRe.close();
      });
    }
  }

  async createHash(certUserBase64: string) {
    this.sign.certificate = certUserBase64;
    if (this.fileUpload) {
      const filePath = {};
      let isSuccess = true;
      const mainContractAttachmentsNew = [];
      const fileArr = new Set(this.signProcessing.map($ => $.fileId));
      for await (const [idx, fileId] of fileArr.entries()) {
        if (this.isCancel) {
          isSuccess = false;
          break;
        }
        const sign = JSON.parse(JSON.stringify(this.sign));
        const _dst$ = this.signProcessing.filter($ => $.fileId == fileId)
        sign.image = this.fileUpload;
        sign.position = JSON.stringify(_dst$[0]);
        sign.signPositions = _dst$;
        const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === fileId);
        sign.path = file && file.path ? file.path : null;
        sign.oldPath = filePath[fileId] ? filePath[fileId] : '';
        if (!this.showCheckVerifySubject && this.checkPersonalVerify) {
          sign.isVerifySubject = true;
        }


        let rs;
        if (this.indexSelect === 0 && (this.isDisplaySignatureTab(1) || (this.isSignDigitalCertificate && !this.isShowImage)) && this.fileUpload) {
          const newDate = await this.signDocumentService.getDateAsync().toPromise();
          const email = await this.signDocumentService.getEmailAnonymousAsync(this.hashKey).toPromise();
          if (!newDate || !newDate.data || !newDate.data.date) {
            return;
          }

          this.signConfig.signingTime.value = newDate.data.date;
          this.signConfig.email.value = email.data;

          this.cd.detectChanges();

          sign.image = this.fileUpload;

          rs = await this.anonymousSignService.createHashWithImageBase64(sign, this.contractIdAndContractEnterpriseIdEncode);

          if (this.contractIdAndContractEnterpriseIdEncode) {
            this.checkExpireTime();
          }

          if (rs && !rs.success) {
            isSuccess = false;
            this.signError = rs && rs.message ? rs.message : null;
          } else if (rs && rs.data) {
            sign.path = rs.data.path;
            sign.signPdf = rs.data.signPdf;
            filePath[fileId] = rs.data.path;
            const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
            if (!contractAttachment) {
              const contractAttachmentNew = JSON.parse(JSON.stringify(file));
              contractAttachmentNew.path = rs.data.path;
              mainContractAttachmentsNew.push(contractAttachmentNew);
            } else {
              contractAttachment.path = rs.data.path;
            }
            const signature = await anonymousSignHashAsyncNew(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber);
            if (!signature) {
              this.errorStatus = 'messages.error_not_find_certificate';
              isSuccess = false;
              break;
            }
            if (idx === 0) {
              this.isCallDone = false;
            }
            sign.signature = signature;
            sign.position = JSON.parse(sign.position);
            sign.signPositions = this.signImages;
            // usb-token không cần ảnh chân ký → bỏ hẳn ra khỏi payload JSON
            // (tránh Jackson không deserialize được MultipartFile từ @RequestBody)
            delete sign.image;
            const resSign = await this.signUsb(sign, this.contractIdAndContractEnterpriseIdEncode);
            if (this.contractIdAndContractEnterpriseIdEncode) {
              this.checkExpireTime();
            }
            if (resSign && !resSign.success) {
              this.signError = resSign && resSign.message ? resSign.message : null;
              isSuccess = false;
              break;
            }
            if (!resSign || !resSign.data) {
              isSuccess = false;
              break;
            }
            if (!this.isCancel) {
              _dst$.forEach($ => $.done = true);
            }
          } else {
            isSuccess = false;
            break;
          }
        } else {
          rs = await this.anonymousSignService.createHashWithImageBase64(sign, this.contractIdAndContractEnterpriseIdEncode);
          if (this.contractIdAndContractEnterpriseIdEncode) {
            this.checkExpireTime();
          }

          if (rs && !rs.success) {
            isSuccess = false;
            this.signError = rs && rs.message ? rs.message : null;
            break;
          }
          if (rs && rs.data) {
            sign.path = rs.data.path;
            sign.signPdf = rs.data.signPdf;
            filePath[fileId] = rs.data.path;
            const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
            if (!contractAttachment) {
              const contractAttachmentNew = JSON.parse(JSON.stringify(file));
              contractAttachmentNew.path = rs.data.path;
              mainContractAttachmentsNew.push(contractAttachmentNew);
            } else {
              contractAttachment.path = rs.data.path;
            }
            const signature = await anonymousSignHashAsyncNew(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber);
            if (!signature) {
              this.errorStatus = 'messages.error_not_find_certificate';
              isSuccess = false;
              break;
            }
            if (idx === 0) {
              this.isCallDone = false;
            }
            sign.signature = signature;
            sign.position = JSON.parse(sign.position);
            sign.signPositions = this.signImages;
            // usb-token không cần ảnh chân ký → bỏ hẳn ra khỏi payload JSON
            // (tránh Jackson không deserialize được MultipartFile từ @RequestBody)
            delete sign.image;
            const resSign = await this.signUsb(sign, this.contractIdAndContractEnterpriseIdEncode);
            if (this.contractIdAndContractEnterpriseIdEncode) {
              this.checkExpireTime();
            }
            if (resSign && !resSign.success) {
              this.signError = resSign && resSign.message ? resSign.message : null;
              isSuccess = false;
              break;
            }
            if (!resSign || !resSign.data) {
              isSuccess = false;
              break;
            }
            if (!this.isCancel) {
              _dst$.forEach($ => $.done = true);
            }
          } else {
            isSuccess = false;
            break;
          }
        }
      }
      if (this.isCancel) {
        isSuccess = false;
      }
      let data = {}
      if (!this.showCheckVerifySubject && this.checkPersonalVerify) {
        data = {
          signMethod: this.typeCertificate,
          contractId: this.document.id,
          mainContractAttachments: mainContractAttachmentsNew,
          certificate: this.sign.certificate,
          hashKey: this.hashKey,
          tenantId: this.tenantId,
          signTransactionId: this.signTransactionId,
          userCancel: this.userCancel,
          message: this.noteControl.value,
          isVerifySubject: true
        };
      } else {
        data = {
          signMethod: this.typeCertificate,
          contractId: this.document.id,
          mainContractAttachments: mainContractAttachmentsNew,
          certificate: this.sign.certificate,
          hashKey: this.hashKey,
          tenantId: this.tenantId,
          signTransactionId: this.signTransactionId,
          userCancel: this.userCancel,
          message: this.noteControl.value,
        };
      }
      if (isSuccess) {
        this.isCallDone = true;
        const res = await this.anonymousSignService.signDone(data).toPromise();
        if (res && res.data) {
          this.onSignSuccess();
        } else {
          this.isCallDone = false;
        }
      } else {
        this.anonymousSignService.signCancel(data, this.contractIdAndContractEnterpriseIdEncode).subscribe(rs => {
          this.errorStatus = "messages.stop_sign_document";
        });
      }
    } else {
      const filePath = {};
      let isSuccess = true;
      const mainContractAttachmentsNew = [];
      const fileArr = new Set(this.signProcessing.map($ => $.fileId));
      for await (const [idx, fileId] of fileArr.entries()) {
        if (this.isCancel) {
          isSuccess = false;
          break;
        }
        const sign = JSON.parse(JSON.stringify(this.sign));
        const _dst$ = this.signProcessing.filter($ => $.fileId == fileId);
        sign.position = JSON.stringify(_dst$[0]);
        sign.signPositions = _dst$;
        const file = this.document.mainContractAttachments.find(ca => this.decodeId(ca.id) === fileId);
        sign.path = file && file.path ? file.path : null;
        sign.oldPath = filePath[fileId] ? filePath[fileId] : '';
        if (!this.showCheckVerifySubject && this.checkPersonalVerify) {
          sign.isVerifySubject = true;
        }
        const rs = await this.anonymousSignService.createHashNoImage(sign, this.contractIdAndContractEnterpriseIdEncode).toPromise();
        if (this.contractIdAndContractEnterpriseIdEncode) {
          this.checkExpireTime();
        }
        if (rs && !rs.success) {
          isSuccess = false;
          this.signError = rs && rs.message ? rs.message : null;
          break;
        }
        if (rs && rs.data) {
          sign.path = rs.data.path;
          sign.signPdf = rs.data.signPdf;
          filePath[fileId] = rs.data.path;
          const contractAttachment = mainContractAttachmentsNew.find(ca => ca.id === file.id);
          if (!contractAttachment) {
            const contractAttachmentNew = JSON.parse(JSON.stringify(file));
            contractAttachmentNew.path = rs.data.path;
            mainContractAttachmentsNew.push(contractAttachmentNew);
          } else {
            contractAttachment.path = rs.data.path;
          }
          const signature = await anonymousSignHashAsyncNew(this, rs.data.hash, this.sessionId, this.usbTokenCertificate.serialNumber);
          if (!signature) {
            this.errorStatus = 'messages.error_not_find_certificate';
            isSuccess = false;
            break;
          }
          if (idx === 0) {
            this.isCallDone = false;
          }
          sign.signature = signature;
          sign.position = JSON.parse(sign.position);
          sign.signPositions = this.signImages;
          // usb-token không cần ảnh chân ký → bỏ hẳn ra khỏi payload JSON
          delete sign.image;
          const resSign = await this.signUsb(sign, this.contractIdAndContractEnterpriseIdEncode);
          if (this.contractIdAndContractEnterpriseIdEncode) {
            this.checkExpireTime();
          }
          if (resSign && !resSign.success) {
            isSuccess = false;
            this.signError = resSign && resSign.message ? resSign.message : null;
            break;
          }
          if (!resSign || !resSign.data) {
            isSuccess = false;
            break;
          }
          if (!this.isCancel) {
            _dst$.forEach($ => $.done = true);
          }
        } else {
          isSuccess = false;
          break;
        }
      }
      if (this.isCancel) {
        isSuccess = false;
      }
      let data = {};
      if (!this.showCheckVerifySubject && this.checkPersonalVerify) {
        data = {
          signMethod: this.typeCertificate,
          contractId: this.document.id,
          mainContractAttachments: mainContractAttachmentsNew,
          certificate: this.sign.certificate,
          hashKey: this.hashKey,
          tenantId: this.tenantId,
          signTransactionId: this.signTransactionId,
          userCancel: this.userCancel,
          message: this.noteControl.value,
          isVerifySubject: true
        }
      } else {
        data = {
          signMethod: this.typeCertificate,
          contractId: this.document.id,
          mainContractAttachments: mainContractAttachmentsNew,
          certificate: this.sign.certificate,
          hashKey: this.hashKey,
          tenantId: this.tenantId,
          signTransactionId: this.signTransactionId,
          userCancel: this.userCancel,
          message: this.noteControl.value,

        }
      }
      if (isSuccess) {
        this.isCallDone = true;
        const res = await this.anonymousSignService.signDone(data).toPromise();
        if (res && res.data) {
          this.onSignSuccess();
        } else {
          this.isCallDone = false;
        }
      } else {
        this.anonymousSignService.signCancel(data, this.contractIdAndContractEnterpriseIdEncode).subscribe(rs => {
          this.errorStatus = "messages.stop_sign_document";
        });
      }
    }
  }

  validateIsVerifySubject() {
    const customerDTO = JSON.parse(localStorage.getItem('customerDTOXMCT'));
    // check simCA hoặc Usb token
    if (this.typeCertificate === this.signMethod.SIGN_SIM_CA
      || this.typeCertificate === this.signMethod.SIGN_USB_TOKEN
      || this.typeCertificate === this.enumSignMethod.VNEID
      || this.typeCertificate === this.signMethod.SIGN_CLOUD_CA) {
      let selectedCACertficateNo = '';
      let selectedCAName = '';
      if (this.typeCertificate === this.signMethod.SIGN_SIM_CA || this.typeCertificate === this.signMethod.SIGN_CLOUD_CA) {
        selectedCACertficateNo = this.selectedCert.taxCode;
        selectedCAName = this.selectedCert.certificateName;
      } else if(this.typeCertificate === this.enumSignMethod.VNEID){
        selectedCACertficateNo = this.selectedCert.identifier;
        selectedCAName = this.selectedCert.subjectDN;
      } else {
        const taxCode = this.usbTokenCertificate.taxCode;
        selectedCACertficateNo = this.decodeTaxCode(taxCode);
        selectedCAName = this.usbTokenCertificate.issuedTo;
      }
      if (customerDTO != null) {
        // check mã số thuế
        // check name
        if (selectedCACertficateNo.length > 0 &&
          (selectedCACertficateNo.toUpperCase() === customerDTO.certificateNo.toUpperCase() ||
            (customerDTO.representDocumentNumber && selectedCACertficateNo.toUpperCase() === customerDTO.representDocumentNumber.toUpperCase()) ||
            (customerDTO.taxCode && selectedCACertficateNo.toUpperCase() === customerDTO.taxCode.toUpperCase()))) {
          return true;
        } else {
          this.toastr.error(this.message.getMessage('messages.digital_certificate_validate_taxCode'));
          return false;
        }
      }
    }
  }

  onClickNavigateSignFlow(tmpl) {
    switch (this.typeCertificate) {
      case this.signMethod.SIGN_USB_TOKEN:
        this.validateHashForSign(this.usbTokenCertificate.certRawdata, this.usbTokenCertificate.serialNumber, tmpl);
        break;
      case this.signMethod.SIGN_SIM_CA:
        this.validateSimCANoImageForSign(tmpl);
        break;
      case this.signMethod.SIGN_CLOUD_CA:
        this.validateCloudCAForSign(tmpl);
        break;
      case this.signMethod.SIGN_OTP:
        this.validateOTPForSign(tmpl);
        break;
      case this.signMethod.VNEID:
        this.validateVNeId(tmpl);
        break;
      default:
        break;
    }
  }

  validateHashForSign(certUserBase64: string, serialNumber: string, tmpl) {
    this.signXMCT = {
      listSignPosition: this.imageData,
      phoneNumber: this.digitalCertificateService.formatPhoneNumber(this.simCaPhoneNumber),
      ...this.selectedCert
    };
    this.signXMCT.certificate = certUserBase64;
    this.signXMCT.serialNumber = serialNumber;
    this.signXMCT.tenantId = this.tenantId;
    this.signXMCT.type = this.signMethod.SIGN_USB_TOKEN;
    this.signXMCT.contractAndContractEnterpriseIdHash = this.contractIdAndContractEnterpriseIdEncode;
    const position = JSON.parse(localStorage.getItem('SignPosition'));
    if (this.tempEnterprise) {
      this.signXMCT = {
        ...this.signXMCT,
        enterpriseUpdateInfoDTO: this.tempEnterprise,
      };
    }
    const params = {
      dataVerifyUSB: this.signXMCT,
      type: this.signMethod.SIGN_USB_TOKEN
    }
    this.kycService.verifySubject(params).subscribe(rs => {
      if (rs.code == 200) {
        this.checkTimestampMoney(tmpl);
      } else {
        this.toastr.error(this.message.getMessage(rs.message));
      }

    }, error => {
      this.toastr.error(this.message.getMessage(error.error.message));
    });

  }

  validateSimCANoImageForSign(tmpl) {
    this.blockUI.start('');
    const mainContractAttachmentsNew = [];
    const processingId = this.commonService.generateUUID();
    this.processingId = processingId;
    this.signXMCT = {
      listSignPosition: this.imageData,
      phoneNumber: this.digitalCertificateService.formatPhoneNumber(this.simCaPhoneNumber),
      ...this.selectedCert
    };

    const data = {
      // hashKey: this.hashKey,
      // tenantId: this.tenantId,
      // signMethod: this.typeCertificate,
      // mainContractAttachments: mainContractAttachmentsNew,
      // type: this.signMethod.SIGN_SIM_CA,
      // contractAndContractEnterpriseIdHash: this.contractIdAndContractEnterpriseIdEncode,
      // serialNumber: this.selectedCert.serialNumber,
      // providerName: this.providerName,
      // credentialId: this.signXMCT.credentialId,
      // cloudCaUserId: this.cloudCaUsername,
      // listSignPosition: this.imageData, //
      // certificate: this.signXMCT.certificate,
      // lan 4
      listSignPosition: this.signXMCT.listSignPosition,
      tenantId: this.tenantId,
      contractAndContractEnterpriseIdHash: this.contractIdAndContractEnterpriseIdEncode,
      phoneNumber: this.signXMCT.phoneNumber,
      id: this.signXMCT.id,
      certificateName: this.signXMCT.certificateName,
      serialNumber: this.signXMCT.serialNumber,
      taxCode: this.signXMCT.taxCode,
      activeDate: this.signXMCT.expireDate,
      expireDate: this.signXMCT.activeDate,
      isUsed: this.signXMCT.isUsed,
      isExtend: this.signXMCT.isExtend,
      certificates: this.signXMCT.certificates,
      STT: this.signXMCT.STT,
      type: this.signMethod.SIGN_SIM_CA,
      checked: this.signXMCT.checked,
    };
    const params = {
      dataVerifySimCa: data,
      type: this.signMethod.SIGN_SIM_CA
    }
    this.kycService.verifySubject(params).subscribe(rs => {
      if (rs.success) {
        this.checkTimestampMoney(tmpl);
      } else {
        this.onSignFail(rs.message);
      }
    }, error => {
      console.log(error);
    });
  }

  validateCloudCAForSign(tmpl) {
    this.blockUI.start('');
    const mainContractAttachmentsNew = [];
    const processingId = this.commonService.generateUUID();
    this.processingId = processingId;
    this.signXMCT = {
      listSignPosition: this.imageData,
      phoneNumber: this.digitalCertificateService.formatPhoneNumber(this.simCaPhoneNumber),
      ...this.selectedCert
    };

    const data = {
      hashKey: this.hashKey,
      tenantId: this.tenantId,
      signMethod: this.typeCertificate,
      mainContractAttachments: mainContractAttachmentsNew,
      type: 10,
      contractAndContractEnterpriseIdHash: this.contractIdAndContractEnterpriseIdEncode,
      serialNumber: this.selectedCert.serialNumber,
      providerName: this.providerName,
      credentialId: this.signXMCT.credentialId,
      cloudCaUserId: this.cloudCaUsername,
      listSignPosition: this.imageData
    };
    const params = {
      dataVerifyCloudCa: data,
      type: 10
    }
    this.kycService.verifySubject(params).subscribe(rs => {
      if (rs.success) {
        this.checkTimestampMoney(tmpl);
      } else {
        this.onSignFail(rs.message);
      }
    }, error => {
      console.log(error);
    });
  }

  validateOTPForSign(tmpl) {
    this.blockUI.start('');
    const data = {
      tenantId: this.tenantId,
      hashKey: this.hashKey,
      hashLink: this.contractIdAndContractEnterpriseIdEncode,
      phoneNumber: this.otpPhoneNumber,
      isPublicSign: true,
      isVerifySubject: true
    };
    this.kycService.verifySignOTP(data).subscribe(rs => {
      this.blockUI.stop();
      if (rs.code == 200) {
        this.checkTimestampMoney(tmpl);
      } else {
        this.toastr.error(rs.message);
        // this.onSignFail(rs.message);
      }
    }, error => {
      console.log(error);
    });
  }

  validateVNeId(tmpl) {
    this.blockUI.start('');
    const mainContractAttachmentsNew = [];
    const processingId = this.commonService.generateUUID();
    this.processingId = processingId;
    this.signXMCT = {
      listSignPosition: this.imageData,
      ...this.selectedCert
    };

    const data = {
      hashKey: this.hashKey,
      tenantId: this.tenantId,
      signMethod: this.typeCertificate,
      mainContractAttachments: mainContractAttachmentsNew,
      type: 12,
      contractAndContractEnterpriseIdHash: this.contractIdAndContractEnterpriseIdEncode,
      serialNumber: this.selectedCert.serialNumber,
      credentialId: this.signXMCT.credentialId,
      citizenPid: this.VNeIDDataUser,
      listSignPosition: this.imageData,
      issueDN: this.selectedCert.issueDN
    };
    const params = {
      dataVerifyVneid: data,
      type: 12
    }
    this.kycService.verifySubject(params).subscribe(rs => {
      if (rs.success) {
        this.checkTimestampMoney(tmpl);
      } else {
        this.onSignFail(rs.message);
      }
    }, error => {
      console.log(error);
    });
  }

  async signUsb(certificate: any, hashLink?: string) {
    if (this.isSignDigitalCertificate) {
      if (certificate.image) {
        delete certificate.image;
      }
    }
    const res = await this.anonymousSignService.signUsb(certificate, hashLink).toPromise();
    return res;
  }

  private onSignSuccess() {
    if (this.isSetUpSignFlow) {
      this.toastr.success(this.message.getMessage('messages.approve_sucess'));
    } else {
      this.toastr.success(this.message.getMessage('messages.sign_success'));
    }
    this.success = true;
    this.dialog.closeAll();
    this.backToPrePage();
  }

  onClickSignButton() {
    if (this.document.isConfirmBCT) {
      this.signImages = this.signImages.map((item) => {
        item['signTransactionId'] = this.signTransactionId;
        return item;
      })
    }
    this.signProcessing = JSON.parse(JSON.stringify(this.signImages));

    // Fix race condition: đồng bộ ảnh của tab đang hoạt động trước khi ký để payload luôn dùng đúng ảnh của tab hiện tại
    this.syncActiveTabImage();

    if (this.typeCertificate !== this.enumSignMethod.SIGN_OTP) {
      const dialog = this.dialog.open(SigningDialogComponent, {
        width: '80%',
        disableClose: true,
        data: this
      });
      dialog.afterClosed().subscribe(() => {
        this.signProcessing = [];
        this.errorStatus = null;
        this.signError = null;
        this.isCancel = false;
        this.isCallDone = false;
        this.dialog.closeAll();
      });
    }

    if (!this.isShowImage || !this.isSignDigitalCertificate) {
      if (this.systemImageSign && this.isDisplaySignatureTab(1)) {
        if (this.fileUpload) {
          this.onClickConfirmButtonImage();
        }
      } else {
        const imageDataBlob = this.commonService.b64toBlob(this.imageUrlPreview.split(',')[1]);
        const blobUrl = URL.createObjectURL(imageDataBlob);
        fetch(blobUrl)
          .then(response => response.blob())
          .then(blob => {
            this.fileUpload = new File([blob], 'fileNameGoesHere', {type: 'image/png'});
            if (this.fileUpload) {
              this.onClickConfirmButtonImage();
            }
          })
          .catch(error => {
            console.error('Lỗi khi đọc tệp ảnh', error);
          });
      }

    } else {
      if (!this.fileUpload) {
        this.onClickConfirmButtonNoImage();
      } else {
        this.onClickConfirmButtonImage();
      }
    }
  }

  async processSignOTP() {
    if (!this.showCheckVerifySubject && this.checkPersonalVerify) {
      this.sign = {
        ...this.selectedCert,
        hashKey: this.hashKey,
        tenantId: this.tenantId,
        phoneNumber: this.simCaPhoneNumber,
        contractId: this.document.id,
        isVerifySubject: true
      };
    } else {
      this.sign = {
        ...this.selectedCert,
        hashKey: this.hashKey,
        tenantId: this.tenantId,
        phoneNumber: this.simCaPhoneNumber,
        contractId: this.document.id,
      };
    }
    if (this.typeCertificate === this.enumSignMethod.SIGN_OTP) {
      this.sign.phoneNumber = this.otpPhoneNumber;
    }
    let signMethod = this.typeCertificate;
    if (this.isShowEKYC) {
      if (this.ekycSupportConfig === 1) {
        signMethod = this.enumSignMethod.SIGN_OTP_EKYC;
      } else if (this.ekycSupportConfig === 2) {
        signMethod = this.enumSignMethod.SIGN_OTP_EKYC_ADVANCED;
      }
    }
    let request = {
      signMethod: signMethod,
      signPositions: this.signImages
    }

    // tạo lại ảnh ký với giờ hiện tại, nếu lỗi thì không cho ký
    if (this.systemImageSign && this.fileUpload) {
      const date = await this.signDocumentService.getDateAsync().toPromise();
      const email = await this.signDocumentService.getEmailAnonymousAsync(this.hashKey).toPromise();

      this.signConfig.signingTime.value = date.data.date;
      this.signConfig.email.value = email.data;
      let blob = null;
      try {
        let imageSize = this.setSizeFrameImage();
        blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
      } catch (e) {
        console.log("call api error, use html to image", e);
        try {
          let imageSize = this.setSizeFrameImage();
          blob = await this.imageGenerateService.genImage(this.signConfig, imageSize).toPromise();
        } catch (e) {
          console.log("call api error, use html to image", e);
        }
      }

      if (!blob) {
        this.toastr.error(this.message.getMessage('messages.error_proccessing'));
        return;
      }

      const file = new File([blob], 'lastImage.png', {type: 'image/png'});
      this.fileUpload = file;
      this.fileUploadDefault = file;
    }

    this.anonymousSignService.generateTransaction(this.hashKey, this.otpPhoneNumber, this.tenantId, request, this.contractIdAndContractEnterpriseIdEncode).subscribe(rs => {
      this.checkDisplayMessageError(rs.code);
      if (!rs.success) {
        if (rs.code === ErrorCode.OutOfMoneyOtp) {
          this.openDialogOutOfMoneyOtp(this.message.getMessage('messages.otp_out_of_money'));
        } else if (rs.code === ErrorCode.OutOfMoneyOtpNew) {
          this.openDialogOutOfMoneyOtp(this.message.getMessage('messages.otp_out_of_money_new'));
        } else {
          this.toastr.error(rs.message);
        }
      } else {
        this.openDialogConfirmSignOTP(rs.data);
      }
    });
  }

  openDialogOutOfMoneyOtp(message) {
    const confirmDialog = this.dialog.open(NotifyWarningComponent, {
      data: message
    });
    confirmDialog.afterClosed().subscribe(() => {

    });
  }

  openDialogConfirmSignOTP(transactionId: string) {
    let signMethod = this.typeCertificate;
    if (this.isShowEKYC) {
      if (this.ekycSupportConfig === 1) {
        signMethod = EnumSignMethod.SIGN_OTP_EKYC;
      } else if (this.ekycSupportConfig === 2) {
        signMethod = EnumSignMethod.SIGN_OTP_EKYC_ADVANCED;
      }
    }
    let request = {
      signMethod: signMethod,
      signPositions: this.signImages
    }

    const dataCancel = {
      signMethod: this.typeCertificate,
      contractId: this.document.id,
      mainContractAttachments: [],
      certificate: this.sign.certificate,
      hashKey: this.hashKey,
      tenantId: this.tenantId,
      phoneNumber: this.simCaPhoneNumber,
      serialNumber: this.selectedCert.serialNumber,
      transactionId: transactionId,
      userCancel: true,
    };
    this.dialogRef = this.dialog.open(ConfirmSignOtpWithImageComponent, {
      width: '40%',
      data: {
        documentId: this.sign.contractId,
        transaction: transactionId,
        selectedPhone: this.otpPhoneNumber,
        listSignPosition: JSON.stringify(this.imageData),
        image: this.fileUpload,
        anonymousOtp: true,
        hashKey: this.hashKey,
        tenantId: this.tenantId,
        function: this.processSignOTPAfterDialogClose.bind(this),
        supportEkyc: this.supportEkyc,
        request: request,
        signingInteval: this.signingInteval,
        openSigningDialog: this.openSigningDialog,
        dataCancel: dataCancel,
        hashLink: this.contractIdAndContractEnterpriseIdEncode
      }
    });

    this.dialogRef.afterClosed().subscribe((ref) => {
      if (ref && this.typeCertificate != 3) {
        const dialog = this.dialog.open(SigningDialogComponent, {
          width: '80%',
          disableClose: true,
          data: this
        });
        dialog.afterClosed().subscribe(() => {
          this.signProcessing = [];
          this.errorStatus = null;
          this.signError = null;
          this.isCancel = false;
          this.isCallDone = false;
          this.dialog.closeAll();
        });
      }
    });
  }

  signCancel() {
    this.imageData = this.contractSignEntityList;
    const dialog = this.dialog.open(WarningComponent, {
      width: '40%',
      data: this.message.getMessage('sign_processing_dialog.message_stop_sign')
    });
    dialog.afterClosed().subscribe(ref => {
      if (ref) {
        this.isCancel = true;
        this.userCancel = true;
        this.documentService.setCancelFlow(true);
        let data = {};
        if (!this.showCheckVerifySubject && this.checkPersonalVerify) {
          data = {
            signMethod: this.typeCertificate,
            contractId: this.document.id,
            mainContractAttachments: [],
            certificate: this.sign.certificate,
            hashKey: this.hashKey,
            tenantId: this.tenantId,
            signTransactionId: this.signTransactionId,
            userCancel: this.userCancel,
            isVerifySubject: true
          };
        } else {
          data = {
            signMethod: this.typeCertificate,
            contractId: this.document.id,
            mainContractAttachments: [],
            certificate: this.sign.certificate,
            hashKey: this.hashKey,
            tenantId: this.tenantId,
            signTransactionId: this.signTransactionId,
            userCancel: this.userCancel,
          };
        }
        this.anonymousSignService.signCancel(data, this.contractIdAndContractEnterpriseIdEncode).subscribe(rs => {
          this.userCancel = false;
          this.errorStatus = "messages.stop_sign_document";
        });
      }
    })
  }

  async processSignOTPAfterDialogClose(signDialog: any, dialog: any, focusInput: any) {
    this.blockUI.reset();
    this.blockUI.start('');
    let signMethod = this.typeCertificate;
    if (this.isShowEKYC) {
      if (this.ekycSupportConfig === 1) {
        signMethod = EnumSignMethod.SIGN_OTP_EKYC;
      } else if (this.ekycSupportConfig === 2) {
        signMethod = EnumSignMethod.SIGN_OTP_EKYC_ADVANCED;
      }
    }
    const sign = JSON.parse(JSON.stringify(this.sign));

    sign.signTransactionCode = this.commonService.generateUUID();
    sign.otp = signDialog.otp;
    sign.anonymousOtp = false;
    sign.transactionId = signDialog.transactionId;
    sign.contractId = signDialog.contractId;
    sign.signMethod = signMethod;
    sign.signPositions = JSON.stringify(this.signProcessing);
    sign.message = this.noteControl.value;
    if (!this.showCheckVerifySubject && this.checkPersonalVerify) {
      sign.isVerifySubject = true
    }


    if (this.contractIdAndContractEnterpriseIdEncode) {
      this.anonymousSignService.checkExpireTime(this.hashKey, this.tenantId, this.contractIdAndContractEnterpriseIdEncode).subscribe(res => {
        this.checkDisplayMessageError(res.code);
        if (!this.isError) {
          if (this.fileUpload) {
            sign.image = this.fileUpload;
            this.getApiSignImageSystem(this.anonymousSignService.signOtpWithImageBase64, sign, this.contractIdAndContractEnterpriseIdEncode);
          } else {
            this.anonymousSignService.signOtpNoImage(sign, this.contractIdAndContractEnterpriseIdEncode).toPromise().catch(err => {
              this.errorStatus = this.message.getMessage('messages.sign_fail');

            });
          }
          this.signingProcess(sign.signTransactionCode, dialog, focusInput);
        }
      });
    } else {
      if (this.fileUpload) {
        sign.image = this.fileUpload;
        this.getApiSignImageSystem(this.anonymousSignService.signOtpWithImageBase64, sign);
      } else {
        this.anonymousSignService.signOtpNoImage(sign).toPromise().catch(err => {
          this.errorStatus = this.message.getMessage('messages.sign_fail');
        });
      }
      this.signingProcess(sign.signTransactionCode, dialog, focusInput);
    }

  }

  signingProcess(signTransactionCode, dialog?: any, focusInput?: any) {
    clearInterval(this.signingInteval);
    setTimeout(() => {
      this.signingInteval = setInterval(() => {
        let request = {
          signTransactionCode: signTransactionCode,
          tenantId: this.tenantId,
          hashKey: this.hashKey
        }
        if(this.typeCertificate == EnumSignMethod.VNEID){
          request.signTransactionCode = this.VNeIDTransactionCode
        }
        this.anonymousSignService.getStatusSign(request).subscribe(rs => {
          if (rs && rs.success && (rs.data.status == 'DONE' || rs.data.status == 'DAEMON_PROCESSING')) {
            this.isCallDone = true;
            this.signDocumentService.openSigningDialog.next(true);
            clearInterval(this.signingInteval);
            this.onSignSuccess();
            this.blockUI.stop();
            dialog.close(true);
          } else if (rs && rs.success && rs.data.status !== 'ERROR') {
            let arrayStatus = {};
            if (!this.openSigningDialog && this.typeCertificate === this.enumSignMethod.SIGN_OTP && rs.data.list[0].status == 'DONE') {
              this.signDocumentService.openSigningDialog.next(true);
              this.blockUI.stop();
              dialog.close(true);
            }
            for (let i = 0; i < rs.data.list.length; i++) {
              arrayStatus[rs.data.list[i].code] = rs.data.list[i].status;
            }
            for (let i = 0; i < this.signProcessing.length; i++) {
              this.signProcessing[i].done = arrayStatus[this.signProcessing[i].code] == 'DONE' ? true : false
            }
          } else if (rs.data && rs.data.status === 'ERROR') {
            if (!this.openSigningDialog && this.typeCertificate === this.enumSignMethod.SIGN_OTP) {
              this.toastr.error(rs.data.message)
              this.blockUI.stop();
              focusInput();
            } else {
              this.signDocumentService.openSigningDialog.next(false);
              this.errorStatus = "messages.stop_sign_document";
              this.signError = rs && rs.data.message ? rs.data.message : null;
            }
            clearInterval(this.signingInteval);
          }
        })
      }, 10000)
    }, 10000);
  }

  checkDisplayMessageError(code, message?) {
    if (code && code === ErrorCode.NoAccessToContracts) {
      this.isError = true;
      //this.router.navigate([`/error`]);
      window.location.href = 'error';
      this.dialogRef.close();
    } else if (code && code === ErrorCode.NoAuthenToAccess) {
      // 0x102009
      this.isError = true;
      this.toastr.error(this.message.getMessage(message), "", {
        timeOut: 10000
      });
      this.dialogRef.close();
    } else if (code && code === ErrorCode.ContractExpireTime) {
      this.isError = true;
      //this.router.navigate([`/expire`]);
      window.location.href = 'expire';
      this.dialogRef.close();
    } else {
      this.isError = false;
    }
  }

  checkExpireTime() {
    this.anonymousSignService.checkExpireTime(this.hashKey, this.tenantId, this.contractIdAndContractEnterpriseIdEncode).subscribe(res => {
      this.checkDisplayMessageError(res.code);
    });
  }

  getApiSignImageSystem(api: any, ...body) {
    if (this.indexSelect === 0 && (this.isDisplaySignatureTab(1) || (this.isSignDigitalCertificate && !this.isShowImage)) && this.fileUpload) {

      // bỏ chỗ gọi api lấy date vì gọi bên ngoài rồi
      setTimeout(async () => {
        body[0].image = this.fileUpload;

        this.invokeSignApi(api, ...body);

      }, 300);

    } else {
      this.invokeSignApi(api, ...body);
    }
  }

  // hàm cũ trả Observable, hàm Base64 trả Promise — gọi thống nhất ở đây
  invokeSignApi(api: any, ...body: any[]) {
    const handleResult = (res) => {
      if (res && res.code === ErrorCode.NoAuthenToAccess) {
        // 0x102009
        this.isError = true;
        this.dialog.closeAll();
        this.toastr.error(this.message.getMessage(res.message), "", {
          timeOut: 10000
        });
      } else {
        if(this.typeCertificate === EnumSignMethod.VNEID){
          this.VNeIDTransactionCode = res.data
        }
        this.checkDisplayMessageError(res.code, res.message);
      }
    };
    const handleError = () => {
      this.errorStatus = this.message.getMessage('messages.sign_fail');
    };
    const rs = api(...body);
    if (rs && typeof rs.subscribe === 'function') {
      rs.subscribe(handleResult);
    } else {
      rs.then(handleResult).catch(handleError);
    }
  }

  checkDisabledBtnSign(): boolean {
    if (this.isSignDigitalCertificate && !this.isShowImage) {
      if (this.typeCertificate !== this.enumSignMethod.SIGN_OTP && !this.selectedCert.serialNumber) {
        return true;
      }
      if (!this.checkAgree) {
        return true;
      }
    } else {
      if (this.isSelectedPosition.getValue()) {
        return true;
      }
      if (this.isDisableSignBtn) {
        return true;
      }
      if (!this.imageUrlPreview) {
        return true;
      }
      // tab vẽ chữ ký: chặn ký khi nét vẽ mới chưa được Áp dụng
      if (this.isSelectDrawImage && !this.canvasService.isApplyDrawSignatureValue) {
        return true;
      }
      if (this.typeCertificate !== this.enumSignMethod.SIGN_OTP && !this.selectedCert.serialNumber) {
        return true;
      }
      if (!this.checkAgree) {
        return true;
      }
    }
    if ((this.checkPersonalVerify) && (!this.isSignDigitalCertificate || this.isSignDigitalCertificate) && (!this.showCheckVerifySubject)) {
      if (!this.checkVerify) {
        return true;
      }
    }
    return false;
  }


  // end fn group sign

  // start fn group EKYC
  openDialogSignEKYC(tmpl: TemplateRef<any>) {
    this.templateRefEKYC = tmpl;
    this.dialog.open(tmpl, {
      width: '80%',
      panelClass: 'ekyc-dialog',
    });
  }

  getQuantityEkycBeforeNext(): Observable<boolean> {
    this.blockUI.start('');
    return this.anonymousSignService.getQuantityEkyc(this.document.id, this.hashKey, this.tenantId)
      .pipe(map((res) => {
        let isNext = false;
        this.blockUI.stop();
        if (res.success === true && res.data) {
          if (this.ekycSupportConfig == 1 && res.data.quantityEkyc) isNext = true; //normal
          if (this.ekycSupportConfig == 2 && res.data.quantityAdvancedEkyc) isNext = true; //Advance
        } else {
          this.toastr.error(this.message.getMessage(res.message));
        }
        return isNext
      }))
  }

  async loadServiceType() {
    if (this.serviceTypeData && this.serviceTypeData.allowOtp) {
      this.allowOtp = this.serviceTypeData.allowOtp
    }

    if (this.serviceTypeData) {
      this.supportEkyc = !!Number(this.serviceTypeData.ekycSupportConfig);
      this.ekycSupportConfig = this.serviceTypeData.ekycSupportConfig;
      if (this.supportEkyc) {
        await this.getQuantityEkyc();
      }
    }
  }

  async getQuantityEkyc() {
    if (!this.document.id) return of(null);
    const res = await this.anonymousSignService.getQuantityEkyc(this.document.id, this.hashKey, this.tenantId).toPromise()
    if (res.success === true && res.data) {
      if (this.ekycSupportConfig == 1 && res.data.quantityEkyc) this.isStillQuantityEkyc = true; //normal
      if (this.ekycSupportConfig == 2 && res.data.quantityAdvancedEkyc) this.isStillQuantityEkyc = true; //Advance
      if (res.data.quantityEkyc) this.isQuantityEkyc = true;
      if (res.data.quantityAdvancedEkyc) this.isQuantityAdvancedEkyc = true;
    } else {
      this.toastr.error(this.message.getMessage(res.message));
    }
  }

  private onIdentityEKYC() {
    const dataImg = this.ekyc.getDataImage();
    if (!dataImg) return;
    let body = {
      typeImage: dataImg.typeImage,
      contractId: this.sign.contractId,
      images: dataImg.images.map(image => {
        return {base64Image: image.base64Image, type: image.type}
      })
    }

    if (this.typeCertificate === this.enumSignMethod.SIGN_OTP || this.typeCertificate === this.enumSignMethod.SIGN_NO_CERT) {
      this.validateEKYCOtp(body);
    }
  }

  private validateEKYCOtp(body: any): void {
    this.blockUI.start('');
    this.anonymousSignService.valiadateEkycOtpSupport(body, this.hashKey, this.tenantId)
      .subscribe(res => {
        this.blockUI.stop();
        if (res && res.success) {
          if (this.typeCertificate === this.enumSignMethod.SIGN_OTP) {
            this.processSignOTP();
          } else if (this.typeCertificate === this.enumSignMethod.SIGN_NO_CERT) {
            this.processSignNoCertificate();
          }
        } else {
          if (res && !res.success) {
            let dialogRef;
            if (res.code === "0x002413")
              dialogRef = this.dialog.open(ConfirmResignEkycSupportComponent, {
                width: '350px',
                data: {message: this.message.getMessage('messages.sign_fail_ekyc'),}
              });
            else
              dialogRef = this.dialog.open(ConfirmResignEkycSupportComponent, {
                width: '350px',
                data: {message: this.message.getMessage('messages.confirm_resign_ekyc'),}
              });
            dialogRef.afterClosed().subscribe(rs => {
              if (rs) {
                setTimeout(() => {
                  this.openDialogSignEKYC(this.templateRefEKYC);
                }, 10);
              } else {
                if (this.contractIdAndContractEnterpriseIdEncode) {
                  if (this.isSignDigitalCertificate) {
                    this.router.navigate(['/approval/success']);
                  } else
                    this.router.navigate([`sign-anonymous/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}/detail`], {});
                } else {
                  if (this.isSignDigitalCertificate) {
                    this.router.navigate(['/approval/success']);
                  } else
                    this.router.navigate([`/sign-anonymous/${this.hashKey}/${this.tenantId}/detail`], {});
                }
              }
              this.dialog.closeAll();
            })
          }
        }
      })
  }

  // end fn group EKYC

  onCloseDialog() {
    this.dialog.closeAll();
  }

  // start mixed fn
  focusoutNoteControl() {
    this.noteControl.patchValue(this.noteControl.value.trim());
  }

  removeNoteControl() {
    this.noteControl.patchValue('');
  }

  setLanguage() {
    this.commonService.getCurrentLanguage().subscribe(lang => {
      if (lang !== this.language) {
        location.reload();
      }
    });
  }

  decodeTaxCode(taxCode: string): string {
    const arrs = taxCode.split(",");
    for (let element of arrs) {
      if (element.trim().startsWith("MST") || element.trim().startsWith("CMND") || element.trim().startsWith("CCCD")) {
        return element.split(":")[1];
      }
    }
    return "";
  }

  decodeId(id: string) {
    const idDecode = atob(id);
    const findNumber = idDecode.match(/[0-9]{1,}/g);
    if (findNumber && findNumber.length) {
      return Number(findNumber[findNumber.length - 1]);
    }
    return null;
  }

  handlePreviewFromFileUpload(fileUpload: File, isCertificateDefault?: boolean) {
    this.commonService.getBase64(fileUpload)
      // tslint:disable-next-line:no-shadowed-variable
      .then((imageUrlPreviewBlod) => {
        this.imageUrlPreview = imageUrlPreviewBlod;
        if (isCertificateDefault) {
          this.avatarUrl = this.imageUrlPreview;
        }
        const img = new Image();
        img.src = this.imageUrlPreview;
        img.onload = () => {
          this.widthImageRender = img.width;
          this.heightImageRender = img.height;
          if (this.indexSelect === (this.isDisplaySignatureTab(1) ? 1 : 0) && this.isDisplaySignatureTab(2)) {
            this.imagePreviewWidth = img.width;
            this.imagePreviewHeight = img.height;
          }
        }
        this.documentService.setImageSignature({
          url: this.imageUrlPreview,
          fileUpload: this.fileUpload
        });
      });
  }

  public blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    // A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    // Cast to a File() type
    return theBlob as File;
  };

  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], {type});
    if (window.top.navigator.msSaveOrOpenBlob) {
      // Store Blob in IE
      window.top.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // Store Blob in others
      const tA = document.body.appendChild(document.createElement('a'));
      tA.href = URL.createObjectURL(blob);
      tA.download = fileName;
      tA.style.display = 'none';
      tA.click();
      tA.parentNode.removeChild(tA);
    }
  }

  backToPrePage(data?) {
    if (this.contractIdAndContractEnterpriseIdEncode) {
      if (this.isSignDigitalCertificate && !data) {
        if (this.isSetUpSignFlow) {
          localStorage.removeItem('isSetUpSignFlow')
          this.router.navigate([`sign-anonymous/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}/detail`]);
        } else {
          this.router.navigate(['/approval/success']);
        }
      } else
        this.router.navigate([`sign-anonymous/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}/detail`]);
    } else {
      if (this.isSignDigitalCertificate && !data) {
        this.router.navigate(['/approval/success']);
      } else
        this.router.navigate([`/sign-anonymous/${this.hashKey}/${this.tenantId}/detail`]);
    }
  }

  disableGetCertifcate: boolean = false;
  onNumberInput() {
    if (!this.VNeIDDataUser) {
      return;
    }

    this.disableGetCertifcate = false;
  }

  blockNonNumber(event: KeyboardEvent) {
    if (event.ctrlKey || event.metaKey) {
      const ctrlAllowed = ['a', 'c', 'v', 'x', 'z'];
      if (ctrlAllowed.includes(event.key.toLowerCase())) {
        return;
      }
    }
    const allowedKeys = [
      'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'
    ];
    
    if (allowedKeys.includes(event.key)) {
      return; 
    }
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  blockNonNumberPaste(event: ClipboardEvent) {
    const pasted = event.clipboardData.getData('text') || '';
    if (!/^[0-9]+$/.test(pasted)) {
      event.preventDefault(); // chặn dán nếu có ký tự không phải số
    }
  }

  // end mixed fn

  transformContentPositionValue = transformContentPositionValue;

  // --------------------- END FUNCTION --------------------------

  ngOnDestroy(): void {
    this.documentService.setImageSignature(null);
    this.canvasService.setCanvasSignatureImageUrl('');
    this.canvasService.setCanvasSignatureImage(null);
    this.subscribeMediaBreakPointService.unsubscribe();
    this.subcribeViewLandscape.unsubscribe();
    this.domRenderImage = null;
    this.fileUpload = null;
    this.fileUploadDefault = null;
    this.fileUploadUpload = null;
    this.fileUploadDraw = null;
    this.activeImageSource = 'default';
    this.systemImageSign = false;
    this.imageUrlPreview = null;
    this.document = null;
    this.pdfSrc = null;
  }

  hasDefaultImageConfigs: boolean = false;
  hasSignConfigs: boolean = false;
  applyDefaultTypeConfig(){
    if(this.hasSignConfigs && !this.hasDefaultImageConfigs && !this.hasSavedUserConfig
      && !this.isBuyService && this.entTypeAnonymus == '2'){
      // TH2: DN không tick thành phần nào -> suggest 3 thành phần: Tên chủ thể + Dấu tích xanh + Địa chỉ
      this.signConfig.enterpriseName.enabled = true;
      this.signConfig.greenTick.enabled = true;
      this.signConfig.address.enabled = true;
      this.convertHtmlToImage();
      return;
    }
    if(this.hasDefaultImageConfigs && this.hasSignConfigs){
      for (const key in this.defaultImageConfigs) {
        const conf = this.defaultImageConfigs[key];
        // TH1c: thành phần mặc định+bắt buộc luôn bật sẵn (KH không được bỏ tick, chỉ bổ sung giá trị)
        this.signConfig[key].enabled = conf.isDefault
          ? (this.signConfig[key].value ? true : ((conf.isRequire || key === 'greenTick') ? true : false))
          : false;
      }
      // Chữ ký bật sẵn nhưng chưa có vị trí -> set mặc định "trái" như khi KH tự tick
      // (onCheckboxSignatureImageChange), nếu không khung preview không có kích thước
      if (this.signConfig.signatureImage.enabled && !this.signConfig.signaturePosition.value) {
        this.signConfig.signaturePosition.value = 'left';
        if (!this.signConfig.signatureRatio.value) {
          this.signConfig.signatureRatio.value = '30:70';
        }
      }
      this.signConfigPhoneNumber = this.defaultImageConfigs.phoneNumber.isDefault;
      this.convertHtmlToImage()
    }
  }
  checkErrorConfigDefault(): boolean {
    if(this.hasDefaultImageConfigs && this.indexSelect === 0 && this.isDisplaySignatureTab(1) && ((this.isSignDigitalCertificate && this.isShowImage) || !this.isSignDigitalCertificate)){
      let errorList = [];
      for (const key in this.defaultImageConfigs) {
        if(this.defaultImageConfigs[key].isRequire && !this.signConfig[key].enabled && !(this.selectedCert.typeCertificate !== this.signMethod.SIGN_OTP && key === 'phoneNumber')){
          errorList.push(key)
          this.toastr.error(this.message.getMessage('config_default_image.required_error').replace('{0}', this.getName(key)));
        }
        // TH1c: thành phần bắt buộc đã bật nhưng chưa có giá trị (Địa chỉ/Chức vụ rỗng, Chữ ký chưa up/vẽ)
        else if(this.defaultImageConfigs[key].isRequire && this.signConfig[key].enabled
          && (key === 'address' || key === 'position' || key === 'signatureImage')){
          const isEmpty = key === 'signatureImage'
            ? !(this.signConfig.signatureImageBase64 && this.signConfig.signatureImageBase64.value)
            : !this.signConfig[key].value;
          if(isEmpty){
            errorList.push(key);
            if(key === 'signatureImage'){
              this.toastr.error(this.message.getMessage('config_default_image.signature_required'));
            } else {
              this.toastr.error(this.message.getMessage('config_default_image.required_error').replace('{0}', this.getName(key)));
            }
          }
        }
      }

      if(errorList.length > 0){
        return true;
      } else return false;
    }
    return false;
  }

  getName(signatureComponent: any){

    switch(signatureComponent){
      case 'enterpriseName':
        return this.message.getMessage('enterprise_contract.panel_document_view.table_signing_flow.detail_content.issued_to');
      case 'phoneNumber':
        return this.message.getMessage('headertable.phone');
      case 'signingTime':
        return this.message.getMessage('enterprise_contract.image_signing.no_image.signing_time');
      case 'address':
        return this.message.getMessage('headertable.address');
      case 'greenTick':
        return this.message.getMessage('enterprise_contract.image_signing.no_image.green_tick');
      case 'position':
        return this.message.getMessage('enterprise_contract.image_signing.no_image.position');
      case 'signatureImage':
        return this.message.getMessage('enterprise_contract.image_signing.no_image.signatureImage');
      case 'email':
        return this.message.getMessage('config_notification.email');
    }
  }
}
